(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.gg.a4 === region.e0.a4)
	{
		return 'on line ' + region.gg.a4;
	}
	return 'on lines ' + region.gg.a4 + ' through ' + region.e0.a4;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.fm,
		impl.gI,
		impl.dV,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		Q: func(record.Q),
		cl: record.cl,
		cc: record.cc
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.Q;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cl;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.cc) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.fm,
		impl.gI,
		impl.dV,
		function(sendToApp, initialModel) {
			var view = impl.gL;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.fm,
		impl.gI,
		impl.dV,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ci && impl.ci(sendToApp)
			var view = impl.gL;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.bR);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.gD) && (_VirtualDom_doc.title = title = doc.gD);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.fR;
	var onUrlRequest = impl.fS;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ci: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.dy === next.dy
							&& curr.c0 === next.c0
							&& curr.ds.a === next.ds.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		fm: function(flags)
		{
			return A3(impl.fm, flags, _Browser_getUrl(), key);
		},
		gL: impl.gL,
		gI: impl.gI,
		dV: impl.dV
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { fe: 'hidden', eG: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { fe: 'mozHidden', eG: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { fe: 'msHidden', eG: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { fe: 'webkitHidden', eG: 'webkitvisibilitychange' }
		: { fe: 'hidden', eG: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		dK: _Browser_getScene(),
		d3: {
			d8: _Browser_window.pageXOffset,
			gN: _Browser_window.pageYOffset,
			d4: _Browser_doc.documentElement.clientWidth,
			cY: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		d4: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		cY: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			dK: {
				d4: node.scrollWidth,
				cY: node.scrollHeight
			},
			d3: {
				d8: node.scrollLeft,
				gN: node.scrollTop,
				d4: node.clientWidth,
				cY: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			dK: _Browser_getScene(),
			d3: {
				d8: x,
				gN: y,
				d4: _Browser_doc.documentElement.clientWidth,
				cY: _Browser_doc.documentElement.clientHeight
			},
			e$: {
				d8: x + rect.left,
				gN: y + rect.top,
				d4: rect.width,
				cY: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.bV.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.bV.b, xhr)); });
		$elm$core$Maybe$isJust(request.cq) && _Http_track(router, xhr, request.cq.a);

		try {
			xhr.open(request.b7, request.gJ, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.gJ));
		}

		_Http_configureRequest(xhr, request);

		request.bR.a && xhr.setRequestHeader('Content-Type', request.bR.a);
		xhr.send(request.bR.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.bY; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.cp.a || 0;
	xhr.responseType = request.bV.d;
	xhr.withCredentials = request.el;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		gJ: xhr.responseURL,
		gh: xhr.status,
		gi: xhr.statusText,
		bY: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			f5: event.loaded,
			dP: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			fX: event.loaded,
			dP: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.fD) { flags += 'm'; }
	if (options.eF) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.eV))
		{
			lang = options.eV.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.fc.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.gn,
		breaks: gfm && gfm.eC,
		sanitize: options.f0,
		smartypants: options.gb
	};
}
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$LinkClicked = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Msg$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.q) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.t);
		} else {
			var treeLen = builder.q * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.u) : builder.u;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.q);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.t);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{u: nodeList, q: (len / $elm$core$Array$branchFactor) | 0, t: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {cV: fragment, c0: host, dp: path, ds: port_, dy: protocol, dA: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Msg$APIProfileResult = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Blank = {$: 0};
var $author$project$Data$User$CheckingProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$User$LoggedOut = {$: 0};
var $author$project$Pages$Authentication$LoggedOut = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Authentication$LoggedOutWith = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$LoginMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$TransitioningFrom = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Data$SearchSettings$TotalScore = 0;
var $author$project$Data$SearchSettings$WholePhrase = 0;
var $author$project$Data$SearchSettings$defaultSearchSettings = {b$: true, b0: false, cf: 0, ck: 0, cr: true};
var $author$project$Data$ViewSettings$defaultViewSettings = {bT: false, cm: false};
var $author$project$Data$Session$defaultSession = {cw: false, cB: _List_Nil, bq: _List_Nil, b4: _List_Nil, dN: $author$project$Data$SearchSettings$defaultSearchSettings, cg: _List_Nil, d$: $author$project$Data$User$LoggedOut, d2: $author$project$Data$ViewSettings$defaultViewSettings};
var $author$project$Data$APITypes$emptyUserPass = {a1: '', cb: ''};
var $author$project$Requests$Profile = {$: 5};
var $author$project$Data$APITypes$UserProfile = F5(
	function (userId, email, creationDate, subscriptions, sublevel) {
		return {cK: creationDate, a1: email, dS: sublevel, dV: subscriptions, d_: userId};
	});
var $author$project$Data$APITypes$Basic = 0;
var $author$project$Data$APITypes$Pro = 1;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Data$APITypes$decodeSubLevel = function (str) {
	switch (str) {
		case 'Basic':
			return $elm$json$Json$Decode$succeed(0);
		case 'Pro':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail(str + ' is not a valid SubLevel');
	}
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Data$APITypes$decodeUserProfile = A2(
	$elm$json$Json$Decode$field,
	'profile',
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Data$APITypes$UserProfile,
		A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'creationDate', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'subscriptions',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		A2(
			$elm$json$Json$Decode$andThen,
			$author$project$Data$APITypes$decodeSubLevel,
			A2($elm$json$Json$Decode$field, 'level', $elm$json$Json$Decode$string))));
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Requests$acceptHeader = A2($elm$http$Http$header, 'Accept', 'application/json');
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$APIServer$apiServerAddress = 'https://api.readtheregs.com/';
var $author$project$Requests$landingPageAddress = 'https://readtheregs.com/';
var $author$project$Requests$endPointToString = function (endpoint) {
	switch (endpoint.$) {
		case 0:
			return $author$project$APIServer$apiServerAddress + 'auth/page/email/login';
		case 1:
			return $author$project$Requests$landingPageAddress + 'auth/page/email/register';
		case 2:
			return $author$project$Requests$landingPageAddress + 'auth/page/email/forgot-password';
		case 3:
			return $author$project$Requests$landingPageAddress + 'auth/page/email/set-password';
		case 4:
			return $author$project$Requests$landingPageAddress + 'pricing';
		case 5:
			return $author$project$APIServer$apiServerAddress + 'user/profile';
		case 6:
			var subname = endpoint.a;
			return $author$project$APIServer$apiServerAddress + ('subs/' + subname);
		case 7:
			return $author$project$APIServer$apiServerAddress + 'subs';
		case 8:
			var slug = endpoint.a;
			return $author$project$APIServer$apiServerAddress + ('docs/' + slug);
		case 9:
			var slug = endpoint.a;
			return $author$project$APIServer$apiServerAddress + ('doc/' + slug);
		default:
			return $author$project$Requests$landingPageAddress + 'glp/define/';
	}
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $author$project$Data$Errors$Other = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Data$Errors$InvalidRequest = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Errors$NotLoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Errors$PasswordInvalid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Errors$SessionExpired = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Errors$decodeAPIErrMsg = function (msg) {
	var errorOf = function (str) {
		return A2($elm$core$String$contains, str, msg);
	};
	return errorOf('Invalid email/password combination') ? $elm$json$Json$Decode$succeed(
		$author$project$Data$Errors$PasswordInvalid(msg)) : (errorOf('Expired') ? $elm$json$Json$Decode$succeed(
		$author$project$Data$Errors$SessionExpired(msg)) : (errorOf('Not logged in') ? $elm$json$Json$Decode$succeed(
		$author$project$Data$Errors$NotLoggedIn(msg)) : $elm$json$Json$Decode$succeed(
		$author$project$Data$Errors$InvalidRequest(msg))));
};
var $author$project$Requests$errorMessageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Data$Errors$decodeAPIErrMsg,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Requests$responseToResult = F2(
	function (decoder, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Data$Errors$Other(
						$elm$http$Http$BadUrl(url)));
			case 1:
				return $elm$core$Result$Err(
					$author$project$Data$Errors$Other($elm$http$Http$Timeout));
			case 2:
				return $elm$core$Result$Err(
					$author$project$Data$Errors$Other($elm$http$Http$NetworkError));
			case 3:
				var metadata = response.a;
				var body = response.b;
				var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$Requests$errorMessageDecoder, body);
				if (!_v1.$) {
					var value = _v1.a;
					return $elm$core$Result$Err(value);
				} else {
					var err = _v1.a;
					return $elm$core$Result$Err(
						$author$project$Data$Errors$Other(
							$elm$http$Http$BadBody(
								$elm$json$Json$Decode$errorToString(err))));
				}
			default:
				var metadata = response.a;
				var body = response.b;
				var _v2 = A2($elm$json$Json$Decode$decodeString, decoder, body);
				if (!_v2.$) {
					var value = _v2.a;
					return $elm$core$Result$Ok(value);
				} else {
					var err = _v2.a;
					return $elm$core$Result$Err(
						$author$project$Data$Errors$Other(
							$elm$http$Http$BadBody(
								$elm$json$Json$Decode$errorToString(err))));
				}
		}
	});
var $author$project$Requests$expectStringWithErrJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$author$project$Requests$responseToResult(decoder));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {dD: reqs, dT: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.cq;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.dD));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.dT)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					el: r.el,
					bR: r.bR,
					bV: A2(_Http_mapExpect, func, r.bV),
					bY: r.bY,
					b7: r.b7,
					cp: r.cp,
					cq: r.cq,
					gJ: r.gJ
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{el: true, bR: r.bR, bV: r.bV, bY: r.bY, b7: r.b7, cp: r.cp, cq: r.cq, gJ: r.gJ}));
};
var $author$project$Requests$fetchEndpoint = F3(
	function (endpoint, handler, decoder) {
		return $elm$http$Http$riskyRequest(
			{
				bR: $elm$http$Http$emptyBody,
				bV: A2($author$project$Requests$expectStringWithErrJson, handler, decoder),
				bY: _List_fromArray(
					[$author$project$Requests$acceptHeader]),
				b7: 'GET',
				cp: $elm$core$Maybe$Nothing,
				cq: $elm$core$Maybe$Nothing,
				gJ: $author$project$Requests$endPointToString(endpoint)
			});
	});
var $author$project$Requests$fetchProfile = function (handler) {
	return A3($author$project$Requests$fetchEndpoint, $author$project$Requests$Profile, handler, $author$project$Data$APITypes$decodeUserProfile);
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {av: frag, az: params, aq: unvisited, ah: value, aF: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aq;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.ah);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.ah);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.dp),
					$elm$url$Url$Parser$prepareQuery(url.dA),
					url.cV,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$About = {$: 6};
var $author$project$Route$Contents = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Route$Document = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$Home = {$: 0};
var $author$project$Route$Login = {$: 9};
var $author$project$Route$Menu = {$: 5};
var $author$project$Route$Profile = {$: 7};
var $author$project$Route$SearchResultsDoc = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$SearchResultsItem = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Route$Settings = {$: 8};
var $author$project$Route$Test = {$: 10};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aF;
		var unvisited = _v0.aq;
		var params = _v0.az;
		var frag = _v0.av;
		var value = _v0.ah;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aF;
			var unvisited = _v1.aq;
			var params = _v1.az;
			var frag = _v1.av;
			var value = _v1.ah;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Data$DocID$DocID = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$DocID$fromString = function (id) {
	return $author$project$Data$DocID$DocID(id);
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.aF;
			var unvisited = _v0.aq;
			var params = _v0.az;
			var frag = _v0.av;
			var value = _v0.ah;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$Route$rawDocID = A2($elm$url$Url$Parser$map, $author$project$Data$DocID$fromString, $elm$url$Url$Parser$string);
var $author$project$Data$ID$ID = function (a) {
	return {$: 1, a: a};
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {fl: index, fA: match, fN: number, gm: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{eF: false, fD: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Data$ID$fromString = function (phrase) {
	var rex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[ /#,;§¶]'));
	var noSpacesHashesSlashes = A2(
		$elm$regex$Regex$replace,
		rex,
		function (_v0) {
			return '';
		});
	return $author$project$Data$ID$ID(
		A3(
			$elm$core$String$replace,
			'.',
			'-',
			noSpacesHashesSlashes(phrase)));
};
var $author$project$Route$rawID = A2($elm$url$Url$Parser$map, $author$project$Data$ID$fromString, $elm$url$Url$Parser$string);
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.aF;
		var unvisited = _v0.aq;
		var params = _v0.az;
		var frag = _v0.av;
		var value = _v0.ah;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$route = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$About,
			$elm$url$Url$Parser$s('about')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Settings,
			$elm$url$Url$Parser$s('settings')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Profile,
			$elm$url$Url$Parser$s('profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Login,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Test,
			$elm$url$Url$Parser$s('test')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Menu,
			$elm$url$Url$Parser$s('menu')),
			A2($elm$url$Url$Parser$map, $author$project$Route$Document, $author$project$Route$rawDocID),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SearchResultsDoc,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Route$rawDocID,
				$elm$url$Url$Parser$s('search'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SearchResultsItem,
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Route$rawDocID,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('search'),
					$author$project$Route$rawID))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Contents,
			A2($elm$url$Url$Parser$slash, $author$project$Route$rawDocID, $author$project$Route$rawID))
		]));
var $author$project$Route$fromUrl = function (url) {
	return A2($elm$url$Url$Parser$parse, $author$project$Route$route, url);
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Data$Citation$EPA = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Citation$FDA = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Citation$NoCitation = {$: 0};
var $author$project$Data$Citation$OECD = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$APITypes$decodeCitation = F2(
	function (regtype, slug) {
		switch (regtype) {
			case 'OECD':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$Citation$OECD(slug));
			case 'FDA':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$Citation$FDA(slug));
			case 'EPA':
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$Citation$EPA(slug));
			default:
				return $elm$json$Json$Decode$succeed($author$project$Data$Citation$NoCitation);
		}
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Data$Outline$DocInfo = F5(
	function (id, citation, title, url, description) {
		return {eI: citation, cM: description, c2: id, gD: title, gJ: url};
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Data$APITypes$toDocInfo = F3(
	function (regtype, title, slug) {
		var createID = $author$project$Data$DocID$fromString(
			A3($elm$core$String$slice, 0, -4, slug));
		return A4($author$project$Data$Outline$DocInfo, createID, regtype, title, slug);
	});
var $author$project$Data$APITypes$decodeDocInfo = A2(
	$elm$json$Json$Decode$field,
	'article',
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Data$APITypes$toDocInfo,
		A2(
			$elm$json$Json$Decode$andThen,
			function (x) {
				return A2($author$project$Data$APITypes$decodeCitation, x, '');
			},
			A2($elm$json$Json$Decode$field, 'regtype', $elm$json$Json$Decode$string)),
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'slug', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string)));
var $author$project$Data$SearchSettings$SearchSettings = F5(
	function (searchTermSettings, ignoreCase, ignoreCommonWords, useSynonyms, sortBy) {
		return {b$: ignoreCase, b0: ignoreCommonWords, cf: searchTermSettings, ck: sortBy, cr: useSynonyms};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Data$SearchSettings$AllWords = 1;
var $author$project$Data$SearchSettings$AnyWords = 2;
var $author$project$Data$SearchSettings$KeyWordsOnly = 3;
var $author$project$Data$SearchSettings$decodeSearchTermSettings = function (str) {
	switch (str) {
		case 'WholePhrase':
			return $elm$json$Json$Decode$succeed(0);
		case 'AllWords':
			return $elm$json$Json$Decode$succeed(1);
		case 'AnyWords':
			return $elm$json$Json$Decode$succeed(2);
		case 'KeyWordsOnly':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail(str + ' is not a valid SearchTerm.');
	}
};
var $author$project$Data$SearchSettings$DocumentOrder = 1;
var $author$project$Data$SearchSettings$decodeSortType = function (str) {
	switch (str) {
		case 'TotalScore':
			return $elm$json$Json$Decode$succeed(0);
		case 'DocumentOrder':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail(str + ' is not a valid Sort option.');
	}
};
var $author$project$Data$SearchSettings$decodeSearchSettings = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$SearchSettings$SearchSettings,
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Data$SearchSettings$decodeSearchTermSettings,
		A2($elm$json$Json$Decode$field, 'searchTermSettings', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'ignoreCase', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ignoreCommonWords', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'useSynonyms', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Data$SearchSettings$decodeSortType,
		A2($elm$json$Json$Decode$field, 'sortBy', $elm$json$Json$Decode$string)));
var $author$project$Data$ViewSettings$ViewSettings = F2(
	function (columnView, summarize) {
		return {bT: columnView, cm: summarize};
	});
var $author$project$Data$ViewSettings$decodeViewSettings = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$ViewSettings$ViewSettings,
	A2($elm$json$Json$Decode$field, 'columnView', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'summarize', $elm$json$Json$Decode$bool));
var $author$project$Pages$Settings$decodeSettings = function () {
	var settings = F2(
		function (s, v) {
			return {dN: s, d2: v};
		});
	return A3(
		$elm$json$Json$Decode$map2,
		settings,
		A2($elm$json$Json$Decode$field, 'searchSettings', $author$project$Data$SearchSettings$decodeSearchSettings),
		A2($elm$json$Json$Decode$field, 'viewSettings', $author$project$Data$ViewSettings$decodeViewSettings));
}();
var $author$project$Data$User$decodeUser = $author$project$Data$APITypes$decodeUserProfile;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Main$defaultSettings = {dN: $author$project$Data$SearchSettings$defaultSearchSettings, d2: $author$project$Data$ViewSettings$defaultViewSettings};
var $author$project$Data$UrlQueue$Empty = {$: 0};
var $author$project$Data$UrlQueue$empty = $author$project$Data$UrlQueue$Empty;
var $author$project$Data$UrlQueue$Ready = {$: 0};
var $author$project$Data$UrlQueue$Urls = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Data$UrlQueue$fromList = function (l) {
	if (!l.b) {
		return $author$project$Data$UrlQueue$Empty;
	} else {
		var xs = l;
		return A2(
			$author$project$Data$UrlQueue$Urls,
			$author$project$Data$UrlQueue$Ready,
			$elm$core$Set$fromList(xs));
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Main$parseFlags = function (mFlags) {
	if (mFlags.$ === 1) {
		return {au: $author$project$Data$UrlQueue$empty, X: $author$project$Main$defaultSettings, bI: $elm$core$Maybe$Nothing};
	} else {
		var flags = mFlags.a;
		return {
			au: function () {
				var _v1 = flags.au;
				if (_v1.$ === 1) {
					return $author$project$Data$UrlQueue$empty;
				} else {
					var lst = _v1.a;
					return $author$project$Data$UrlQueue$fromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.gJ;
							},
							A2(
								$elm$core$Result$withDefault,
								_List_Nil,
								$elm$json$Json$Decode$decodeValue(
									$elm$json$Json$Decode$list($author$project$Data$APITypes$decodeDocInfo))(lst))));
				}
			}(),
			X: function () {
				var _v2 = flags.X;
				if (_v2.$ === 1) {
					return $author$project$Main$defaultSettings;
				} else {
					var stngs = _v2.a;
					return A2(
						$elm$core$Result$withDefault,
						$author$project$Main$defaultSettings,
						A2($elm$json$Json$Decode$decodeValue, $author$project$Pages$Settings$decodeSettings, stngs));
				}
			}(),
			bI: function () {
				var _v3 = flags.bP;
				if (_v3.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var usr = _v3.a;
					return A2(
						$elm$core$Result$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Result$map,
							$elm$core$Maybe$Just,
							A2($elm$json$Json$Decode$decodeValue, $author$project$Data$User$decodeUser, usr)));
				}
			}()
		};
	}
};
var $author$project$Data$Errors$APIError = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Main$About = {$: 5};
var $author$project$Main$Home = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$HomeMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Loaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Login = {$: 6};
var $author$project$Pages$Home$None = {$: 18};
var $author$project$Main$NotFound = {$: 1};
var $author$project$Msg$OnApiSubResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Msg$OnLoadDoc = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Main$Profile = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$ProfileMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Home$Refresh = {$: 1};
var $author$project$Pages$Home$Reset = {$: 2};
var $author$project$Main$Settings = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$SettingsMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Home$SwitchToItem = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$Test = function (a) {
	return {$: 4, a: a};
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Utility$addIfNotInList = F2(
	function (a, list) {
		return A2($elm$core$List$member, a, list) ? list : A2($elm$core$List$cons, a, list);
	});
var $author$project$Views$Menu$AddSearchable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Menu$NoOp = {$: 3};
var $author$project$Data$Errors$ParseError = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$MyXml$Decode$Content = function (a) {
	return {$: 5, a: a};
};
var $author$project$MyXml$Xml$Object = function (a) {
	return {$: 5, a: a};
};
var $author$project$MyXml$Xml$StrNode = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$MyXml$Decode$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$MyXml$Decode$getContent = function (token) {
	if (!token.$) {
		if (token.a.$ === 5) {
			var val = token.a.a;
			return $elm$core$Result$Ok(val);
		} else {
			return $elm$core$Result$Err('Non-content token left in stack');
		}
	} else {
		var msg = token.a;
		return $elm$core$Result$Err(msg);
	}
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$MyXml$Decode$removeComments = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('<!--.*-->')),
	function (_v0) {
		return '';
	});
var $author$project$MyXml$Decode$removeNestedElementDoctypes = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('<!DOCTYPE.*\\[.*\\].*>')),
	function (_v0) {
		return '';
	});
var $author$project$MyXml$Decode$CloseTag = function (a) {
	return {$: 1, a: a};
};
var $author$project$MyXml$Decode$DeclT = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$MyXml$Decode$DocT = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$MyXml$Decode$OpenTag = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$MyXml$Decode$SelfClosing = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$MyXml$Symbols$escapeCodesToSymbols = function (s) {
	return A2($elm$core$String$contains, '&', s) ? A3(
		$elm$core$String$replace,
		'&quot;',
		'\"',
		A3(
			$elm$core$String$replace,
			'&apos;',
			'\'',
			A3(
				$elm$core$String$replace,
				'&gt;',
				'>',
				A3(
					$elm$core$String$replace,
					'&lt;',
					'<',
					A3($elm$core$String$replace, '&amp;', '&', s))))) : s;
};
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$MyXml$Decode$getEnts = function (str) {
	var itb = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[.*]'));
	return $author$project$MyXml$Xml$Object(
		A2(
			$elm$core$List$map,
			$author$project$MyXml$Xml$StrNode,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.fA;
				},
				A2($elm$regex$Regex$find, itb, str))));
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$trim = _String_trim;
var $elm$core$String$words = _String_words;
var $author$project$MyXml$Decode$getName = function (nameAndProps) {
	var rx = A2(
		$elm$regex$Regex$find,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('[^<>/\\?\\!].*[^<>/]')),
		nameAndProps);
	return $elm$core$String$trim(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				$elm$core$String$words(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.fA;
								},
								rx)))))));
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$MyXml$Xml$BoolNode = function (a) {
	return {$: 4, a: a};
};
var $author$project$MyXml$Decode$decodeBool = function (str) {
	return (str === 'true') ? $elm$core$Result$Ok(
		$author$project$MyXml$Xml$BoolNode(true)) : ((str === 'false') ? $elm$core$Result$Ok(
		$author$project$MyXml$Xml$BoolNode(false)) : $elm$core$Result$Err('Not a bool'));
};
var $author$project$MyXml$Xml$FloatNode = function (a) {
	return {$: 3, a: a};
};
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$MyXml$Decode$decodeFloat = function (str) {
	var _v0 = $elm$core$String$toFloat(str);
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('Error converting ' + (str + ' to a Float'));
	} else {
		var v = _v0.a;
		return $elm$core$Result$Ok(
			$author$project$MyXml$Xml$FloatNode(v));
	}
};
var $author$project$MyXml$Xml$IntNode = function (a) {
	return {$: 2, a: a};
};
var $author$project$MyXml$Decode$decodeInt = function (str) {
	var _v0 = $elm$core$String$toInt(str);
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('Error converting ' + (str + ' to an Int'));
	} else {
		var v = _v0.a;
		return $elm$core$Result$Ok(
			$author$project$MyXml$Xml$IntNode(v));
	}
};
var $author$project$MyXml$Decode$decodeString = function (str) {
	return $elm$core$Result$Ok(
		$author$project$MyXml$Xml$StrNode(
			$author$project$MyXml$Symbols$escapeCodesToSymbols(str)));
};
var $author$project$MyXml$Decode$decodeProps = function (str) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (decoder, val) {
				if (!val.$) {
					return val;
				} else {
					return decoder(str);
				}
			}),
		$elm$core$Result$Err(''),
		_List_fromArray(
			[$author$project$MyXml$Decode$decodeBool, $author$project$MyXml$Decode$decodeInt, $author$project$MyXml$Decode$decodeFloat, $author$project$MyXml$Decode$decodeString]));
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $author$project$MyXml$Decode$parseProps = $elm$core$List$filterMap(
	function (n) {
		var _v0 = A2($elm$core$String$split, '=', n);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var name = _v0.a;
			var _v1 = _v0.b;
			var value = _v1.a;
			var withoutQuotes = A2(
				$elm$core$String$dropRight,
				1,
				A2($elm$core$String$dropLeft, 1, value));
			var _v2 = $author$project$MyXml$Decode$decodeProps(withoutQuotes);
			if (_v2.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var v = _v2.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(name, v));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$MyXml$Decode$propRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString(' .+?=\".+?\"'));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MyXml$Decode$findProps = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$tail,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$withDefault(_List_Nil),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$join(' '),
			A2(
				$elm$core$Basics$composeR,
				function (s) {
					return ' ' + s;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$regex$Regex$find($author$project$MyXml$Decode$propRegex),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fA;
								},
								$elm$core$String$trim)),
						A2($elm$core$Basics$composeR, $author$project$MyXml$Decode$parseProps, $elm$core$Dict$fromList)))))));
var $author$project$MyXml$Decode$getProps = function (nameAndProps) {
	return $author$project$MyXml$Decode$findProps(
		$elm$core$String$words(nameAndProps));
};
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$MyXml$Decode$isClosingTag = function (str) {
	return (A2($elm$core$String$left, 2, str) === '</') && (A2($elm$core$String$right, 1, str) === '>');
};
var $author$project$MyXml$Decode$isDecl = function (str) {
	return (A2($elm$core$String$left, 2, str) === '<?') && (A2($elm$core$String$right, 2, str) === '?>');
};
var $author$project$MyXml$Decode$isDocType = function (str) {
	return (A2($elm$core$String$left, 2, str) === '<!') && (A2($elm$core$String$right, 1, str) === '>');
};
var $author$project$MyXml$Decode$isSelfClosingTag = function (str) {
	return (A2($elm$core$String$left, 1, str) === '<') && (A2($elm$core$String$right, 2, str) === '/>');
};
var $author$project$MyXml$Decode$isTag = function (str) {
	return (A2($elm$core$String$left, 1, str) === '<') && (A2($elm$core$String$right, 1, str) === '>');
};
var $author$project$MyXml$Decode$readToken = function (input) {
	var tagOrContent = $elm$core$String$trim(input);
	return $author$project$MyXml$Decode$isSelfClosingTag(tagOrContent) ? A2(
		$author$project$MyXml$Decode$SelfClosing,
		$author$project$MyXml$Decode$getName(tagOrContent),
		$author$project$MyXml$Decode$getProps(tagOrContent)) : ($author$project$MyXml$Decode$isClosingTag(tagOrContent) ? $author$project$MyXml$Decode$CloseTag(
		$author$project$MyXml$Decode$getName(tagOrContent)) : ($author$project$MyXml$Decode$isDocType(tagOrContent) ? A2(
		$author$project$MyXml$Decode$DocT,
		$author$project$MyXml$Decode$getName(tagOrContent),
		$author$project$MyXml$Decode$getEnts(tagOrContent)) : ($author$project$MyXml$Decode$isDecl(tagOrContent) ? A2(
		$author$project$MyXml$Decode$DeclT,
		$author$project$MyXml$Decode$getName(tagOrContent),
		$author$project$MyXml$Decode$getProps(tagOrContent)) : ($author$project$MyXml$Decode$isTag(tagOrContent) ? A2(
		$author$project$MyXml$Decode$OpenTag,
		$author$project$MyXml$Decode$getName(tagOrContent),
		$author$project$MyXml$Decode$getProps(tagOrContent)) : $author$project$MyXml$Decode$Content(
		$author$project$MyXml$Xml$StrNode(
			$author$project$MyXml$Symbols$escapeCodesToSymbols(tagOrContent)))))));
};
var $author$project$MyXml$Decode$tokenizeIter = F3(
	function (_v0, revResultSoFar, rawXmlString) {
		tokenizeIter:
		while (true) {
			var openIndexes = _v0.a;
			var closeIndexes = _v0.b;
			var sliceThenReadToken = F2(
				function (i1, i2) {
					return $author$project$MyXml$Decode$readToken(
						A3($elm$core$String$slice, i1, i2 + 1, rawXmlString));
				});
			var _v1 = _Utils_Tuple2(openIndexes, closeIndexes);
			_v1$2:
			while (true) {
				if (_v1.a.b) {
					if (_v1.a.b.b) {
						if (_v1.b.b) {
							var _v2 = _v1.a;
							var first = _v2.a;
							var _v3 = _v2.b;
							var second = _v3.a;
							var rest = _v3.b;
							var _v4 = _v1.b;
							var firstClose = _v4.a;
							var restClose = _v4.b;
							var newRevResult = A2(
								$elm$core$List$cons,
								A2(sliceThenReadToken, firstClose + 1, second - 1),
								A2(
									$elm$core$List$cons,
									A2(sliceThenReadToken, first, firstClose),
									revResultSoFar));
							var $temp$_v0 = _Utils_Tuple2(
								A2($elm$core$List$cons, second, rest),
								restClose),
								$temp$revResultSoFar = newRevResult,
								$temp$rawXmlString = rawXmlString;
							_v0 = $temp$_v0;
							revResultSoFar = $temp$revResultSoFar;
							rawXmlString = $temp$rawXmlString;
							continue tokenizeIter;
						} else {
							break _v1$2;
						}
					} else {
						if (_v1.b.b && (!_v1.b.b.b)) {
							var _v5 = _v1.a;
							var first = _v5.a;
							var _v6 = _v1.b;
							var firstClose = _v6.a;
							return A2(
								$elm$core$List$cons,
								A2(sliceThenReadToken, first, firstClose),
								revResultSoFar);
						} else {
							break _v1$2;
						}
					}
				} else {
					break _v1$2;
				}
			}
			return revResultSoFar;
		}
	});
var $author$project$MyXml$Decode$tokenize = F2(
	function (_v0, rawXmlString) {
		var openIndexes = _v0.a;
		var closeIndexes = _v0.b;
		return $elm$core$List$reverse(
			A3(
				$author$project$MyXml$Decode$tokenizeIter,
				_Utils_Tuple2(openIndexes, closeIndexes),
				_List_Nil,
				rawXmlString));
	});
var $author$project$MyXml$Decode$getTokenList = function (xmlString) {
	var rawXmlString = $author$project$MyXml$Decode$removeNestedElementDoctypes(
		$author$project$MyXml$Decode$removeComments(xmlString));
	var openIndexes = A2($elm$core$String$indexes, '<', rawXmlString);
	var closeIndexes = A2($elm$core$String$indexes, '>', rawXmlString);
	return (!_Utils_eq(
		$elm$core$List$length(openIndexes),
		$elm$core$List$length(closeIndexes))) ? $elm$core$Result$Err('Imbalanced <> symbols') : $elm$core$Result$Ok(
		A2(
			$author$project$MyXml$Decode$tokenize,
			_Utils_Tuple2(openIndexes, closeIndexes),
			rawXmlString));
};
var $author$project$Data$Stack$Stack = $elm$core$Basics$identity;
var $author$project$Data$Stack$initialise = _List_Nil;
var $author$project$MyXml$Xml$Decl = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$MyXml$Xml$DocType = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$MyXml$Xml$Tag = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Data$Stack$push = F2(
	function (item, _v0) {
		var stack = _v0;
		return A2($elm$core$List$cons, item, stack);
	});
var $author$project$Data$Stack$pop = function (_v0) {
	var stack = _v0;
	if (!stack.b) {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
	} else {
		var head = stack.a;
		var tail = stack.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(head),
			tail);
	}
};
var $author$project$MyXml$Decode$ranOutOfTags = function (t1) {
	return $elm$core$Result$Err('Ran out of tags trying to close' + t1);
};
var $author$project$MyXml$Decode$unbalanced = F2(
	function (t1, t2) {
		return $elm$core$Result$Err('Unbalanced tag ' + (t2 + (' found closing ' + t1)));
	});
var $author$project$MyXml$Decode$unexpected = F2(
	function (t1, tag) {
		return $elm$core$Result$Err('Unexpected tag ' + (t1 + (' found on stack before closing ' + tag)));
	});
var $author$project$MyXml$Decode$contentStack = F3(
	function (stck, ctag, lst) {
		contentStack:
		while (true) {
			var _v0 = $author$project$Data$Stack$pop(stck);
			if (!_v0.a.$) {
				if (!_v0.a.a.$) {
					if (!_v0.a.a.a.$) {
						var _v1 = _v0.a.a.a;
						var otag = _v1.a;
						var props = _v1.b;
						var rstck = _v0.b;
						if (_Utils_eq(otag, ctag)) {
							var _v2 = $elm$core$List$length(lst);
							if (_v2 === 1) {
								var nd = A2(
									$elm$core$Maybe$withDefault,
									$author$project$MyXml$Xml$StrNode(''),
									$elm$core$List$head(lst));
								return _Utils_Tuple2(
									$elm$core$Result$Ok(
										A3($author$project$MyXml$Xml$Tag, otag, props, nd)),
									rstck);
							} else {
								return _Utils_Tuple2(
									$elm$core$Result$Ok(
										A3(
											$author$project$MyXml$Xml$Tag,
											otag,
											props,
											$author$project$MyXml$Xml$Object(lst))),
									rstck);
							}
						} else {
							return _Utils_Tuple2(
								A2($author$project$MyXml$Decode$unbalanced, otag, ctag),
								rstck);
						}
					} else {
						var itm = _v0.a.a.a;
						var rstck = _v0.b;
						if (itm.$ === 5) {
							var val = itm.a;
							var $temp$stck = rstck,
								$temp$ctag = ctag,
								$temp$lst = A2($elm$core$List$cons, val, lst);
							stck = $temp$stck;
							ctag = $temp$ctag;
							lst = $temp$lst;
							continue contentStack;
						} else {
							return _Utils_Tuple2(
								A2($author$project$MyXml$Decode$unexpected, 'tag', ctag),
								rstck);
						}
					}
				} else {
					var msg = _v0.a.a.a;
					var rstck = _v0.b;
					return _Utils_Tuple2(
						$elm$core$Result$Err(msg),
						rstck);
				}
			} else {
				var _v4 = _v0.a;
				var rstck = _v0.b;
				return _Utils_Tuple2(
					$author$project$MyXml$Decode$ranOutOfTags(ctag),
					rstck);
			}
		}
	});
var $author$project$MyXml$Decode$rollUpContent = F2(
	function (ctag, stack) {
		var _v0 = A3($author$project$MyXml$Decode$contentStack, stack, ctag, _List_Nil);
		var rslt = _v0.a;
		var rStckFinal = _v0.b;
		return A2(
			$author$project$Data$Stack$push,
			A2($elm$core$Result$map, $author$project$MyXml$Decode$Content, rslt),
			rStckFinal);
	});
var $author$project$MyXml$Decode$readTokenStack = F2(
	function (token, stack) {
		switch (token.$) {
			case 3:
				var docstr = token.a;
				var entlist = token.b;
				return A2(
					$author$project$Data$Stack$push,
					$elm$core$Result$Ok(
						$author$project$MyXml$Decode$Content(
							A2($author$project$MyXml$Xml$DocType, docstr, entlist))),
					stack);
			case 4:
				var decl = token.a;
				var props = token.b;
				return A2(
					$author$project$Data$Stack$push,
					$elm$core$Result$Ok(
						$author$project$MyXml$Decode$Content(
							A2($author$project$MyXml$Xml$Decl, decl, props))),
					stack);
			case 2:
				var tag = token.a;
				var props = token.b;
				return A2(
					$author$project$Data$Stack$push,
					$elm$core$Result$Ok(
						$author$project$MyXml$Decode$Content(
							A3(
								$author$project$MyXml$Xml$Tag,
								tag,
								props,
								$author$project$MyXml$Xml$Object(_List_Nil)))),
					stack);
			case 1:
				var tag = token.a;
				return A2($author$project$MyXml$Decode$rollUpContent, tag, stack);
			default:
				return A2(
					$author$project$Data$Stack$push,
					$elm$core$Result$Ok(token),
					stack);
		}
	});
var $author$project$Data$Stack$toList = function (_v0) {
	var stack = _v0;
	return stack;
};
var $author$project$MyXml$Decode$decode = function (xmlStr) {
	var tokensResult = A2(
		$elm$core$Result$map,
		$elm$core$List$filter(
			function (x) {
				return !_Utils_eq(
					x,
					$author$project$MyXml$Decode$Content(
						$author$project$MyXml$Xml$StrNode('')));
			}),
		$author$project$MyXml$Decode$getTokenList(xmlStr));
	if (tokensResult.$ === 1) {
		var msg = tokensResult.a;
		return $elm$core$Result$Err(msg);
	} else {
		var tokens = tokensResult.a;
		var stack = A3($elm$core$List$foldl, $author$project$MyXml$Decode$readTokenStack, $author$project$Data$Stack$initialise, tokens);
		var contentList = $author$project$MyXml$Decode$combine(
			$elm$core$List$reverse(
				A2(
					$elm$core$List$map,
					$author$project$MyXml$Decode$getContent,
					$author$project$Data$Stack$toList(stack))));
		if (!contentList.$) {
			var lst = contentList.a;
			return $elm$core$Result$Ok(
				$author$project$MyXml$Xml$Object(lst));
		} else {
			var msg = contentList.a;
			return $elm$core$Result$Err(msg);
		}
	}
};
var $author$project$Data$Outline$Doc = function (uniqueID) {
	return function (cite) {
		return function (link) {
			return function (info) {
				return function (fineprint) {
					return function (published) {
						return function (lastChecked) {
							return function (ignored) {
								return function (title) {
									return function (shortTitle) {
										return function (keywords) {
											return function (outline) {
												return function (version) {
													return {bk: cite, e9: fineprint, fh: ignored, b1: info, b3: keywords, fx: lastChecked, c9: link, a9: outline, dz: published, f8: shortTitle, gD: title, R: uniqueID, gK: version};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_community$result_extra$Result$Extra$andMap = F2(
	function (ra, rb) {
		var _v0 = _Utils_Tuple2(ra, rb);
		if (_v0.b.$ === 1) {
			var x = _v0.b.a;
			return $elm$core$Result$Err(x);
		} else {
			var o = _v0.a;
			var fn = _v0.b.a;
			return A2($elm$core$Result$map, fn, o);
		}
	});
var $author$project$MyXml$Query$childNodes = F2(
	function (tagName, node) {
		childNodes:
		while (true) {
			switch (node.$) {
				case 0:
					var name = node.a;
					var value = node.c;
					if (_Utils_eq(name, tagName)) {
						return _List_fromArray(
							[node]);
					} else {
						var $temp$tagName = tagName,
							$temp$node = value;
						tagName = $temp$tagName;
						node = $temp$node;
						continue childNodes;
					}
				case 5:
					var nodes = node.a;
					var tagFilter = function (nd) {
						if (!nd.$) {
							var name = nd.a;
							return _Utils_eq(name, tagName);
						} else {
							return false;
						}
					};
					if ((nodes.b && (!nodes.a.$)) && (!nodes.b.b)) {
						var _v2 = nodes.a;
						var n = _v2.a;
						var p = _v2.b;
						var v = _v2.c;
						var $temp$tagName = tagName,
							$temp$node = A3($author$project$MyXml$Xml$Tag, n, p, v);
						tagName = $temp$tagName;
						node = $temp$node;
						continue childNodes;
					} else {
						return A2($elm$core$List$filter, tagFilter, nodes);
					}
				default:
					return _List_Nil;
			}
		}
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MyXml$Query$collect = F2(
	function (fn, values) {
		return A2(
			$elm$core$List$filterMap,
			A2($elm$core$Basics$composeR, fn, $elm$core$Result$toMaybe),
			values);
	});
var $author$project$MyXml$Query$string = function (value) {
	if (value.$ === 1) {
		var s = value.a;
		return $elm$core$Result$Ok(s);
	} else {
		return $elm$core$Result$Err('Not a string.');
	}
};
var $author$project$Data$Outline$Xml$stringOrBlank = function (value) {
	var result = $author$project$MyXml$Query$string(value);
	if (!result.$) {
		var s = result.a;
		return $elm$core$Result$Ok(s);
	} else {
		return $elm$core$Result$Ok('');
	}
};
var $author$project$MyXml$Query$tagsHelper = F3(
	function (tagName, node, acc) {
		tagsHelper:
		while (true) {
			switch (node.$) {
				case 1:
					return acc;
				case 4:
					return acc;
				case 2:
					return acc;
				case 3:
					return acc;
				case 7:
					return acc;
				case 6:
					return acc;
				case 0:
					var name = node.a;
					var value = node.c;
					if (_Utils_eq(name, tagName)) {
						var $temp$tagName = tagName,
							$temp$node = value,
							$temp$acc = A2($elm$core$List$cons, node, acc);
						tagName = $temp$tagName;
						node = $temp$node;
						acc = $temp$acc;
						continue tagsHelper;
					} else {
						var $temp$tagName = tagName,
							$temp$node = value,
							$temp$acc = acc;
						tagName = $temp$tagName;
						node = $temp$node;
						acc = $temp$acc;
						continue tagsHelper;
					}
				default:
					var nodes = node.a;
					if (!nodes.b) {
						return acc;
					} else {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$map,
								function (n) {
									return A3($author$project$MyXml$Query$tagsHelper, tagName, n, acc);
								},
								nodes));
					}
			}
		}
	});
var $author$project$MyXml$Query$tags = F2(
	function (tagName, node) {
		return A3($author$project$MyXml$Query$tagsHelper, tagName, node, _List_Nil);
	});
var $author$project$MyXml$Query$tag = F3(
	function (name, converter, value) {
		tag:
		while (true) {
			var _v0 = A2($author$project$MyXml$Query$tags, name, value);
			if (!_v0.b) {
				return $elm$core$Result$Err('No tag called \'' + (name + '\' found.'));
			} else {
				var firstTag = _v0.a;
				_v1$2:
				while (true) {
					switch (firstTag.$) {
						case 0:
							var nextValue = firstTag.c;
							return converter(nextValue);
						case 5:
							if (firstTag.a.b) {
								var _v2 = firstTag.a;
								var x = _v2.a;
								var $temp$name = name,
									$temp$converter = converter,
									$temp$value = x;
								name = $temp$name;
								converter = $temp$converter;
								value = $temp$value;
								continue tag;
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return $elm$core$Result$Err('Not a tag');
			}
		}
	});
var $author$project$Data$Outline$Xml$decodeKeywords = function (val) {
	return $elm$core$Result$Ok(
		A2(
			$author$project$MyXml$Query$collect,
			A2($author$project$MyXml$Query$tag, 'KEYWORD', $author$project$Data$Outline$Xml$stringOrBlank),
			A2($author$project$MyXml$Query$childNodes, 'KEYWORD', val)));
};
var $author$project$Data$Citation$map = F2(
	function (f, cit) {
		switch (cit.$) {
			case 0:
				return $author$project$Data$Citation$NoCitation;
			case 3:
				var s = cit.a;
				return $author$project$Data$Citation$OECD(
					f(s));
			case 1:
				var s = cit.a;
				return $author$project$Data$Citation$FDA(
					f(s));
			default:
				var s = cit.a;
				return $author$project$Data$Citation$EPA(
					f(s));
		}
	});
var $author$project$Data$Citation$makeCitation = F2(
	function (rawLocalCitation, parentCitn) {
		var localCitation = $elm$core$String$trim(
			A3(
				$elm$core$String$replace,
				'SECTION',
				'',
				A3($elm$core$String$replace, 'PART', '', rawLocalCitation)));
		if (localCitation === '') {
			return A2(
				$author$project$Data$Citation$map,
				function (x) {
					return x + '%';
				},
				parentCitn);
		} else {
			switch (parentCitn.$) {
				case 3:
					var s = parentCitn.a;
					return (s === '') ? $author$project$Data$Citation$OECD(localCitation) : $author$project$Data$Citation$OECD(s + ('.' + localCitation));
				case 1:
					var s = parentCitn.a;
					return (s === '') ? $author$project$Data$Citation$FDA(localCitation) : $author$project$Data$Citation$FDA(s + ('.' + localCitation));
				case 2:
					var s = parentCitn.a;
					return (s === '') ? $author$project$Data$Citation$EPA(localCitation) : $author$project$Data$Citation$EPA(s + ('.' + localCitation));
				default:
					return $author$project$Data$Citation$NoCitation;
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$Data$DocID$toString = function (id) {
	if (id.$ === 1) {
		var s = id.a;
		return s;
	} else {
		return '';
	}
};
var $author$project$Data$Outline$Xml$decodeDocContents = F5(
	function (docUID, citn, shortTitle, outline, val) {
		var mkerr = F2(
			function (field, msg) {
				return 'Error parsing field ' + (field + (' while parsing document ' + ($author$project$Data$DocID$toString(docUID) + (': ' + msg))));
			});
		var tagE = F3(
			function (field, decoder, value) {
				return A2(
					$elm$core$Result$mapError,
					mkerr(field),
					A3($author$project$MyXml$Query$tag, field, decoder, value));
			});
		var rcite = A3(tagE, 'CITE', $author$project$MyXml$Query$string, val);
		var rfineprint = A3(tagE, 'FINEPRINT', $author$project$Data$Outline$Xml$stringOrBlank, val);
		var rignored = A3(tagE, 'IGNORED', $author$project$Data$Outline$Xml$stringOrBlank, val);
		var rinfo = A3(tagE, 'INFO', $author$project$Data$Outline$Xml$stringOrBlank, val);
		var rkeywords = A3(tagE, 'KEYWORDS', $author$project$Data$Outline$Xml$decodeKeywords, val);
		var rlastChecked = A3(tagE, 'LAST_CHECKED', $author$project$MyXml$Query$string, val);
		var rlink = A3(tagE, 'LINK', $author$project$MyXml$Query$string, val);
		var rpublished = A3(tagE, 'DATE', $author$project$MyXml$Query$string, val);
		var rtitle = A3(tagE, 'TITLE', $author$project$MyXml$Query$string, val);
		var rversion = A3(tagE, 'VERSION', $author$project$MyXml$Query$string, val);
		return A2(
			$elm_community$result_extra$Result$Extra$andMap,
			rversion,
			A2(
				$elm_community$result_extra$Result$Extra$andMap,
				outline,
				A2(
					$elm_community$result_extra$Result$Extra$andMap,
					rkeywords,
					A2(
						$elm_community$result_extra$Result$Extra$andMap,
						$elm$core$Result$Ok(shortTitle),
						A2(
							$elm_community$result_extra$Result$Extra$andMap,
							rtitle,
							A2(
								$elm_community$result_extra$Result$Extra$andMap,
								rignored,
								A2(
									$elm_community$result_extra$Result$Extra$andMap,
									$elm$core$Result$Ok(rlastChecked),
									A2(
										$elm_community$result_extra$Result$Extra$andMap,
										$elm$core$Result$Ok(rpublished),
										A2(
											$elm_community$result_extra$Result$Extra$andMap,
											rfineprint,
											A2(
												$elm_community$result_extra$Result$Extra$andMap,
												rinfo,
												A2(
													$elm_community$result_extra$Result$Extra$andMap,
													rlink,
													A2(
														$elm_community$result_extra$Result$Extra$andMap,
														A2(
															$elm$core$Result$map,
															function (x) {
																return A2($author$project$Data$Citation$makeCitation, x, citn);
															},
															rcite),
														A2(
															$elm_community$result_extra$Result$Extra$andMap,
															$elm$core$Result$Ok(docUID),
															$elm$core$Result$Ok($author$project$Data$Outline$Doc))))))))))))));
	});
var $author$project$Data$Outline$Document = {$: 0};
var $author$project$Data$Outline$Entry = F9(
	function (uniqueID, citeLevel, docLevel, title, olType, keywords, content, parent, parentTitle) {
		return {cI: citeLevel, eO: content, cO: docLevel, b3: keywords, a6: olType, dm: parent, dn: parentTitle, gD: title, R: uniqueID};
	});
var $author$project$Utility$andMap = F2(
	function (ra, rb) {
		var _v0 = _Utils_Tuple2(ra, rb);
		if (_v0.b.$ === 1) {
			var x = _v0.b.a;
			return $elm$core$Result$Err(x);
		} else {
			var o = _v0.a;
			var fn = _v0.b.a;
			return A2($elm$core$Result$map, fn, o);
		}
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Data$Outline$Xml$cleanUpMarkup = function (txt) {
	var regexStr = '\\t| {4,}';
	return $elm$core$Result$Ok(
		A3(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString(regexStr)),
			function (_v0) {
				var match = _v0.fA;
				return '';
			},
			txt));
};
var $author$project$Utility$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$Data$Outline$Article = {$: 3};
var $author$project$Data$Outline$Definition = {$: 4};
var $author$project$Data$Outline$Section = {$: 2};
var $author$project$Data$Outline$SubArticle = {$: 5};
var $author$project$Data$Outline$SubDefinition = {$: 6};
var $author$project$Data$Outline$SubParagraph = {$: 7};
var $author$project$Data$Outline$Xml$decodeArticle = function (oltype) {
	switch (oltype) {
		case 'Document':
			return $elm$core$Result$Ok($author$project$Data$Outline$Document);
		case 'Section':
			return $elm$core$Result$Ok($author$project$Data$Outline$Section);
		case 'Article':
			return $elm$core$Result$Ok($author$project$Data$Outline$Article);
		case 'Definition':
			return $elm$core$Result$Ok($author$project$Data$Outline$Definition);
		case 'SubDefinition':
			return $elm$core$Result$Ok($author$project$Data$Outline$SubDefinition);
		case 'SubArticle':
			return $elm$core$Result$Ok($author$project$Data$Outline$SubArticle);
		case 'SubParagraph':
			return $elm$core$Result$Ok($author$project$Data$Outline$SubParagraph);
		default:
			return $elm$core$Result$Err(oltype + ' is not a valid outline type');
	}
};
var $author$project$MyXml$Query$int = function (value) {
	if (value.$ === 2) {
		var n = value.a;
		return $elm$core$Result$Ok(n);
	} else {
		return $elm$core$Result$Err('Not an int');
	}
};
var $author$project$Data$Outline$Xml$stringOrInt = function (value) {
	var result = $author$project$MyXml$Query$int(value);
	if (!result.$) {
		var s = result.a;
		return $elm$core$Result$Ok(
			$elm$core$String$fromInt(s));
	} else {
		return $author$project$Data$Outline$Xml$stringOrBlank(value);
	}
};
var $author$project$Data$Outline$Xml$decodeID = function (value) {
	var result = $author$project$Data$Outline$Xml$stringOrInt(value);
	return A2($elm$core$Result$map, $author$project$Data$ID$fromString, result);
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Citation$internalString = function (cit) {
	switch (cit.$) {
		case 3:
			var s = cit.a;
			return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		case 1:
			var s = cit.a;
			return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		case 2:
			var s = cit.a;
			return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Citation$toIDString = function (citn) {
	var raw = $author$project$Data$Citation$internalString(citn);
	return _Utils_eq(
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$right(1),
			raw),
		$elm$core$Maybe$Just('%')) ? A2(
		$elm$core$Maybe$map,
		A2($elm$core$String$replace, '%', '-top'),
		raw) : A2(
		$elm$core$Maybe$map,
		A2($elm$core$String$replace, '%', ''),
		raw);
};
var $author$project$Data$ID$fromCitation = function (citation) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Data$ID$fromString,
		$author$project$Data$Citation$toIDString(citation));
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Data$Outline$Outline = $elm$core$Basics$identity;
var $author$project$Data$Outline$ShowAll = 2;
var $author$project$Data$Outline$makeOL = F4(
	function (entry, docid, citn, sublist) {
		return {bk: citn, cP: docid, U: entry, Z: sublist, cs: 2};
	});
var $elm$core$Result$map4 = F5(
	function (func, ra, rb, rc, rd) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				if (rc.$ === 1) {
					var x = rc.a;
					return $elm$core$Result$Err(x);
				} else {
					var c = rc.a;
					if (rd.$ === 1) {
						var x = rd.a;
						return $elm$core$Result$Err(x);
					} else {
						var d = rd.a;
						return $elm$core$Result$Ok(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $elm_community$result_extra$Result$Extra$or = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			return rb;
		} else {
			return ra;
		}
	});
var $author$project$Data$Outline$Xml$decodeEntries = F3(
	function (val, docUID, citn) {
		return $author$project$Utility$combine(
			A2(
				$elm$core$List$map,
				A2(
					$author$project$MyXml$Query$tag,
					'ENTRY',
					function (x) {
						return A3($author$project$Data$Outline$Xml$decodeEntry, x, docUID, citn);
					}),
				A2($author$project$MyXml$Query$childNodes, 'ENTRY', val)));
	});
var $author$project$Data$Outline$Xml$decodeEntry = F3(
	function (val, rootDocUID, citn) {
		var thisDocLevel = A3($author$project$MyXml$Query$tag, 'DOCID', $author$project$Data$Outline$Xml$stringOrBlank, val);
		var thisCitationLevel = A3($author$project$MyXml$Query$tag, 'CITEID', $author$project$Data$Outline$Xml$stringOrBlank, val);
		var citation = A2(
			$elm$core$Result$map,
			function (x) {
				return A2($author$project$Data$Citation$makeCitation, x, citn);
			},
			thisCitationLevel);
		var mIdFromCitation = A2(
			$elm$core$Result$fromMaybe,
			'Invalid Citation',
			$author$project$Data$ID$fromCitation(
				A2($elm$core$Result$withDefault, $author$project$Data$Citation$NoCitation, citation)));
		return A5(
			$elm$core$Result$map4,
			$author$project$Data$Outline$makeOL,
			A2(
				$author$project$Utility$andMap,
				$elm$core$Result$Ok(''),
				A2(
					$author$project$Utility$andMap,
					$elm$core$Result$Ok($elm$core$Maybe$Nothing),
					A2(
						$author$project$Utility$andMap,
						A2(
							$elm$core$Result$andThen,
							$author$project$Data$Outline$Xml$cleanUpMarkup,
							A3($author$project$MyXml$Query$tag, 'CONTENT', $author$project$Data$Outline$Xml$stringOrBlank, val)),
						A2(
							$author$project$Utility$andMap,
							A3($author$project$MyXml$Query$tag, 'KEYWORDS', $author$project$Data$Outline$Xml$decodeKeywords, val),
							A2(
								$author$project$Utility$andMap,
								A2(
									$elm$core$Result$andThen,
									$author$project$Data$Outline$Xml$decodeArticle,
									A3($author$project$MyXml$Query$tag, 'OLTYPE', $author$project$MyXml$Query$string, val)),
								A2(
									$author$project$Utility$andMap,
									A3($author$project$MyXml$Query$tag, 'TITLE', $author$project$Data$Outline$Xml$stringOrBlank, val),
									A2(
										$author$project$Utility$andMap,
										thisDocLevel,
										A2(
											$author$project$Utility$andMap,
											thisCitationLevel,
											A2(
												$elm$core$Result$map,
												$author$project$Data$Outline$Entry,
												A2(
													$elm_community$result_extra$Result$Extra$or,
													mIdFromCitation,
													A3($author$project$MyXml$Query$tag, 'ID', $author$project$Data$Outline$Xml$decodeID, val))))))))))),
			$elm$core$Result$Ok(rootDocUID),
			citation,
			A3(
				$author$project$Data$Outline$Xml$getEntries,
				val,
				rootDocUID,
				A2($elm$core$Result$withDefault, $author$project$Data$Citation$NoCitation, citation)));
	});
var $author$project$Data$Outline$Xml$getEntries = F3(
	function (val, docUID, citn) {
		var entList = A2($author$project$MyXml$Query$tags, 'ENTRIES', val);
		if (!entList.b) {
			return $elm$core$Result$Ok(_List_Nil);
		} else {
			var x = entList.a;
			var xs = entList.b;
			return A3(
				$author$project$MyXml$Query$tag,
				'ENTRIES',
				function (y) {
					return A3($author$project$Data$Outline$Xml$decodeEntries, y, docUID, citn);
				},
				x);
		}
	});
var $author$project$Data$Outline$Xml$decodeDocOutline = F3(
	function (docUID, citn, val) {
		var localId = $author$project$Data$ID$fromString(
			$author$project$Data$DocID$toString(docUID));
		var citation = A2(
			$author$project$Data$Citation$makeCitation,
			$author$project$Data$DocID$toString(docUID),
			citn);
		return A5(
			$elm$core$Result$map4,
			$author$project$Data$Outline$makeOL,
			A2(
				$elm_community$result_extra$Result$Extra$andMap,
				$elm$core$Result$Ok(''),
				A2(
					$elm_community$result_extra$Result$Extra$andMap,
					$elm$core$Result$Ok($elm$core$Maybe$Nothing),
					A2(
						$elm_community$result_extra$Result$Extra$andMap,
						$elm$core$Result$Ok(''),
						A2(
							$elm_community$result_extra$Result$Extra$andMap,
							A3($author$project$MyXml$Query$tag, 'KEYWORDS', $author$project$Data$Outline$Xml$decodeKeywords, val),
							A2(
								$elm_community$result_extra$Result$Extra$andMap,
								$elm$core$Result$Ok($author$project$Data$Outline$Document),
								A2(
									$elm_community$result_extra$Result$Extra$andMap,
									A3($author$project$MyXml$Query$tag, 'TITLE', $author$project$Data$Outline$Xml$stringOrBlank, val),
									A2(
										$elm_community$result_extra$Result$Extra$andMap,
										$elm$core$Result$Ok(
											$author$project$Data$DocID$toString(docUID)),
										A2(
											$elm_community$result_extra$Result$Extra$andMap,
											$elm$core$Result$Ok(
												$author$project$Data$DocID$toString(docUID)),
											A2(
												$elm$core$Result$map,
												$author$project$Data$Outline$Entry,
												$elm$core$Result$Ok(localId)))))))))),
			$elm$core$Result$Ok(docUID),
			$elm$core$Result$Ok(citation),
			A3($author$project$Data$Outline$Xml$getEntries, val, docUID, citation));
	});
var $author$project$Data$Outline$Xml$decodeDoc = F4(
	function (docUID, citn, shortTitle, val) {
		var outline = A3(
			$author$project$MyXml$Query$tag,
			'DOCUMENT',
			A2($author$project$Data$Outline$Xml$decodeDocOutline, docUID, citn),
			val);
		return A3(
			$author$project$MyXml$Query$tag,
			'DOCUMENT',
			A4($author$project$Data$Outline$Xml$decodeDocContents, docUID, citn, shortTitle, outline),
			val);
	});
var $author$project$Data$Outline$mapD = F2(
	function (fn, doc) {
		return _Utils_update(
			doc,
			{
				a9: fn(doc.a9)
			});
	});
var $author$project$Data$Outline$setParent = F3(
	function (parent, parentTitle, ol) {
		var outline = ol;
		var ent = outline.U;
		var newTitle = $elm$core$String$isEmpty(
			$elm$core$String$trim(ent.gD)) ? parentTitle : ent.gD;
		return _Utils_update(
			outline,
			{
				U: _Utils_update(
					ent,
					{dm: parent, dn: parentTitle}),
				Z: A2(
					$elm$core$List$map,
					A2(
						$author$project$Data$Outline$setParent,
						$elm$core$Maybe$Just(ent.R),
						newTitle),
					outline.Z)
			});
	});
var $author$project$Data$Outline$Xml$fromXml = F4(
	function (docUID, citn, shortTitle, xml) {
		var val = $author$project$MyXml$Decode$decode(xml);
		var outline = function () {
			if (!val.$) {
				var ol = val.a;
				return A4($author$project$Data$Outline$Xml$decodeDoc, docUID, citn, shortTitle, ol);
			} else {
				var msg = val.a;
				return $elm$core$Result$Err(msg);
			}
		}();
		return A2(
			$elm$core$Result$map,
			$author$project$Data$Outline$mapD(
				A2($author$project$Data$Outline$setParent, $elm$core$Maybe$Nothing, '')),
			outline);
	});
var $author$project$Data$Session$setError = F2(
	function (session, newErr) {
		return _Utils_update(
			session,
			{
				bq: A2($elm$core$List$cons, newErr, session.bq)
			});
	});
var $elm$core$String$append = _String_append;
var $author$project$Data$Outline$docToUrl = function (doc) {
	return function (x) {
		return A2($elm$core$String$append, x, '.xml');
	}(
		$author$project$Data$DocID$toString(doc.R));
};
var $author$project$Data$Outline$docToDocInfo = function (doc) {
	return A5(
		$author$project$Data$Outline$DocInfo,
		doc.R,
		doc.bk,
		doc.gD,
		$author$project$Data$Outline$docToUrl(doc),
		doc.b1);
};
var $author$project$Data$User$getSubLevel = function (state) {
	if (state.$ === 2) {
		var user = state.a;
		return user.dS;
	} else {
		return 0;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Views$Menu$update = F2(
	function (msg, session) {
		switch (msg.$) {
			case 1:
				var doc = msg.a;
				var _v1 = $author$project$Data$User$getSubLevel(session.d$);
				if (_v1 === 1) {
					return _Utils_update(
						session,
						{
							cg: A2(
								$author$project$Utility$addIfNotInList,
								$author$project$Data$Outline$docToDocInfo(doc),
								session.cg)
						});
				} else {
					return _Utils_update(
						session,
						{
							cg: _List_fromArray(
								[
									$author$project$Data$Outline$docToDocInfo(doc)
								])
						});
				}
			case 2:
				var doc = msg.a;
				return _Utils_update(
					session,
					{
						cg: A2(
							$elm$core$List$filter,
							function (x) {
								return !_Utils_eq(
									x,
									$author$project$Data$Outline$docToDocInfo(doc));
							},
							session.cg)
					});
			case 0:
				return _Utils_update(
					session,
					{cw: !session.cw});
			default:
				return session;
		}
	});
var $author$project$Main$convertLoadedDocXml = F4(
	function (docinfo, xmlResult, isFirstDocLoadedOnHome, session) {
		var shortTitle = docinfo.gD;
		var docid = docinfo.c2;
		var citn = docinfo.eI;
		if (!xmlResult.$) {
			var xml = xmlResult.a;
			var docResult = A4($author$project$Data$Outline$Xml$fromXml, docid, citn, shortTitle, xml);
			if (!docResult.$) {
				var doc = docResult.a;
				var newSession = _Utils_update(
					session,
					{
						b4: A2($elm$core$List$cons, doc, session.b4)
					});
				var menuMsg = isFirstDocLoadedOnHome ? $author$project$Views$Menu$AddSearchable(doc) : $author$project$Views$Menu$NoOp;
				return A2($author$project$Views$Menu$update, menuMsg, newSession);
			} else {
				var msg = docResult.a;
				return A2(
					$author$project$Data$Session$setError,
					session,
					A2($author$project$Data$Errors$ParseError, 'Error parsing ' + shortTitle, msg));
			}
		} else {
			var httpErr = xmlResult.a;
			return A2(
				$author$project$Data$Session$setError,
				session,
				A2(
					$author$project$Data$Errors$APIError,
					'Error loading ' + $author$project$Data$DocID$toString(docid),
					$author$project$Data$Errors$Other(httpErr)));
		}
	});
var $author$project$Requests$Article = function (a) {
	return {$: 9, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.gh));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Requests$fetchDocument = F2(
	function (docinfo, handler) {
		return $elm$http$Http$riskyRequest(
			{
				bR: $elm$http$Http$emptyBody,
				bV: $elm$http$Http$expectString(
					handler(docinfo)),
				bY: _List_fromArray(
					[$author$project$Requests$acceptHeader]),
				b7: 'GET',
				cp: $elm$core$Maybe$Nothing,
				cq: $elm$core$Maybe$Nothing,
				gJ: $author$project$Requests$endPointToString(
					$author$project$Requests$Article(docinfo.gJ))
			});
	});
var $author$project$Requests$Sub = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$APITypes$Subscription = F4(
	function (name, articles, level, description) {
		return {ep: articles, cM: description, fy: level, fE: name};
	});
var $author$project$Data$APITypes$decodeSubContent = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$APITypes$Subscription,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'articles',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Data$APITypes$decodeSubLevel,
		A2($elm$json$Json$Decode$field, 'level', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string));
var $author$project$Data$APITypes$decodeSubscription = A2($elm$json$Json$Decode$field, 'subscription', $author$project$Data$APITypes$decodeSubContent);
var $author$project$Requests$fetchSub = F2(
	function (subid, handler) {
		return A3(
			$author$project$Requests$fetchEndpoint,
			$author$project$Requests$Sub(subid),
			handler,
			$author$project$Data$APITypes$decodeSubscription);
	});
var $author$project$Msg$NoOp = function (a) {
	return {$: 11, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Main$focusSearchBox = A2(
	$elm$core$Task$attempt,
	function (_v0) {
		return $author$project$Msg$NoOp('Focussed searchbox');
	},
	$elm$browser$Browser$Dom$focus('mainSearchBar'));
var $author$project$Data$DocID$EmptyID = {$: 0};
var $author$project$Data$DocID$isEmpty = function (id) {
	return _Utils_eq(id, $author$project$Data$DocID$EmptyID);
};
var $author$project$Data$Outline$getDocByID = F2(
	function (id, doclist) {
		var isEq = function (doc) {
			return _Utils_eq(id, doc.R);
		};
		return $author$project$Data$DocID$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$filter, isEq, doclist));
	});
var $author$project$Data$Outline$getOutlineID = function (_v0) {
	var ol = _v0;
	return ol.U.R;
};
var $author$project$Data$Outline$getSubs = function (_v0) {
	var x = _v0;
	return x.Z;
};
var $author$project$Data$Outline$findFirstOLWithID = F3(
	function (id, ol, ans) {
		if (ans.$ === 1) {
			return _Utils_eq(
				$author$project$Data$Outline$getOutlineID(ol),
				id) ? $elm$core$Maybe$Just(ol) : A3(
				$elm$core$List$foldr,
				F2(
					function (o, acc) {
						return A3($author$project$Data$Outline$findFirstOLWithID, id, o, acc);
					}),
				$elm$core$Maybe$Nothing,
				$author$project$Data$Outline$getSubs(ol));
		} else {
			return ans;
		}
	});
var $author$project$Data$Outline$getOutlineByID = F2(
	function (id, doc) {
		return A3($author$project$Data$Outline$findFirstOLWithID, id, doc.a9, $elm$core$Maybe$Nothing);
	});
var $author$project$Data$Outline$getParentDocumentID = function (_v0) {
	var ol = _v0;
	return ol.cP;
};
var $author$project$Data$Outline$getOutlineFromListByParentID = F2(
	function (id, ollist) {
		var isEq = function (ol) {
			return _Utils_eq(
				id,
				$author$project$Data$Outline$getParentDocumentID(ol));
		};
		return $author$project$Data$DocID$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$filter, isEq, ollist));
	});
var $author$project$Main$getPage = function (pageState) {
	if (!pageState.$) {
		var page = pageState.a;
		return page;
	} else {
		var page = pageState.a;
		return page;
	}
};
var $author$project$Data$User$LoggedIn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Authentication$getUserState = function (model) {
	if (model.$ === 1) {
		var user = model.a;
		return $author$project$Data$User$LoggedIn(user);
	} else {
		return $author$project$Data$User$LoggedOut;
	}
};
var $author$project$Pages$Authentication$LoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Authentication$Waiting = {$: 3};
var $author$project$Pages$Authentication$init = function (userstate) {
	switch (userstate.$) {
		case 0:
			return _Utils_Tuple2(
				A2($author$project$Pages$Authentication$LoggedOut, $elm$core$Maybe$Nothing, $author$project$Data$APITypes$emptyUserPass),
				$elm$core$Platform$Cmd$none);
		case 1:
			return _Utils_Tuple2(
				$author$project$Pages$Authentication$Waiting,
				$author$project$Requests$fetchProfile($author$project$Msg$APIProfileResult));
		default:
			var user = userstate.a;
			return _Utils_Tuple2(
				$author$project$Pages$Authentication$LoggedIn(user),
				$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Pages$Home$HidePopup = {$: 0};
var $author$project$Data$Outline$mapOutlineListHelper = F3(
	function (fn, outline, acc) {
		var newAcc = A2(
			$elm$core$List$cons,
			fn(outline),
			acc);
		return A3(
			$elm$core$List$foldl,
			function (o) {
				return A2($author$project$Data$Outline$mapOutlineListHelper, fn, o);
			},
			newAcc,
			$author$project$Data$Outline$getSubs(outline));
	});
var $author$project$Data$Outline$mapOutlineList = F2(
	function (fn, outline) {
		return $elm$core$List$reverse(
			A3($author$project$Data$Outline$mapOutlineListHelper, fn, outline, _List_Nil));
	});
var $author$project$Data$Outline$getEntry = function (_v0) {
	var x = _v0;
	return x.U;
};
var $author$project$Data$Outline$singleLevelKeywords = function (outline) {
	return $author$project$Data$Outline$getEntry(outline).b3;
};
var $author$project$Data$Outline$getKeywords = function (outline) {
	return $elm$core$List$concat(
		A2($author$project$Data$Outline$mapOutlineList, $author$project$Data$Outline$singleLevelKeywords, outline));
};
var $author$project$Pages$Home$loadKeywords = function (outlines) {
	return A3(
		$elm$core$Basics$composeR,
		$elm$core$List$map($elm$core$String$trim),
		A2($elm$core$Basics$composeR, $elm$core$Set$fromList, $elm$core$Set$toList),
		$elm$core$List$concat(
			A2($elm$core$List$map, $author$project$Data$Outline$getKeywords, outlines)));
};
var $author$project$Pages$Home$init = F2(
	function (res, errMsg) {
		var kw = $author$project$Pages$Home$loadKeywords(res);
		return {eM: $elm$core$Set$empty, bq: errMsg, b3: kw, aM: _List_Nil, a5: false, af: $author$project$Pages$Home$HidePopup, dH: res, bE: '', aT: '', _: res};
	});
var $author$project$Pages$Profile$GotSubs = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Profile$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Requests$Subs = {$: 7};
var $author$project$Data$APITypes$decodeSubscriptionList = A2(
	$elm$json$Json$Decode$field,
	'subscriptions',
	$elm$json$Json$Decode$list($author$project$Data$APITypes$decodeSubContent));
var $author$project$Requests$fetchSubs = function (handler) {
	return A3($author$project$Requests$fetchEndpoint, $author$project$Requests$Subs, handler, $author$project$Data$APITypes$decodeSubscriptionList);
};
var $author$project$Pages$Profile$init = F2(
	function (state, doclist) {
		var model = {
			w: $author$project$Pages$Profile$Loading('List Subscriptions'),
			b5: doclist,
			d$: state
		};
		var cmd = function () {
			switch (state.$) {
				case 0:
					return $elm$core$Platform$Cmd$none;
				case 1:
					return $elm$core$Platform$Cmd$none;
				default:
					return $author$project$Requests$fetchSubs($author$project$Pages$Profile$GotSubs);
			}
		}();
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Pages$Settings$init = F2(
	function (ssettings, vsettings) {
		return {
			Q: '',
			X: {dN: ssettings, d2: vsettings}
		};
	});
var $author$project$Views$Test$init = function (amodel) {
	return amodel;
};
var $author$project$Pages$Home$initViewingDoc = F3(
	function (doc, resultslist, errmsg) {
		var newModel = A2($author$project$Pages$Home$init, resultslist, errmsg);
		return _Utils_update(
			newModel,
			{
				a5: true,
				_: _List_fromArray(
					[doc.a9])
			});
	});
var $author$project$Pages$Home$initViewingItem = F3(
	function (ol, resultsList, errMsg) {
		var newModel = A2($author$project$Pages$Home$init, resultsList, errMsg);
		return _Utils_update(
			newModel,
			{
				a5: true,
				_: _List_fromArray(
					[ol])
			});
	});
var $author$project$Data$UrlQueue$isComplete = function (u) {
	_v0$2:
	while (true) {
		if (u.$ === 1) {
			switch (u.a.$) {
				case 2:
					var _v1 = u.a;
					return true;
				case 1:
					var i = u.a.a;
					return i < 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Data$UrlQueue$isEmpty = function (u) {
	if (u.$ === 1) {
		var urls = u.b;
		return $elm$core$Set$isEmpty(urls);
	} else {
		return true;
	}
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Utility$pair = F2(
	function (first, second) {
		return _Utils_Tuple2(first, second);
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Data$UrlQueue$Finished = {$: 2};
var $author$project$Data$UrlQueue$Requested = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$UrlQueue$received = function (u) {
	if ((u.$ === 1) && (u.a.$ === 1)) {
		var i = u.a.a;
		var urls = u.b;
		return (i === 1) ? A2($author$project$Data$UrlQueue$Urls, $author$project$Data$UrlQueue$Finished, urls) : A2(
			$author$project$Data$UrlQueue$Urls,
			$author$project$Data$UrlQueue$Requested(i - 1),
			urls);
	} else {
		return u;
	}
};
var $author$project$Data$ID$toString = function (id) {
	if (id.$ === 1) {
		var s = id.a;
		return s;
	} else {
		return '';
	}
};
var $author$project$Route$routeToString = function (page) {
	switch (page.$) {
		case 0:
			return '/';
		case 6:
			return '/about';
		case 8:
			return '/settings';
		case 9:
			return '/login';
		case 10:
			return '/test';
		case 7:
			return '/profile';
		case 5:
			return '/menu';
		case 1:
			var doc = page.a;
			return '/' + $author$project$Data$DocID$toString(doc);
		case 3:
			var doc = page.a;
			return '/' + ($author$project$Data$DocID$toString(doc) + '/search');
		case 4:
			var doc = page.a;
			var item = page.b;
			return '/' + ($author$project$Data$DocID$toString(doc) + ('/search/' + $author$project$Data$ID$toString(item)));
		default:
			var doc = page.a;
			var item = page.b;
			return '/' + ($author$project$Data$DocID$toString(doc) + ('/' + $author$project$Data$ID$toString(item)));
	}
};
var $author$project$Main$redirect = F2(
	function (model, route) {
		var url = $author$project$Route$routeToString(route);
		return A2($elm$browser$Browser$Navigation$pushUrl, model.a3, url);
	});
var $author$project$Msg$OnApiArticleInfoResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Requests$ArticleInfo = function (a) {
	return {$: 8, a: a};
};
var $author$project$Requests$fetchArticleInfo = F2(
	function (slug, handler) {
		return A3(
			$author$project$Requests$fetchEndpoint,
			$author$project$Requests$ArticleInfo(slug),
			handler,
			$author$project$Data$APITypes$decodeDocInfo);
	});
var $author$project$Data$UrlQueue$request = function (u) {
	if ((u.$ === 1) && (!u.a.$)) {
		var _v1 = u.a;
		var urls = u.b;
		var list = $elm$core$Set$toList(urls);
		return _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				function (x) {
					return A2($author$project$Requests$fetchArticleInfo, x, $author$project$Msg$OnApiArticleInfoResponse);
				},
				list),
			A2(
				$author$project$Data$UrlQueue$Urls,
				$author$project$Data$UrlQueue$Requested(
					$elm$core$List$length(list)),
				urls));
	} else {
		return _Utils_Tuple2(_List_Nil, u);
	}
};
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Main$scrollToElement = function (elID) {
	var noop = function (rea) {
		if (!rea.$) {
			return $author$project$Msg$NoOp('Success!');
		} else {
			var e = rea.a;
			return $author$project$Msg$NoOp('NotFound ' + e);
		}
	};
	return $elm$core$String$isEmpty(elID) ? $elm$core$Platform$Cmd$none : A2(
		$elm$core$Task$attempt,
		function (e) {
			return noop(e);
		},
		A2(
			$elm$core$Task$andThen,
			function (item) {
				return A2($elm$browser$Browser$Dom$setViewport, 0, item.e$.gN);
			},
			$elm$browser$Browser$Dom$getElement(elID)));
};
var $author$project$Main$scrollToTop = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Msg$NoOp('Scrolled to top');
	},
	A2($elm$browser$Browser$Dom$setViewport, 0, 0));
var $author$project$Main$setLoaded = function (state) {
	if (!state.$) {
		var pg = state.a;
		return $author$project$Main$Loaded(pg);
	} else {
		var pg = state.a;
		return $author$project$Main$Loaded(pg);
	}
};
var $author$project$Main$setTransitioningFrom = function (state) {
	if (!state.$) {
		var pg = state.a;
		return $author$project$Main$TransitioningFrom(pg);
	} else {
		var pg = state.a;
		return $author$project$Main$TransitioningFrom(pg);
	}
};
var $author$project$Pages$Profile$toDocList = function (model) {
	var _v0 = model.w;
	if (_v0.$ === 2) {
		var subs = _v0.b;
		var allDocOptions = A2(
			$elm$core$List$concatMap,
			function (sub) {
				return sub.T;
			},
			subs);
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					if ((!x.$) && (x.b.$ === 2)) {
						var _v2 = x.b;
						var doc = _v2.b;
						return A2($elm$core$List$cons, doc, acc);
					} else {
						return acc;
					}
				}),
			_List_Nil,
			allDocOptions);
	} else {
		return _List_Nil;
	}
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.dy;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.cV,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.dA,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.ds,
					_Utils_ap(http, url.c0)),
				url.dp)));
};
var $author$project$Pages$Authentication$APIError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$APILoginResult = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Authentication$ErrorEncountered = function (a) {
	return {$: 4, a: a};
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$auth0ClearSaved = _Platform_outgoingPort(
	'auth0ClearSaved',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Data$APITypes$encodeUserPass = function (u) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(u.a1)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(u.cb))
			]));
};
var $author$project$Data$APITypes$encodeSubLevel = function (s) {
	if (!s) {
		return $elm$json$Json$Encode$string('Basic');
	} else {
		return $elm$json$Json$Encode$string('Pro');
	}
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Data$APITypes$encodeUserProfile = function (u) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'profile',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'userId',
							$elm$json$Json$Encode$int(u.d_)),
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(u.a1)),
							_Utils_Tuple2(
							'creationDate',
							$elm$json$Json$Encode$string(u.cK)),
							_Utils_Tuple2(
							'subscriptions',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, u.dV)),
							_Utils_Tuple2(
							'level',
							$author$project$Data$APITypes$encodeSubLevel(u.dS))
						])))
			]));
};
var $author$project$Pages$Authentication$isLoggedIn = function (model) {
	if (model.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Requests$Login = {$: 0};
var $author$project$Requests$apiMessageDecoder = A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string);
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Requests$loginToAPI = F2(
	function (userpass, handler) {
		return $elm$http$Http$riskyRequest(
			{
				bR: $elm$http$Http$jsonBody(userpass),
				bV: A2($author$project$Requests$expectStringWithErrJson, handler, $author$project$Requests$apiMessageDecoder),
				bY: _List_fromArray(
					[$author$project$Requests$acceptHeader]),
				b7: 'POST',
				cp: $elm$core$Maybe$Nothing,
				cq: $elm$core$Maybe$Nothing,
				gJ: $author$project$Requests$endPointToString($author$project$Requests$Login)
			});
	});
var $author$project$Ports$storeProfile = _Platform_outgoingPort('storeProfile', $elm$core$Basics$identity);
var $elm$core$String$toLower = _String_toLower;
var $author$project$Data$User$updateUser = F2(
	function (user, apiuser) {
		return apiuser;
	});
var $author$project$Pages$Authentication$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var lmsg = msg.a;
				var currUserPass = function () {
					if ((!model.$) && (model.a.$ === 1)) {
						var _v3 = model.a;
						var up = model.b;
						return up;
					} else {
						return $author$project$Data$APITypes$emptyUserPass;
					}
				}();
				switch (lmsg.$) {
					case 0:
						var s = lmsg.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Pages$Authentication$LoggedOut,
								$elm$core$Maybe$Nothing,
								_Utils_update(
									currUserPass,
									{
										a1: $elm$core$String$toLower(s)
									})),
							$elm$core$Platform$Cmd$none);
					case 1:
						var s = lmsg.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Pages$Authentication$LoggedOut,
								$elm$core$Maybe$Nothing,
								_Utils_update(
									currUserPass,
									{cb: s})),
							$elm$core$Platform$Cmd$none);
					case 2:
						var userpass = lmsg.a;
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Requests$loginToAPI,
								$author$project$Data$APITypes$encodeUserPass(userpass),
								$author$project$Msg$APILoginResult));
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var responseResult = msg.a;
				if ($author$project$Pages$Authentication$isLoggedIn(model)) {
					return _Utils_Tuple2(
						model,
						$author$project$Requests$fetchProfile($author$project$Msg$APIProfileResult));
				} else {
					if (!responseResult.$) {
						var s = responseResult.a;
						return _Utils_Tuple2(
							model,
							$author$project$Requests$fetchProfile($author$project$Msg$APIProfileResult));
					} else {
						var errmsg = responseResult.a;
						switch (errmsg.$) {
							case 2:
								return _Utils_Tuple2(
									A2(
										$author$project$Pages$Authentication$LoggedOut,
										$elm$core$Maybe$Just('Your session has expired. Please log in again'),
										$author$project$Data$APITypes$emptyUserPass),
									$author$project$Ports$auth0ClearSaved(0));
							case 0:
								return _Utils_Tuple2(
									A2(
										$author$project$Pages$Authentication$LoggedOut,
										$elm$core$Maybe$Just('Incorrect Email or Password. Please try again.'),
										$author$project$Data$APITypes$emptyUserPass),
									$author$project$Ports$auth0ClearSaved(0));
							case 1:
								return _Utils_Tuple2(
									A2(
										$author$project$Pages$Authentication$LoggedOut,
										$elm$core$Maybe$Just('No such user. Please try again or Click below to Sign Up.'),
										$author$project$Data$APITypes$emptyUserPass),
									$author$project$Ports$auth0ClearSaved(0));
							case 3:
								return _Utils_Tuple2(
									$author$project$Pages$Authentication$ErrorEncountered(
										$author$project$Pages$Authentication$APIError(errmsg)),
									$author$project$Ports$auth0ClearSaved(0));
							default:
								return _Utils_Tuple2(
									$author$project$Pages$Authentication$ErrorEncountered(
										$author$project$Pages$Authentication$APIError(errmsg)),
									$author$project$Ports$auth0ClearSaved(0));
						}
					}
				}
			case 3:
				var responseResult = msg.a;
				if (!responseResult.$) {
					var apiProfile = responseResult.a;
					switch (model.$) {
						case 4:
							var e = model.a;
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 1:
							var user = model.a;
							var newUser = A2($author$project$Data$User$updateUser, user, apiProfile);
							return _Utils_Tuple2(
								$author$project$Pages$Authentication$LoggedIn(newUser),
								$author$project$Ports$storeProfile(
									$author$project$Data$APITypes$encodeUserProfile(newUser)));
						case 2:
							var user = model.a;
							var newUser = A2($author$project$Data$User$updateUser, user, apiProfile);
							return _Utils_Tuple2(
								$author$project$Pages$Authentication$LoggedIn(newUser),
								$author$project$Ports$storeProfile(
									$author$project$Data$APITypes$encodeUserProfile(newUser)));
						case 0:
							return _Utils_Tuple2(
								$author$project$Pages$Authentication$LoggedIn(apiProfile),
								$author$project$Ports$storeProfile(
									$author$project$Data$APITypes$encodeUserProfile(apiProfile)));
						default:
							return _Utils_Tuple2(
								$author$project$Pages$Authentication$LoggedIn(apiProfile),
								$author$project$Ports$storeProfile(
									$author$project$Data$APITypes$encodeUserProfile(apiProfile)));
					}
				} else {
					var errmsg = responseResult.a;
					return _Utils_Tuple2(
						$author$project$Pages$Authentication$ErrorEncountered(
							$author$project$Pages$Authentication$APIError(errmsg)),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					A2($author$project$Pages$Authentication$LoggedOut, $elm$core$Maybe$Nothing, $author$project$Data$APITypes$emptyUserPass),
					$author$project$Ports$auth0ClearSaved(0));
		}
	});
var $author$project$Data$Citation$Long = 2;
var $author$project$Pages$Home$ShowCPopup = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Home$ShowCollectionPopup = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Pages$Home$ShowDIPopup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Outline$CollectionDocument = {$: 10};
var $author$project$Data$Outline$getCurrentCiteLevel = function (ol) {
	var ent = $author$project$Data$Outline$getEntry(ol);
	return ent.cI;
};
var $author$project$Data$Outline$getCurrentDocLevel = function (ol) {
	var ent = $author$project$Data$Outline$getEntry(ol);
	return ent.cO;
};
var $author$project$Pages$Home$createCollectionOutline = F2(
	function (parentOutline, collectedOutlines) {
		var internal = parentOutline;
		return A4(
			$author$project$Data$Outline$makeOL,
			A9(
				$author$project$Data$Outline$Entry,
				$author$project$Data$ID$fromString('collection'),
				$author$project$Data$Outline$getCurrentCiteLevel(parentOutline),
				$author$project$Data$Outline$getCurrentDocLevel(parentOutline),
				'Collected ' + ($elm$core$String$fromInt(
					$elm$core$List$length(collectedOutlines)) + ' entries.'),
				$author$project$Data$Outline$CollectionDocument,
				_List_Nil,
				'',
				$elm$core$Maybe$Nothing,
				''),
			$author$project$Data$Outline$getParentDocumentID(parentOutline),
			function ($) {
				return $.bk;
			}(internal),
			collectedOutlines);
	});
var $author$project$Data$Outline$filterHelper = F3(
	function (predicate, outlineList, startAcc) {
		var fn = F2(
			function (outline, acc) {
				var o = outline;
				if (predicate(outline)) {
					var newOutline = outline;
					return A3(
						$author$project$Data$Outline$filterHelper,
						predicate,
						o.Z,
						A2($elm$core$List$cons, newOutline, acc));
				} else {
					return A3($author$project$Data$Outline$filterHelper, predicate, o.Z, acc);
				}
			});
		return A3($elm$core$List$foldl, fn, startAcc, outlineList);
	});
var $author$project$Data$Outline$filter = F2(
	function (predicate, outline) {
		var x = outline;
		var startAcc = predicate(outline) ? _List_fromArray(
			[outline]) : _List_Nil;
		return $elm$core$List$reverse(
			A3($author$project$Data$Outline$filterHelper, predicate, x.Z, startAcc));
	});
var $author$project$Data$Citation$Short = 0;
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Data$Outline$getYear = function (sDate) {
	if (!sDate.$) {
		var date = sDate.a;
		var dateParts = A2($elm$core$String$split, '-', date);
		return $elm$core$List$head(dateParts);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Citation$getNum = function (filename) {
	if (!filename.$) {
		var o = filename.a;
		return o.bx;
	} else {
		var c = filename.a;
		return c.bx;
	}
};
var $author$project$Data$Citation$getPartOrID = function (filename) {
	if (!filename.$) {
		var o = filename.a;
		return o.dh;
	} else {
		var c = filename.a;
		return c.$7;
	}
};
var $author$project$Data$Citation$joinSectionLabelsHelper = F2(
	function (labelList, acc) {
		joinSectionLabelsHelper:
		while (true) {
			var isWords = function (s) {
				return $elm$core$String$length(s) > 3;
			};
			var isSingleAlpha = function (s) {
				return A2(
					$elm$core$List$member,
					s,
					_List_fromArray(
						['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']));
			};
			var isRoman = function (s) {
				return A2(
					$elm$core$List$member,
					s,
					_List_fromArray(
						['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x', 'xi', 'xii', 'xiii', 'xiv', 'xv', 'xvi', 'xvii', 'xviii', 'xix', 'xx', 'xxi', 'xxii', 'xxiii', 'xxiv', 'xxv', 'xxvi', 'xxvii', 'xxviii', 'xxix', 'xxx']));
			};
			var bracket = function (x) {
				return isSingleAlpha(x) ? ('(' + (x + ')')) : (isRoman(x) ? ('(' + (x + ')')) : (isWords(x) ? (': ' + x) : (x + '.')));
			};
			if (!labelList.b) {
				return (A2($elm$core$String$right, 1, acc) === '.') ? A2($elm$core$String$dropRight, 1, acc) : acc;
			} else {
				var x = labelList.a;
				var xs = labelList.b;
				var $temp$labelList = xs,
					$temp$acc = _Utils_ap(
					acc,
					bracket(x));
				labelList = $temp$labelList;
				acc = $temp$acc;
				continue joinSectionLabelsHelper;
			}
		}
	});
var $author$project$Data$Citation$joinSectionLabels = function (labelList) {
	return A3(
		$elm$core$String$replace,
		'.:',
		':',
		A3(
			$elm$core$String$replace,
			'.(',
			'(',
			A2($author$project$Data$Citation$joinSectionLabelsHelper, labelList, '')));
};
var $author$project$Data$Citation$cfrAPACitation = F3(
	function (cit, year, docName) {
		return docName + (', ' + ($author$project$Data$Citation$getNum(cit.G) + (' C.F.R. Pt. ' + ($author$project$Data$Citation$getPartOrID(cit.G) + ('.' + ($author$project$Data$Citation$joinSectionLabels(cit.aU) + (' (' + (year + ').'))))))));
	});
var $author$project$Data$Citation$cfrChicagoCitation = F5(
	function (agency, cit, year, docName, link) {
		var publisher = 'Office of the Federal Register, Washington DC';
		return agency + (' (' + (year + ('), ' + (docName + (', ' + ($author$project$Data$Citation$getNum(cit.G) + (' C.F.R. Pt. ' + ($author$project$Data$Citation$getPartOrID(cit.G) + ('.' + ($author$project$Data$Citation$joinSectionLabels(cit.aU) + (', ' + (publisher + (', ' + (link + '.'))))))))))))));
	});
var $author$project$Data$Citation$cfrShortCitation = F2(
	function (cit, year) {
		return $author$project$Data$Citation$getNum(cit.G) + (' CFR §' + ($author$project$Data$Citation$getPartOrID(cit.G) + ('.' + $author$project$Data$Citation$joinSectionLabels(cit.aU))));
	});
var $author$project$Data$Citation$joinOECDDocumentSections = function (cit) {
	var labels = $author$project$Data$Citation$joinSectionLabels(cit.aU);
	return $elm$core$String$isEmpty(labels) ? cit.bF : ((A2($elm$core$String$left, 1, labels) === ':') ? _Utils_ap(cit.bF, labels) : (cit.bF + ('.' + labels)));
};
var $author$project$Data$Citation$oecdChicagoCitation = F4(
	function (cit, year, docName, link) {
		var seriesName = 'OECD Series on Principles of Good Laboratory Practice and Compliance Monitoring';
		var publisherInfo = 'OECD Publishing, Paris';
		return 'OECD (' + (year + ('), ' + (docName + (', ' + ($author$project$Data$Citation$joinOECDDocumentSections(cit) + (', ' + (seriesName + (', ' + ('No. ' + ($author$project$Data$Citation$getNum(cit.G) + (', ' + (publisherInfo + (', ' + (link + '.'))))))))))))));
	});
var $author$project$Data$Citation$getYear2 = function (filename) {
	if (!filename.$) {
		var o = filename.a;
		return o.di;
	} else {
		var c = filename.a;
		return 'XX';
	}
};
var $author$project$Data$Citation$oecdLegalCitation = F3(
	function (cit, year, docName) {
		var year2 = $author$project$Data$Citation$getYear2(cit.G);
		var pubnum = $author$project$Data$Citation$getPartOrID(cit.G);
		return 'ENV/MC/CHEM(' + (year2 + (')' + (pubnum + (' \"' + (docName + ('\", (' + (year + ('), ' + ($author$project$Data$Citation$joinOECDDocumentSections(cit) + '.')))))))));
	});
var $author$project$Data$Citation$oecdShortCitation = F2(
	function (cit, year) {
		return 'OECD GLPs #' + ($author$project$Data$Citation$getNum(cit.G) + (': ' + $author$project$Data$Citation$joinOECDDocumentSections(cit)));
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $author$project$Data$Citation$CitationData = F3(
	function (fileName, sectionName, sectionLabels) {
		return {G: fileName, aU: sectionLabels, bF: sectionName};
	});
var $elm$parser$Parser$Forbidden = 0;
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {bS: col, eQ: contextStack, dv: problem, ce: row};
	});
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.e, s.ce, s.bS, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.i)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.e, newOffset) < 0,
			0,
			{bS: newCol, i: s.i, k: s.k, e: newOffset, ce: newRow, a: s.a});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.e, s.ce, s.bS, s.a);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.a) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.e, adjustedOffset) < 0,
			0,
			{bS: newCol, i: s.i, k: s.k, e: adjustedOffset, ce: newRow, a: s.a});
	};
};
var $elm$parser$Parser$chompUntilEndOr = $elm$parser$Parser$Advanced$chompUntilEndOr;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.e, s1.e, s0.a),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $author$project$Data$Citation$CFRFileName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Citation$OECDFileName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Citation$CFRData = F2(
	function (num, part) {
		return {bx: num, $7: part};
	});
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.ce, s.bS, x, s.i));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.e, s.ce, s.bS, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.a))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{bS: newCol, i: s.i, k: s.k, e: newOffset, ce: newRow, a: s.a});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.e, offset) < 0,
					0,
					{bS: col, i: s0.i, k: s0.k, e: offset, ce: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.e, s.ce, s.bS, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $author$project$Data$Citation$numerals = $elm$parser$Parser$getChompedString(
	$elm$parser$Parser$chompWhile($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.e, s.ce, s.bS, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{bS: newCol, i: s.i, k: s.k, e: newOffset, ce: newRow, a: s.a});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $author$project$Data$Citation$parseCFR = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($author$project$Data$Citation$CFRData),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$author$project$Data$Citation$numerals,
							$elm$parser$Parser$symbol('-')),
						$elm$parser$Parser$keyword('CFR')),
					$elm$parser$Parser$symbol('-')),
				$elm$parser$Parser$keyword('Pt')),
			$elm$parser$Parser$symbol('-'))),
	$author$project$Data$Citation$numerals);
var $author$project$Data$Citation$OECDData = F3(
	function (num, oecdYear2, oecdID) {
		return {bx: num, dh: oecdID, di: oecdYear2};
	});
var $author$project$Data$Citation$parseOECD = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($author$project$Data$Citation$OECDData),
							$elm$parser$Parser$keyword('OECD')),
						$elm$parser$Parser$symbol('-')),
					$elm$parser$Parser$keyword('GLP')),
				$elm$parser$Parser$symbol('-')),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Data$Citation$numerals,
				$elm$parser$Parser$symbol('-'))),
		A2(
			$elm$parser$Parser$ignorer,
			$author$project$Data$Citation$numerals,
			$elm$parser$Parser$symbol('-'))),
	$author$project$Data$Citation$numerals);
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $author$project$Data$Citation$parseFilename = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$Data$Citation$CFRFileName),
			$elm$parser$Parser$backtrackable($author$project$Data$Citation$parseCFR)),
			A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$Data$Citation$OECDFileName),
			$elm$parser$Parser$backtrackable($author$project$Data$Citation$parseOECD)),
			$elm$parser$Parser$problem('Failed to parse FileName')
		]));
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$revAlways = F2(
	function (_v0, b) {
		return b;
	});
var $elm$parser$Parser$Advanced$skip = F2(
	function (iParser, kParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$parser$Parser$Advanced$revAlways, iParser, kParser);
	});
var $elm$parser$Parser$Advanced$sequenceEndForbidden = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var chompRest = function (item) {
			return A5(
				$elm$parser$Parser$Advanced$sequenceEndForbidden,
				ender,
				ws,
				parseItem,
				sep,
				A2($elm$core$List$cons, item, revItems));
		};
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$map,
								function (item) {
									return $elm$parser$Parser$Advanced$Loop(
										A2($elm$core$List$cons, item, revItems));
								},
								parseItem))),
						A2(
						$elm$parser$Parser$Advanced$map,
						function (_v0) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(revItems));
						},
						ender)
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEndMandatory = F4(
	function (ws, parseItem, sep, revItems) {
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (item) {
						return $elm$parser$Parser$Advanced$Loop(
							A2($elm$core$List$cons, item, revItems));
					},
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						parseItem,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							ws,
							A2($elm$parser$Parser$Advanced$ignorer, sep, ws)))),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(
							$elm$core$List$reverse(revItems));
					},
					$elm$parser$Parser$Advanced$succeed(0))
				]));
	});
var $elm$parser$Parser$Advanced$sequenceEndOptional = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var parseEnd = A2(
			$elm$parser$Parser$Advanced$map,
			function (_v0) {
				return $elm$parser$Parser$Advanced$Done(
					$elm$core$List$reverse(revItems));
			},
			ender);
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							$elm$parser$Parser$Advanced$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$Advanced$map,
										function (item) {
											return $elm$parser$Parser$Advanced$Loop(
												A2($elm$core$List$cons, item, revItems));
										},
										parseItem),
										parseEnd
									])))),
						parseEnd
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEnd = F5(
	function (ender, ws, parseItem, sep, trailing) {
		var chompRest = function (item) {
			switch (trailing) {
				case 0:
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndForbidden, ender, ws, parseItem, sep));
				case 1:
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndOptional, ender, ws, parseItem, sep));
				default:
					return A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$skip,
								sep,
								A2(
									$elm$parser$Parser$Advanced$skip,
									ws,
									A2(
										$elm$parser$Parser$Advanced$loop,
										_List_fromArray(
											[item]),
										A3($elm$parser$Parser$Advanced$sequenceEndMandatory, ws, parseItem, sep))))),
						ender);
			}
		};
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2($elm$parser$Parser$Advanced$andThen, chompRest, parseItem),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					ender)
				]));
	});
var $elm$parser$Parser$Advanced$sequence = function (i) {
	return A2(
		$elm$parser$Parser$Advanced$skip,
		$elm$parser$Parser$Advanced$token(i.gg),
		A2(
			$elm$parser$Parser$Advanced$skip,
			i.gd,
			A5(
				$elm$parser$Parser$Advanced$sequenceEnd,
				$elm$parser$Parser$Advanced$token(i.e0),
				i.gd,
				i.fv,
				$elm$parser$Parser$Advanced$token(i.f6),
				i.gG)));
};
var $elm$parser$Parser$Advanced$Forbidden = 0;
var $elm$parser$Parser$Advanced$Mandatory = 2;
var $elm$parser$Parser$Advanced$Optional = 1;
var $elm$parser$Parser$toAdvancedTrailing = function (trailing) {
	switch (trailing) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $elm$parser$Parser$sequence = function (i) {
	return $elm$parser$Parser$Advanced$sequence(
		{
			e0: $elm$parser$Parser$toToken(i.e0),
			fv: i.fv,
			f6: $elm$parser$Parser$toToken(i.f6),
			gd: i.gd,
			gg: $elm$parser$Parser$toToken(i.gg),
			gG: $elm$parser$Parser$toAdvancedTrailing(i.gG)
		});
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $elm$parser$Parser$spaces = $elm$parser$Parser$Advanced$spaces;
var $author$project$Data$Citation$parseLeaf = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$Data$Citation$CitationData),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Data$Citation$parseFilename,
				$elm$parser$Parser$symbol('.'))),
		$elm$parser$Parser$getChompedString(
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompUntil('.')))),
	$elm$parser$Parser$sequence(
		{
			e0: '',
			fv: $elm$parser$Parser$getChompedString(
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$chompUntilEndOr('.'))),
			f6: '.',
			gd: $elm$parser$Parser$spaces,
			gg: '.',
			gG: 0
		}));
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.a),
			s.e) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $author$project$Data$Citation$parseTopDocument = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$Data$Citation$CitationData),
			A2($elm$parser$Parser$ignorer, $author$project$Data$Citation$parseFilename, $elm$parser$Parser$end)),
		$elm$parser$Parser$succeed('')),
	$elm$parser$Parser$succeed(_List_Nil));
var $author$project$Data$Citation$parseTopLevelSection = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($author$project$Data$Citation$CitationData),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Data$Citation$parseFilename,
				$elm$parser$Parser$symbol('.'))),
		$elm$parser$Parser$getChompedString(
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompUntilEndOr('.')))),
	$elm$parser$Parser$succeed(_List_Nil));
var $author$project$Data$Citation$parseCitation = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$backtrackable($author$project$Data$Citation$parseLeaf),
			$elm$parser$Parser$backtrackable($author$project$Data$Citation$parseTopLevelSection),
			$author$project$Data$Citation$parseTopDocument
		]));
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$String$fromList = _String_fromList;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$Utility$toUnderlineChar = F4(
	function (minCol, maxCol, col, _char) {
		return ((_Utils_cmp(minCol, col) < 1) && (_Utils_cmp(col, maxCol) < 1)) ? '^' : ((_char === '\t') ? '\t' : ' ');
	});
var $author$project$Utility$makeUnderline = F3(
	function (row, minCol, maxCol) {
		return (row === '') ? '^' : $elm$core$String$fromList(
			A2(
				$elm$core$List$indexedMap,
				A2($author$project$Utility$toUnderlineChar, minCol, maxCol),
				$elm$core$String$toList(row)));
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Utility$printDeadEnd = F2(
	function (s, d) {
		var lines = A2($elm$core$String$split, '\n', s);
		var source = A2(
			$elm$core$String$join,
			'\n|   ',
			A2(
				$elm$core$List$take,
				4,
				A2($elm$core$List$drop, d.ce - 5, lines)));
		var later2 = A2(
			$elm$core$String$join,
			'\n|   ',
			A2(
				$elm$core$List$take,
				2,
				A2($elm$core$List$drop, d.ce, lines)));
		return A2(
			$elm$core$String$join,
			'\n',
			_List_fromArray(
				[
					'---Start Deadend---',
					'|   ' + source,
					'    ' + A3($author$project$Utility$makeUnderline, source, d.bS - 1, d.bS + 1),
					'|   ' + later2,
					A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'',
							'(' + ($elm$core$String$fromInt(d.ce) + (',' + ($elm$core$String$fromInt(d.bS) + ')'))),
							''
						])),
					'',
					'---End DeadEnd---'
				]));
	});
var $author$project$Utility$printDeadEnds = F2(
	function (s, de) {
		return A2(
			$elm$core$String$join,
			'\n',
			A2(
				$elm$core$List$map,
				$author$project$Utility$printDeadEnd(s),
				de));
	});
var $author$project$Data$Citation$parseCitationError = F2(
	function (s, err) {
		return 'Error: there was a problem parsing the citation for ' + (s + (': ' + A2($author$project$Utility$printDeadEnds, s, err)));
	});
var $author$project$Data$Citation$removePercentSymbol = A2($elm$core$String$replace, '%', '');
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {bS: col, dv: problem, ce: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.ce, p.bS, p.dv);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{bS: 1, i: _List_Nil, k: 1, e: 0, ce: 1, a: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $author$project$Data$Citation$readCitation = F5(
	function (citn, docName, myear, link, citationStyle) {
		var rYear = A2($elm$core$Result$fromMaybe, 'Failed parsing the year', myear);
		switch (citn.$) {
			case 3:
				var s = citn.a;
				var raw = $author$project$Data$Citation$removePercentSymbol(s);
				var rCit = A2(
					$elm$core$Result$mapError,
					$author$project$Data$Citation$parseCitationError(raw),
					A2($elm$parser$Parser$run, $author$project$Data$Citation$parseCitation, raw));
				switch (citationStyle) {
					case 0:
						return A3($elm$core$Result$map2, $author$project$Data$Citation$oecdShortCitation, rCit, rYear);
					case 1:
						return A3(
							$elm$core$Result$map2,
							F2(
								function (ct, yr) {
									return A3($author$project$Data$Citation$oecdLegalCitation, ct, yr, docName);
								}),
							rCit,
							rYear);
					case 2:
						return A3(
							$elm$core$Result$map2,
							F2(
								function (ct, yr) {
									return A4($author$project$Data$Citation$oecdChicagoCitation, ct, yr, docName, link);
								}),
							rCit,
							rYear);
					default:
						return $elm$core$Result$Ok(s);
				}
			case 1:
				var s = citn.a;
				var raw = $author$project$Data$Citation$removePercentSymbol(s);
				var rcit = A2(
					$elm$core$Result$mapError,
					$author$project$Data$Citation$parseCitationError(s),
					A2($elm$parser$Parser$run, $author$project$Data$Citation$parseCitation, raw));
				switch (citationStyle) {
					case 0:
						return A3($elm$core$Result$map2, $author$project$Data$Citation$cfrShortCitation, rcit, rYear);
					case 1:
						return A3(
							$elm$core$Result$map2,
							F2(
								function (cit, year) {
									return A3($author$project$Data$Citation$cfrAPACitation, cit, year, docName);
								}),
							rcit,
							rYear);
					case 2:
						return A3(
							$elm$core$Result$map2,
							F2(
								function (cit, year) {
									return A5($author$project$Data$Citation$cfrChicagoCitation, 'FDA', cit, year, docName, link);
								}),
							rcit,
							rYear);
					default:
						return $elm$core$Result$Ok(s);
				}
			case 2:
				var s = citn.a;
				var raw = $author$project$Data$Citation$removePercentSymbol(s);
				var rcit = A2(
					$elm$core$Result$mapError,
					$author$project$Data$Citation$parseCitationError(s),
					A2($elm$parser$Parser$run, $author$project$Data$Citation$parseCitation, raw));
				switch (citationStyle) {
					case 0:
						return A3($elm$core$Result$map2, $author$project$Data$Citation$cfrShortCitation, rcit, rYear);
					case 1:
						return A3(
							$elm$core$Result$map2,
							F2(
								function (cit, year) {
									return A3($author$project$Data$Citation$cfrAPACitation, cit, year, docName);
								}),
							rcit,
							rYear);
					case 2:
						return A3(
							$elm$core$Result$map2,
							F2(
								function (cit, year) {
									return A5($author$project$Data$Citation$cfrChicagoCitation, 'EPA', cit, year, docName, link);
								}),
							rcit,
							rYear);
					default:
						return $elm$core$Result$Ok(s);
				}
			default:
				return $elm$core$Result$Ok('');
		}
	});
var $author$project$Data$Outline$getCitation = F3(
	function (outline, cstyle, doc) {
		var x = outline;
		var year = $author$project$Data$Outline$getYear(doc.dz);
		var citn = function ($) {
			return $.bk;
		}(x);
		var _v0 = A5($author$project$Data$Citation$readCitation, citn, doc.gD, year, doc.c9, cstyle);
		if (!_v0.$) {
			var citation = _v0.a;
			return citation;
		} else {
			var msg = _v0.a;
			return 'There was a problem getting the citation. Please Try again later.';
		}
	});
var $author$project$Data$DocID$empty = $author$project$Data$DocID$EmptyID;
var $author$project$Data$ID$EmptyID = {$: 0};
var $author$project$Data$ID$empty = $author$project$Data$ID$EmptyID;
var $author$project$Data$Outline$emptyOutline = A4(
	$author$project$Data$Outline$makeOL,
	A9($author$project$Data$Outline$Entry, $author$project$Data$ID$empty, '', '', 'Empty', $author$project$Data$Outline$Article, _List_Nil, '', $elm$core$Maybe$Nothing, ''),
	$author$project$Data$DocID$empty,
	$author$project$Data$Citation$NoCitation,
	_List_Nil);
var $author$project$Data$Outline$emptyDoc = $author$project$Data$Outline$Doc($author$project$Data$DocID$empty)(
	$author$project$Data$Citation$FDA('citation'))('www.example.com')('info')('fineprint')(
	$elm$core$Result$Err('Empty Document'))(
	$elm$core$Result$Err('Empty Document'))('ignored')('title')('shortTitle')(
	_List_fromArray(
		['keyword']))($author$project$Data$Outline$emptyOutline)('1.0');
var $author$project$Data$Outline$getDoc = F2(
	function (outline, doclist) {
		var docid = $author$project$Data$Outline$getParentDocumentID(outline);
		var mdoc = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (x) {
					return _Utils_eq(x.R, docid);
				},
				doclist));
		if (!mdoc.$) {
			var doc = mdoc.a;
			return doc;
		} else {
			return $author$project$Data$Outline$emptyDoc;
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $author$project$Pages$Home$formatEntryContent = F2(
	function (session, outline) {
		var subContent = function () {
			var createSubItem = function (ol) {
				var subEnt = $author$project$Data$Outline$getEntry(ol);
				return function ($) {
					return $.cI;
				}(subEnt) + (') ' + function ($) {
					return $.eO;
				}(subEnt));
			};
			return A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					createSubItem,
					$author$project$Data$Outline$getSubs(outline)));
		}();
		var entry = $author$project$Data$Outline$getEntry(outline);
		var title = function ($) {
			return $.gD;
		}(entry);
		var entitledContent = A2($elm$core$String$startsWith, 'means', entry.eO) ? (title + (' ' + function ($) {
			return $.eO;
		}(entry))) : function ($) {
			return $.eO;
		}(entry);
		var rolledUpContent = A2($elm$core$String$endsWith, ':', entitledContent) ? (entitledContent + ('\n\n' + subContent)) : entitledContent;
		var doc = A2($author$project$Data$Outline$getDoc, outline, session.b4);
		var content = rolledUpContent;
		var lines = ($elm$core$String$isEmpty(title) || $elm$core$String$isEmpty(content)) ? '' : (A2(
			$elm$core$String$repeat,
			$elm$core$String$length(
				function ($) {
					return $.gD;
				}(entry)),
			'-') + '\n');
		var citation = A3($author$project$Data$Outline$getCitation, outline, 0, doc);
		return A2(
			$elm$core$String$join,
			'\n',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				_List_fromArray(
					[title, lines, content, '\n[' + (citation + ']')])));
	});
var $author$project$Data$Session$docInfoToDoc = F2(
	function (docInfo, session) {
		var pred = function (doc) {
			return _Utils_eq(doc.R, docInfo.c2);
		};
		var docList = session.b4;
		var results = A2($elm$core$List$filter, pred, docList);
		return $elm$core$List$head(results);
	});
var $author$project$Utility$maybeToList = function (mlist) {
	return A2($elm$core$List$filterMap, $elm$core$Basics$identity, mlist);
};
var $author$project$Data$Session$getSearchableDocs = function (session) {
	var mList = A2(
		$elm$core$List$map,
		function (x) {
			return A2($author$project$Data$Session$docInfoToDoc, x, session);
		},
		session.cg);
	return $author$project$Utility$maybeToList(mList);
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Data$Outline$count = function (outline) {
	var cnt = function (_v0) {
		var x = _v0;
		return x.cs;
	};
	return $elm$core$List$length(
		A2($author$project$Data$Outline$mapOutlineList, cnt, outline));
};
var $author$project$Data$SearchInfo$NotSearched = {$: 1};
var $author$project$Data$Outline$getOLType = function (_v0) {
	var ol = _v0;
	return ol.U.a6;
};
var $author$project$Data$Outline$getSearchInfo = function (outline) {
	var _v0 = $author$project$Data$Outline$getOLType(outline);
	if (_v0.$ === 9) {
		var x = _v0.a;
		return x;
	} else {
		return $author$project$Data$SearchInfo$NotSearched;
	}
};
var $author$project$Data$SearchInfo$getSearchRating = function (si) {
	if (si.$ === 1) {
		return _List_Nil;
	} else {
		var r = si.a;
		return function ($) {
			return $.dM;
		}(r);
	}
};
var $author$project$Data$SearchSettings$filterFunction = function (searchTermSettings) {
	switch (searchTermSettings) {
		case 0:
			return $elm$core$Basics$identity;
		case 2:
			return $elm$core$Basics$identity;
		case 1:
			var listRating = function (outline) {
				return $author$project$Data$SearchInfo$getSearchRating(
					$author$project$Data$Outline$getSearchInfo(outline));
			};
			var isNone = function (rating) {
				if (!rating.$) {
					return true;
				} else {
					return false;
				}
			};
			var hasNoNones = function (outline) {
				return !A2(
					$elm$core$List$any,
					isNone,
					listRating(outline));
			};
			return function (list) {
				return A2($elm$core$List$filter, hasNoNones, list);
			};
		default:
			var listRating = function (outline) {
				return $author$project$Data$SearchInfo$getSearchRating(
					$author$project$Data$Outline$getSearchInfo(outline));
			};
			var isKeyword = function (rating) {
				if (rating.$ === 3) {
					return true;
				} else {
					return false;
				}
			};
			var hasKeyword = function (outline) {
				return A2(
					$elm$core$List$any,
					isKeyword,
					listRating(outline));
			};
			return function (list) {
				return A2($elm$core$List$filter, hasKeyword, list);
			};
	}
};
var $author$project$Search$Prepared = $elm$core$Basics$identity;
var $author$project$Search$wholeWordsRegex = function (wd) {
	var last = A2($elm$core$String$right, 1, wd);
	return A2(
		$elm$core$List$member,
		last,
		_List_fromArray(
			[',', '.', ';', '!', '?', ':'])) ? A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('\\b' + wd)) : A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('\\b' + (wd + '\\b')));
};
var $author$project$Search$createPhrasesFromSynonyms = F3(
	function (mWord, phrase, listOfSynonyms) {
		if (!mWord.$) {
			var wd = mWord.a;
			var replaceSynonym = function (syn) {
				return A3(
					$elm$regex$Regex$replace,
					$author$project$Search$wholeWordsRegex(wd),
					function (_v1) {
						return syn;
					},
					phrase);
			};
			return A2($elm$core$List$map, replaceSynonym, listOfSynonyms);
		} else {
			return _List_Nil;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Search$hasWordWithSynonyms = F2(
	function (phrase, listOfSynonyms) {
		return $elm$core$List$head(
			$elm_community$maybe_extra$Maybe$Extra$values(
				A2(
					$elm$core$List$map,
					function (syn) {
						return A2($elm$core$String$contains, syn, phrase) ? $elm$core$Maybe$Just(syn) : $elm$core$Maybe$Nothing;
					},
					listOfSynonyms)));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Search$listWithDefault = F2(
	function (item, list) {
		return $elm$core$List$isEmpty(list) ? item : list;
	});
var $author$project$Search$synonymLists = _List_fromArray(
	[
		_List_fromArray(
		['study plan', 'study protocol', 'sp']),
		_List_fromArray(
		['plan', 'protocol']),
		_List_fromArray(
		['study director', 'sd']),
		_List_fromArray(
		['quality assurance', 'quality assurance unit', 'quality assurance personnel', 'qa', 'qau']),
		_List_fromArray(
		['experimental start date', 'esd', 'experimental starting date']),
		_List_fromArray(
		['experimental finish date', 'efd', 'ecd', 'experimental completion date']),
		_List_fromArray(
		['study initiation date', 'sid']),
		_List_fromArray(
		['study completion date', 'scd']),
		_List_fromArray(
		['nonclinical', 'non-clinical', 'pre-clinical']),
		_List_fromArray(
		['test facility management', 'tfm']),
		_List_fromArray(
		['archive', 'archives', 'ar'])
	]);
var $author$project$Search$addSynonyms = function (phraseList) {
	var addSynonymPhrases = F2(
		function (phrase, acc) {
			var gatherPhrases = function (listOfSynonyms) {
				return A3(
					$author$project$Search$createPhrasesFromSynonyms,
					A2(
						$author$project$Search$hasWordWithSynonyms,
						$elm$core$String$toLower(phrase),
						listOfSynonyms),
					$elm$core$String$toLower(phrase),
					listOfSynonyms);
			};
			return A2($elm$core$List$map, gatherPhrases, $author$project$Search$synonymLists);
		});
	return A2(
		$author$project$Search$listWithDefault,
		phraseList,
		$elm$core$List$concat(
			A3($elm$core$List$foldr, addSynonymPhrases, _List_Nil, phraseList)));
};
var $author$project$Utility$onlyIf = F2(
	function (_do, fn) {
		return _do ? fn : $elm$core$Basics$identity;
	});
var $author$project$Search$commonWords = _List_fromArray(
	['the', 'be', 'to', 'of', 'and', 'a', 'in', 'that', 'have', 'it', 'as', 'for', 'is']);
var $author$project$Utility$diff = F2(
	function (main, subtract) {
		diff:
		while (true) {
			if (!subtract.b) {
				return main;
			} else {
				if (!main.b) {
					return _List_Nil;
				} else {
					var x = main.a;
					var xs = main.b;
					if (A2($elm$core$List$member, x, subtract)) {
						var $temp$main = xs,
							$temp$subtract = subtract;
						main = $temp$main;
						subtract = $temp$subtract;
						continue diff;
					} else {
						return A2(
							$elm$core$List$cons,
							x,
							A2($author$project$Utility$diff, xs, subtract));
					}
				}
			}
		}
	});
var $author$project$Search$removeCommonWords = function (xs) {
	return A2($author$project$Utility$diff, xs, $author$project$Search$commonWords);
};
var $author$project$Utility$nubHelper = F2(
	function (l, acc) {
		nubHelper:
		while (true) {
			if (!l.b) {
				return acc;
			} else {
				var x = l.a;
				var xs = l.b;
				if (A2($elm$core$List$member, x, acc)) {
					var $temp$l = xs,
						$temp$acc = acc;
					l = $temp$l;
					acc = $temp$acc;
					continue nubHelper;
				} else {
					var $temp$l = xs,
						$temp$acc = A2($elm$core$List$cons, x, acc);
					l = $temp$l;
					acc = $temp$acc;
					continue nubHelper;
				}
			}
		}
	});
var $author$project$Utility$nub = function (l) {
	return $elm$core$List$reverse(
		A2($author$project$Utility$nubHelper, l, _List_Nil));
};
var $author$project$Search$removeRepeats = $author$project$Utility$nub;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Search$prepareSearchTerms = F2(
	function (phrase, settings) {
		if (phrase === '') {
			return _List_Nil;
		} else {
			var _v0 = settings.cf;
			switch (_v0) {
				case 0:
					return A2(
						$elm$core$List$map,
						$elm$core$Basics$identity,
						$author$project$Search$removeRepeats(
							A3(
								$author$project$Utility$onlyIf,
								settings.cr,
								$author$project$Search$addSynonyms,
								$elm$core$List$singleton(
									A3($author$project$Utility$onlyIf, settings.b$, $elm$core$String$toLower, phrase)))));
				case 1:
					return A2(
						$elm$core$List$map,
						$elm$core$Basics$identity,
						$author$project$Search$removeRepeats(
							A3(
								$author$project$Utility$onlyIf,
								settings.b0,
								$author$project$Search$removeCommonWords,
								$elm$core$String$words(
									A3($author$project$Utility$onlyIf, settings.b$, $elm$core$String$toLower, phrase)))));
				case 2:
					return A2(
						$elm$core$List$map,
						$elm$core$Basics$identity,
						$author$project$Search$removeRepeats(
							A3(
								$author$project$Utility$onlyIf,
								settings.b0,
								$author$project$Search$removeCommonWords,
								$elm$core$String$words(
									A3($author$project$Utility$onlyIf, settings.b$, $elm$core$String$toLower, phrase)))));
				default:
					return A2(
						$elm$core$List$map,
						$elm$core$Basics$identity,
						$author$project$Search$removeRepeats(
							A3(
								$author$project$Utility$onlyIf,
								settings.cr,
								$author$project$Search$addSynonyms,
								$elm$core$List$singleton(
									A3($author$project$Utility$onlyIf, settings.b$, $elm$core$String$toLower, phrase)))));
			}
		}
	});
var $author$project$Data$Outline$SearchResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Data$SearchInfo$getSearchScore = function (si) {
	if (si.$ === 1) {
		return 0;
	} else {
		var r = si.a;
		return function ($) {
			return $.dL;
		}(r);
	}
};
var $author$project$Data$SearchInfo$InContent = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Data$SearchInfo$InKeyword = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$SearchInfo$InTitle = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Data$SearchInfo$None = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$SearchInfo$Searched = function (a) {
	return {$: 0, a: a};
};
var $author$project$Search$getSearchTerm = function (searchTerm) {
	var term = searchTerm;
	return term;
};
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Search$totalScore = function (searchResults) {
	var score = function (a) {
		switch (a.$) {
			case 0:
				return 0;
			case 1:
				var c = a.b;
				return c * 1;
			case 2:
				var c = a.b;
				return c * 5;
			default:
				return 100;
		}
	};
	return $elm$core$List$sum(
		A2($elm$core$List$map, score, searchResults));
};
var $author$project$Search$searchEntry = F3(
	function (phrase, caseSensitive, entry) {
		var titl = A3($author$project$Utility$onlyIf, !caseSensitive, $elm$core$String$toLower, entry.gD);
		var numOccur = F2(
			function (word, str) {
				return $elm$core$List$length(
					A2(
						$elm$regex$Regex$find,
						$author$project$Search$wholeWordsRegex(word),
						str));
			});
		var kwds = A2($elm$core$List$map, $elm$core$String$toLower, entry.b3);
		var cont = A3($author$project$Utility$onlyIf, !caseSensitive, $elm$core$String$toLower, entry.eO);
		var searchWord = function (word) {
			if (A2($elm$core$List$member, word, kwds)) {
				return $author$project$Data$SearchInfo$InKeyword(word);
			} else {
				var tnum = A2(numOccur, word, titl);
				if (tnum > 0) {
					return A2($author$project$Data$SearchInfo$InTitle, word, tnum);
				} else {
					var _v0 = A2(numOccur, word, cont);
					if (!_v0) {
						return $author$project$Data$SearchInfo$None(word);
					} else {
						var some = _v0;
						return A2($author$project$Data$SearchInfo$InContent, word, some);
					}
				}
			}
		};
		var searchRatings = A2(
			$elm$core$List$map,
			function (x) {
				return searchWord(
					$author$project$Search$getSearchTerm(x));
			},
			phrase);
		var score = $author$project$Search$totalScore(searchRatings);
		return $author$project$Data$SearchInfo$Searched(
			{dL: score, dM: searchRatings});
	});
var $author$project$Data$Outline$setOLType = F2(
	function (oltype, _v0) {
		var ol = _v0;
		var ent = function ($) {
			return $.U;
		}(ol);
		var newEnt = _Utils_update(
			ent,
			{a6: oltype});
		return _Utils_update(
			ol,
			{U: newEnt});
	});
var $author$project$Search$generateSearchResults = F3(
	function (searchTerms, caseSensitive, outline) {
		var subEntriesResults = A2(
			$elm$core$List$map,
			function (x) {
				return A3($author$project$Search$generateSearchResults, searchTerms, caseSensitive, x);
			},
			$author$project$Data$Outline$getSubs(outline));
		var entry = $author$project$Data$Outline$getEntry(outline);
		var currentResults = A3($author$project$Search$searchEntry, searchTerms, caseSensitive, entry);
		var currentEntryResults = function () {
			var _v0 = $author$project$Data$SearchInfo$getSearchScore(currentResults);
			if (!_v0) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Data$Outline$setOLType,
						$author$project$Data$Outline$SearchResult(currentResults),
						outline)
					]);
			}
		}();
		return _Utils_ap(
			currentEntryResults,
			$elm$core$List$concat(subEntriesResults));
	});
var $author$project$Data$Outline$SearchDocument = {$: 8};
var $author$project$Search$getSearchTerms = function (searchTerms) {
	return A2(
		$elm$core$String$join,
		'\'; \'',
		A2($elm$core$List$map, $author$project$Search$getSearchTerm, searchTerms));
};
var $author$project$Search$searchResultsToOutline = F3(
	function (resultsList, searchPhrase, outline) {
		var ol = outline;
		var num = $elm$core$String$fromInt(
			$elm$core$List$length(resultsList));
		var entriesText = (num === '1') ? ' entry searching for \'' : ' entries searching for \'';
		var _v0 = _Utils_eq(resultsList, _List_Nil) ? _Utils_Tuple2(
			'No results found.',
			'Searched for \'' + ($author$project$Search$getSearchTerms(searchPhrase) + ('\'. ' + 'You can try a less specific search term, or try changing the search settings using the gear icon, above.'))) : _Utils_Tuple2(
			'Found ' + (num + (entriesText + ($author$project$Search$getSearchTerms(searchPhrase) + '\'.'))),
			'');
		var title = _v0.a;
		var topLevelText = _v0.b;
		return A4(
			$author$project$Data$Outline$makeOL,
			A9(
				$author$project$Data$Outline$Entry,
				$author$project$Data$ID$fromString('search'),
				$author$project$Data$Outline$getCurrentCiteLevel(outline),
				$author$project$Data$Outline$getCurrentDocLevel(outline),
				title,
				$author$project$Data$Outline$SearchDocument,
				_List_Nil,
				topLevelText,
				$elm$core$Maybe$Nothing,
				''),
			$author$project$Data$Outline$getParentDocumentID(outline),
			function ($) {
				return $.bk;
			}(ol),
			resultsList);
	});
var $author$project$Search$searchOutline = F5(
	function (searchTerms, caseSensitive, sortFunction, filterFunction, outline) {
		var resultsList = sortFunction(
			filterFunction(
				A3($author$project$Search$generateSearchResults, searchTerms, caseSensitive, outline)));
		return A3($author$project$Search$searchResultsToOutline, resultsList, searchTerms, outline);
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Data$SearchSettings$leaveSortOrder = function (list) {
	return list;
};
var $author$project$Data$SearchSettings$sortByScore = function (list) {
	var fn = function (outline) {
		return $author$project$Data$SearchInfo$getSearchScore(
			$author$project$Data$Outline$getSearchInfo(outline));
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortBy(fn),
		$elm$core$List$reverse)(list);
};
var $author$project$Data$SearchSettings$sortFunction = function (sortType) {
	if (!sortType) {
		return $author$project$Data$SearchSettings$sortByScore;
	} else {
		return $author$project$Data$SearchSettings$leaveSortOrder;
	}
};
var $author$project$Pages$Home$newSearch = F3(
	function (ex, session, model) {
		var sortFunction = $author$project$Data$SearchSettings$sortFunction(session.dN.ck);
		var preparedSearchTerm = A2($author$project$Search$prepareSearchTerms, ex, session.dN);
		var outlineList = A2(
			$elm$core$List$map,
			function ($) {
				return $.a9;
			},
			$author$project$Data$Session$getSearchableDocs(session));
		var filterFunction = $author$project$Data$SearchSettings$filterFunction(session.dN.cf);
		var caseSensitive = !session.dN.b$;
		var searchResults = (ex === '') ? outlineList : $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				$author$project$Data$Outline$count,
				A2(
					$elm$core$List$map,
					A4($author$project$Search$searchOutline, preparedSearchTerm, caseSensitive, sortFunction, filterFunction),
					outlineList)));
		return _Utils_update(
			model,
			{aM: _List_Nil, dH: searchResults, bE: ex, aT: ex});
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Pages$Home$preSearch = F2(
	function (input, model) {
		var sortFn = F2(
			function (a, b) {
				return A2($elm$core$String$startsWith, input, a) ? (A2($elm$core$String$startsWith, input, b) ? A2($elm$core$Basics$compare, a, b) : 0) : (A2($elm$core$String$startsWith, input, b) ? 2 : A2($elm$core$Basics$compare, a, b));
			});
		var match = function (kw) {
			return ($elm$core$String$length(input) < 3) ? A2(
				$elm$core$String$startsWith,
				$elm$core$String$toLower(input),
				$elm$core$String$toLower(kw)) : A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(input),
				$elm$core$String$toLower(kw));
		};
		var kwMatchList = (input === '') ? _List_Nil : A2(
			$elm$core$List$sortWith,
			sortFn,
			A2($elm$core$List$filter, match, model.b3));
		return _Utils_update(
			model,
			{aM: kwMatchList, aT: input});
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Pages$Home$update = F3(
	function (msg, session, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, session);
			case 0:
				var srchString = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Pages$Home$preSearch, srchString, model),
					session);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{_: model.dH}),
					session);
			case 2:
				return _Utils_Tuple2(
					A2(
						$author$project$Pages$Home$init,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.a9;
							},
							$author$project$Data$Session$getSearchableDocs(session)),
						session.bq),
					session);
			case 3:
				var srchString = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Pages$Home$newSearch, srchString, session, model),
					session);
			case 4:
				return _Utils_Tuple2(
					model,
					_Utils_update(
						session,
						{cw: !session.cw}));
			case 5:
				var outline = msg.a;
				var doc = A2($author$project$Data$Outline$getDoc, outline, session.b4);
				var citation = A3($author$project$Data$Outline$getCitation, outline, 2, doc);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: A2($author$project$Pages$Home$ShowCPopup, 'Entry Citation', citation)
						}),
					session);
			case 6:
				var outline = msg.a;
				var txt = A2($author$project$Pages$Home$formatEntryContent, session, outline);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: A2($author$project$Pages$Home$ShowCPopup, 'Entry: Top Level Contents', txt)
						}),
					session);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{af: $author$project$Pages$Home$HidePopup}),
					session);
			case 7:
				var outline = msg.a;
				var mdoc = A2($author$project$Data$Outline$getDoc, outline, session.b4);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: $author$project$Pages$Home$ShowDIPopup(mdoc)
						}),
					session);
			case 9:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							_: _List_fromArray(
								[item])
						}),
					session);
			case 10:
				var route = msg.a;
				return _Utils_Tuple2(model, session);
			case 11:
				var routetype = msg.a;
				return _Utils_Tuple2(model, session);
			case 12:
				var outline = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eM: A2(
								$elm$core$Set$insert,
								$author$project$Data$ID$toString(
									$author$project$Data$Outline$getOutlineID(outline)),
								model.eM)
						}),
					session);
			case 13:
				var outline = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eM: A2(
								$elm$core$Set$remove,
								$author$project$Data$ID$toString(
									$author$project$Data$Outline$getOutlineID(outline)),
								model.eM)
						}),
					session);
			case 14:
				var filterCollected = function (ol) {
					return A2(
						$author$project$Pages$Home$createCollectionOutline,
						ol,
						A2(
							$author$project$Data$Outline$filter,
							function (o) {
								return A2(
									$elm$core$Set$member,
									$author$project$Data$ID$toString(
										$author$project$Data$Outline$getOutlineID(o)),
									model.eM);
							},
							ol));
				};
				var collectedItems = A2($elm$core$List$map, filterCollected, model.dH);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{_: collectedItems}),
					session);
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eM: $elm$core$Set$empty, _: model.dH}),
					session);
			case 16:
				var ol = msg.a;
				var citationText = function (outline) {
					var doc = A2($author$project$Data$Outline$getDoc, outline, session.b4);
					return '- ' + A3($author$project$Data$Outline$getCitation, outline, 2, doc);
				};
				var allText = A2(
					$elm$core$List$map,
					citationText,
					$author$project$Data$Outline$getSubs(ol));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: A3($author$project$Pages$Home$ShowCollectionPopup, 'Collected Citations', allText, '')
						}),
					session);
			default:
				var ol = msg.a;
				var allText = A2(
					$elm$core$List$map,
					$author$project$Pages$Home$formatEntryContent(session),
					$author$project$Data$Outline$getSubs(ol));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							af: A3($author$project$Pages$Home$ShowCollectionPopup, 'Collected Entries', allText, 'Note: only the top level text is included with each entry.')
						}),
					session);
		}
	});
var $author$project$Data$Citation$toRegTypeString = function (cit) {
	switch (cit.$) {
		case 3:
			return 'OECD';
		case 1:
			return 'FDA';
		case 2:
			return 'EPA';
		default:
			return 'NoCitation';
	}
};
var $author$project$Data$APITypes$encodeCitationRegTypeOnly = function (cit) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Citation$toRegTypeString(cit));
};
var $author$project$Data$APITypes$encodeDocInfo = function (d) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'article',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'regtype',
							$author$project$Data$APITypes$encodeCitationRegTypeOnly(d.eI)),
							_Utils_Tuple2(
							'title',
							$elm$json$Json$Encode$string(d.gD)),
							_Utils_Tuple2(
							'slug',
							$elm$json$Json$Encode$string(d.gJ)),
							_Utils_Tuple2(
							'description',
							$elm$json$Json$Encode$string(d.cM))
						])))
			]));
};
var $author$project$Data$APITypes$encodeDocInfoList = function (dlist) {
	return A2($elm$json$Json$Encode$list, $author$project$Data$APITypes$encodeDocInfo, dlist);
};
var $author$project$Pages$Profile$GotDoc = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Profile$Requested = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Profile$Success = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Profile$Unloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Profile$statusMap = F2(
	function (fn, status) {
		if (status.$ === 2) {
			var id = status.a;
			var a = status.b;
			return A2(
				$author$project$Pages$Profile$Success,
				id,
				fn(a));
		} else {
			return status;
		}
	});
var $author$project$Pages$Profile$getStatusDocId = function (status) {
	if (status.$ === 2) {
		var doc = status.b;
		return doc.c2;
	} else {
		return $author$project$Data$DocID$empty;
	}
};
var $author$project$Pages$Profile$updateSubDocOption = F2(
	function (newDocOption, sub) {
		var getDOId = function (_do) {
			switch (_do.$) {
				case 0:
					var docinfo = _do.a;
					return docinfo.c2;
				case 1:
					var doStatus = _do.a;
					return $author$project$Pages$Profile$getStatusDocId(doStatus);
				default:
					var doStatus = _do.a;
					return $author$project$Pages$Profile$getStatusDocId(doStatus);
			}
		};
		var updateDoc = function (oldDocOption) {
			return _Utils_eq(
				getDOId(newDocOption),
				getDOId(oldDocOption)) ? newDocOption : oldDocOption;
		};
		return _Utils_update(
			sub,
			{
				T: A2($elm$core$List$map, updateDoc, sub.T)
			});
	});
var $author$project$Pages$Profile$stepDocCheckChanged = F3(
	function (isChecked, docinfo, model) {
		var newmodel = isChecked ? _Utils_update(
			model,
			{
				w: A2(
					$author$project$Pages$Profile$statusMap,
					$elm$core$List$map(
						$author$project$Pages$Profile$updateSubDocOption(
							A2(
								$author$project$Pages$Profile$Requested,
								docinfo,
								$author$project$Pages$Profile$Loading(docinfo.c2)))),
					model.w)
			}) : _Utils_update(
			model,
			{
				w: A2(
					$author$project$Pages$Profile$statusMap,
					$elm$core$List$map(
						$author$project$Pages$Profile$updateSubDocOption(
							$author$project$Pages$Profile$Unloaded(
								A2($author$project$Pages$Profile$Success, docinfo.gJ, docinfo)))),
					model.w)
			});
		var cmd = isChecked ? A2($author$project$Requests$fetchDocument, docinfo, $author$project$Pages$Profile$GotDoc) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newmodel, cmd);
	});
var $author$project$Pages$Profile$Failure = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Profile$stepGotDoc = F3(
	function (docinfo, xmlResult, model) {
		var status = function () {
			if (!xmlResult.$) {
				var xml = xmlResult.a;
				var docResult = A4($author$project$Data$Outline$Xml$fromXml, docinfo.c2, docinfo.eI, docinfo.gD, xml);
				if (!docResult.$) {
					var doc = docResult.a;
					return A2(
						$author$project$Pages$Profile$Requested,
						docinfo,
						A2($author$project$Pages$Profile$Success, docinfo.c2, doc));
				} else {
					var msg = docResult.a;
					return A2(
						$author$project$Pages$Profile$Requested,
						docinfo,
						$author$project$Pages$Profile$Failure(docinfo.c2));
				}
			} else {
				var httpErr = xmlResult.a;
				return A2(
					$author$project$Pages$Profile$Requested,
					docinfo,
					$author$project$Pages$Profile$Failure(docinfo.c2));
			}
		}();
		var newModel = _Utils_update(
			model,
			{
				w: A2(
					$author$project$Pages$Profile$statusMap,
					$elm$core$List$map(
						$author$project$Pages$Profile$updateSubDocOption(status)),
					model.w)
			});
		return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Profile$Unavailable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Profile$getStatusId = function (status) {
	switch (status.$) {
		case 0:
			var id = status.a;
			return id;
		case 1:
			var id = status.a;
			return id;
		default:
			var id = status.a;
			return id;
	}
};
var $author$project$Pages$Profile$updateSubDocInfo = F3(
	function (sDocinfo, docList, sub) {
		var maybeGetDoc = function (id) {
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (doc) {
						return _Utils_eq(doc.R, id);
					},
					docList));
		};
		var docid = $author$project$Pages$Profile$getStatusId(sDocinfo);
		var updateDocInfo = function (oldDocInfo) {
			switch (oldDocInfo.$) {
				case 1:
					var di = oldDocInfo.a;
					if (_Utils_eq(
						$author$project$Pages$Profile$getStatusId(di),
						docid)) {
						if (sDocinfo.$ === 2) {
							var docinfo = sDocinfo.b;
							var _v2 = maybeGetDoc(docinfo.c2);
							if (!_v2.$) {
								var doc = _v2.a;
								return A2(
									$author$project$Pages$Profile$Requested,
									docinfo,
									A2($author$project$Pages$Profile$Success, docinfo.c2, doc));
							} else {
								return $author$project$Pages$Profile$Unloaded(sDocinfo);
							}
						} else {
							return $author$project$Pages$Profile$Unloaded(sDocinfo);
						}
					} else {
						return oldDocInfo;
					}
				case 2:
					var di = oldDocInfo.a;
					return _Utils_eq(
						$author$project$Pages$Profile$getStatusId(di),
						docid) ? $author$project$Pages$Profile$Unavailable(sDocinfo) : oldDocInfo;
				default:
					return oldDocInfo;
			}
		};
		return _Utils_update(
			sub,
			{
				T: A2($elm$core$List$map, updateDocInfo, sub.T)
			});
	});
var $author$project$Pages$Profile$stepGotDocInfo = F2(
	function (docInfoResult, model) {
		var sDocInfo = function () {
			if (!docInfoResult.$) {
				var docinfo = docInfoResult.a;
				return A2($author$project$Pages$Profile$Success, docinfo.gJ, docinfo);
			} else {
				var err = docInfoResult.a;
				return $author$project$Pages$Profile$Failure('err');
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					w: A2(
						$author$project$Pages$Profile$statusMap,
						$elm$core$List$map(
							A2($author$project$Pages$Profile$updateSubDocInfo, sDocInfo, model.b5)),
						model.w)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Profile$GotDocInfo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Profile$subsToSubInfo = F2(
	function (subs, userSubLevel) {
		var subscribed = function (sub) {
			if (!userSubLevel) {
				return !sub.fy;
			} else {
				return true;
			}
		};
		var addSub = function (sub) {
			return {
				T: subscribed(sub) ? A2(
					$elm$core$List$map,
					function (x) {
						return $author$project$Pages$Profile$Unloaded(
							$author$project$Pages$Profile$Loading(x));
					},
					sub.ep) : A2(
					$elm$core$List$map,
					function (x) {
						return $author$project$Pages$Profile$Unavailable(
							$author$project$Pages$Profile$Loading(x));
					},
					sub.ep),
				dU: subscribed(sub),
				aX: sub
			};
		};
		return A2($elm$core$List$map, addSub, subs);
	});
var $author$project$Pages$Profile$stepGotSubs = F2(
	function (subResult, model) {
		var userSublevel = function () {
			var _v1 = model.d$;
			switch (_v1.$) {
				case 2:
					var u = _v1.a;
					return u.dS;
				case 1:
					var u = _v1.a;
					return u.dS;
				default:
					return 0;
			}
		}();
		if (!subResult.$) {
			var subs = subResult.a;
			var articles = A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.ep;
				},
				subs);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						w: A2(
							$author$project$Pages$Profile$Success,
							'Subscription List',
							A2($author$project$Pages$Profile$subsToSubInfo, subs, userSublevel))
					}),
				$elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (x) {
							return A2($author$project$Requests$fetchArticleInfo, x, $author$project$Pages$Profile$GotDocInfo);
						},
						articles)));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						w: $author$project$Pages$Profile$Failure('Subscription List')
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Profile$allToDocInfoList = function (model) {
	var _v0 = model.w;
	if (_v0.$ === 2) {
		var subs = _v0.b;
		var allDocOptions = A2(
			$elm$core$List$concatMap,
			function (sub) {
				return sub.T;
			},
			subs);
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					_v1$2:
					while (true) {
						switch (x.$) {
							case 0:
								if (x.b.$ === 2) {
									var docinfo = x.a;
									var _v2 = x.b;
									return A2($elm$core$List$cons, docinfo, acc);
								} else {
									break _v1$2;
								}
							case 1:
								if (x.a.$ === 2) {
									var _v3 = x.a;
									var docinfo = _v3.b;
									return A2($elm$core$List$cons, docinfo, acc);
								} else {
									break _v1$2;
								}
							default:
								break _v1$2;
						}
					}
					return acc;
				}),
			_List_Nil,
			allDocOptions);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Profile$stepSelectAllOfType = F2(
	function (regType, model) {
		var allAvailable = $author$project$Pages$Profile$allToDocInfoList(model);
		var docinfoList = function () {
			switch (regType) {
				case 'None':
					return _List_Nil;
				case 'All':
					return allAvailable;
				default:
					return A2(
						$elm$core$List$filter,
						function (x) {
							return _Utils_eq(
								$author$project$Data$Citation$toRegTypeString(x.eI),
								regType);
						},
						allAvailable);
			}
		}();
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (docinfo, _v1) {
					var modelAcc = _v1.a;
					return A3($author$project$Pages$Profile$stepDocCheckChanged, false, docinfo, modelAcc);
				}),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			allAvailable);
		var clearedModel = _v0.a;
		var _v2 = function () {
			var mergeModelCmd = F2(
				function (docinfo, _v4) {
					var modelAcc = _v4.a;
					var cmdAcc = _v4.b;
					var _v3 = A3($author$project$Pages$Profile$stepDocCheckChanged, true, docinfo, modelAcc);
					var nm = _v3.a;
					var nc = _v3.b;
					return _Utils_Tuple2(
						nm,
						A2($elm$core$List$cons, nc, cmdAcc));
				});
			return A3(
				$elm$core$List$foldl,
				mergeModelCmd,
				_Utils_Tuple2(clearedModel, _List_Nil),
				docinfoList);
		}();
		var newModel = _v2.a;
		var cmdList = _v2.b;
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(cmdList));
	});
var $author$project$Ports$storeDocs = _Platform_outgoingPort('storeDocs', $elm$core$Basics$identity);
var $author$project$Pages$Profile$toDocInfoList = function (model) {
	var _v0 = model.w;
	if (_v0.$ === 2) {
		var subs = _v0.b;
		var allDocOptions = A2(
			$elm$core$List$concatMap,
			function (sub) {
				return sub.T;
			},
			subs);
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					if ((!x.$) && (x.b.$ === 2)) {
						var docinfo = x.a;
						var _v2 = x.b;
						return A2($elm$core$List$cons, docinfo, acc);
					} else {
						return acc;
					}
				}),
			_List_Nil,
			allDocOptions);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Profile$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var docID = msg.a;
				var isChecked = msg.b;
				return A3($author$project$Pages$Profile$stepDocCheckChanged, isChecked, docID, model);
			case 1:
				var subResult = msg.a;
				return A2($author$project$Pages$Profile$stepGotSubs, subResult, model);
			case 3:
				var docInfoResult = msg.a;
				return A2($author$project$Pages$Profile$stepGotDocInfo, docInfoResult, model);
			case 2:
				var docinfo = msg.a;
				var docResult = msg.b;
				return A3($author$project$Pages$Profile$stepGotDoc, docinfo, docResult, model);
			case 4:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$storeDocs(
						$author$project$Data$APITypes$encodeDocInfoList(
							$author$project$Pages$Profile$toDocInfoList(model))));
			default:
				var regType = msg.a;
				return A2($author$project$Pages$Profile$stepSelectAllOfType, regType, model);
		}
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Data$SearchSettings$searchTermSettingsToString = function (s) {
	switch (s) {
		case 0:
			return 'WholePhrase';
		case 1:
			return 'AllWords';
		case 2:
			return 'AnyWords';
		default:
			return 'KeyWordsOnly';
	}
};
var $author$project$Data$SearchSettings$sortTypeToString = function (s) {
	if (!s) {
		return 'TotalScore';
	} else {
		return 'DocumentOrder';
	}
};
var $author$project$Data$SearchSettings$encodeSearchSettings = function (s) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'searchTermSettings',
				$elm$json$Json$Encode$string(
					$author$project$Data$SearchSettings$searchTermSettingsToString(s.cf))),
				_Utils_Tuple2(
				'ignoreCase',
				$elm$json$Json$Encode$bool(s.b$)),
				_Utils_Tuple2(
				'ignoreCommonWords',
				$elm$json$Json$Encode$bool(s.b0)),
				_Utils_Tuple2(
				'useSynonyms',
				$elm$json$Json$Encode$bool(s.cr)),
				_Utils_Tuple2(
				'sortBy',
				$elm$json$Json$Encode$string(
					$author$project$Data$SearchSettings$sortTypeToString(s.ck)))
			]));
};
var $author$project$Data$ViewSettings$encodeViewSettings = function (s) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'summarize',
				$elm$json$Json$Encode$bool(s.cm)),
				_Utils_Tuple2(
				'columnView',
				$elm$json$Json$Encode$bool(s.bT))
			]));
};
var $author$project$Pages$Settings$encodeSettings = function (s) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'searchSettings',
				$author$project$Data$SearchSettings$encodeSearchSettings(s.dN)),
				_Utils_Tuple2(
				'viewSettings',
				$author$project$Data$ViewSettings$encodeViewSettings(s.d2))
			]));
};
var $author$project$Ports$storeSettings = _Platform_outgoingPort('storeSettings', $elm$core$Basics$identity);
var $author$project$Pages$Settings$update = F2(
	function (msg, model) {
		var oldViewSettings = model.X.d2;
		var oldSearchSettings = model.X.dN;
		switch (msg.$) {
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Q: 'Settings saved for future sessions'}),
					$author$project$Ports$storeSettings(
						$author$project$Pages$Settings$encodeSettings(model.X)));
			case 0:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Q: 'Settings changed for this session',
							X: {
								dN: _Utils_update(
									oldSearchSettings,
									{cf: val}),
								d2: model.X.d2
							}
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Q: 'Settings changed for this session',
							X: {
								dN: _Utils_update(
									oldSearchSettings,
									{b$: val}),
								d2: model.X.d2
							}
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Q: 'Settings changed for this session',
							X: {
								dN: _Utils_update(
									oldSearchSettings,
									{b0: val}),
								d2: model.X.d2
							}
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Q: 'Settings changed for this session',
							X: {
								dN: _Utils_update(
									oldSearchSettings,
									{cr: val}),
								d2: model.X.d2
							}
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Q: 'Settings changed for this session',
							X: {
								dN: _Utils_update(
									oldSearchSettings,
									{ck: val}),
								d2: model.X.d2
							}
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Q: 'Settings changed for this session',
							X: {
								dN: model.X.dN,
								d2: _Utils_update(
									oldViewSettings,
									{bT: val})
							}
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Q: 'Settings changed for this session',
							X: {
								dN: model.X.dN,
								d2: _Utils_update(
									oldViewSettings,
									{cm: val})
							}
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$setRoute = F3(
	function (maybeRoute, fragment, model) {
		setRoute:
		while (true) {
			var session = model.g;
			var scrollCmdOr = function (_default) {
				if (fragment.$ === 1) {
					return _default;
				} else {
					var element = fragment.a;
					return $author$project$Main$scrollToElement(element);
				}
			};
			var notFound = A2(
				$author$project$Utility$pair,
				_Utils_update(
					model,
					{
						p: $author$project$Main$Loaded($author$project$Main$NotFound)
					}),
				$elm$core$Platform$Cmd$none);
			var docsFinishedLoading = $author$project$Data$UrlQueue$isComplete(model.y);
			var docLoadingState = function (pg) {
				return (docsFinishedLoading || _Utils_eq(model.g.d$, $author$project$Data$User$LoggedOut)) ? $author$project$Main$setLoaded(pg) : $author$project$Main$setTransitioningFrom(pg);
			};
			var passThrough = function (tempRoute) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							p: docLoadingState(
								$author$project$Main$Loaded(tempRoute)),
							aB: maybeRoute
						}),
					$elm$core$Platform$Cmd$none);
			};
			if (maybeRoute.$ === 1) {
				return notFound;
			} else {
				switch (maybeRoute.a.$) {
					case 0:
						var _v26 = maybeRoute.a;
						return A2(
							$author$project$Utility$pair,
							_Utils_update(
								model,
								{
									p: docLoadingState(
										$author$project$Main$Loaded(
											$author$project$Main$Home(
												A2($author$project$Pages$Home$init, model.F, model.g.bq))))
								}),
							scrollCmdOr($author$project$Main$scrollToTop));
					case 1:
						var docid = maybeRoute.a.a;
						if (docsFinishedLoading) {
							var docInList = A2($author$project$Data$Outline$getDocByID, docid, model.g.b4);
							if (!docInList.$) {
								var doc = docInList.a;
								var newSession = _Utils_update(
									session,
									{
										cg: _List_fromArray(
											[
												$author$project$Data$Outline$docToDocInfo(doc)
											])
									});
								var currentOutline = _Utils_eq(model.F, _List_Nil) ? _List_fromArray(
									[doc.a9]) : model.F;
								var homeInit = A3($author$project$Pages$Home$initViewingDoc, doc, currentOutline, model.g.bq);
								return A2(
									$author$project$Utility$pair,
									_Utils_update(
										model,
										{
											p: docLoadingState(
												$author$project$Main$Loaded(
													$author$project$Main$Home(homeInit))),
											g: newSession
										}),
									scrollCmdOr($author$project$Main$scrollToTop));
							} else {
								return notFound;
							}
						} else {
							return passThrough(
								$author$project$Main$Home(
									A2($author$project$Pages$Home$init, model.F, model.g.bq)));
						}
					case 2:
						var _v28 = maybeRoute.a;
						var docid = _v28.a;
						var itemid = _v28.b;
						if (docsFinishedLoading) {
							var docInList = A2($author$project$Data$Outline$getDocByID, docid, model.g.b4);
							if (!docInList.$) {
								var doc = docInList.a;
								var newSession = _Utils_update(
									session,
									{
										cg: A2(
											$author$project$Utility$addIfNotInList,
											$author$project$Data$Outline$docToDocInfo(doc),
											session.cg)
									});
								var itemInDoc = A2($author$project$Data$Outline$getOutlineByID, itemid, doc);
								var currentUrl = $author$project$Route$routeToString(
									A2($author$project$Route$Contents, docid, itemid));
								var currentOutline = _Utils_eq(model.F, _List_Nil) ? _List_fromArray(
									[doc.a9]) : model.F;
								if (!itemInDoc.$) {
									var item = itemInDoc.a;
									var homeInit = A3($author$project$Pages$Home$initViewingItem, item, currentOutline, model.g.bq);
									var newModel = _Utils_update(
										model,
										{
											F: currentOutline,
											p: $author$project$Main$Loaded(
												$author$project$Main$Home(homeInit)),
											aB: $elm$core$Maybe$Nothing,
											g: newSession
										});
									return _Utils_Tuple2(
										newModel,
										scrollCmdOr($author$project$Main$scrollToTop));
								} else {
									return notFound;
								}
							} else {
								return notFound;
							}
						} else {
							return passThrough(
								$author$project$Main$Home(
									A2($author$project$Pages$Home$init, model.F, model.g.bq)));
						}
					case 3:
						var docid = maybeRoute.a.a;
						var docInList = A2($author$project$Data$Outline$getOutlineFromListByParentID, docid, model.F);
						if (!docInList.$) {
							var doc = docInList.a;
							var _v32 = A2(
								$author$project$Main$update,
								$author$project$Msg$HomeMsg(
									$author$project$Pages$Home$SwitchToItem(doc)),
								model);
							var m = _v32.a;
							var c = _v32.b;
							return _Utils_Tuple2(
								m,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[c, $author$project$Main$scrollToTop])));
						} else {
							return notFound;
						}
					case 4:
						var _v33 = maybeRoute.a;
						var docid = _v33.a;
						var itemid = _v33.b;
						var docInList = A2($author$project$Data$Outline$getDocByID, docid, model.g.b4);
						if (!docInList.$) {
							var doc = docInList.a;
							var itemInDoc = A2($author$project$Data$Outline$getOutlineByID, itemid, doc);
							if (!itemInDoc.$) {
								var item = itemInDoc.a;
								var _v36 = A2(
									$author$project$Main$update,
									$author$project$Msg$HomeMsg(
										$author$project$Pages$Home$SwitchToItem(item)),
									model);
								var m = _v36.a;
								var c = _v36.b;
								return _Utils_Tuple2(
									m,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[c, $author$project$Main$scrollToTop, $author$project$Main$focusSearchBox])));
							} else {
								var $temp$maybeRoute = $elm$core$Maybe$Nothing,
									$temp$fragment = $elm$core$Maybe$Nothing,
									$temp$model = model;
								maybeRoute = $temp$maybeRoute;
								fragment = $temp$fragment;
								model = $temp$model;
								continue setRoute;
							}
						} else {
							return notFound;
						}
					case 6:
						var _v37 = maybeRoute.a;
						return A2(
							$author$project$Utility$pair,
							_Utils_update(
								model,
								{
									p: $author$project$Main$Loaded($author$project$Main$About)
								}),
							scrollCmdOr($author$project$Main$scrollToTop));
					case 8:
						var _v38 = maybeRoute.a;
						return A2(
							$author$project$Utility$pair,
							_Utils_update(
								model,
								{
									p: $author$project$Main$Loaded(
										$author$project$Main$Settings(
											A2($author$project$Pages$Settings$init, model.g.dN, model.g.d2)))
								}),
							scrollCmdOr($author$project$Main$scrollToTop));
					case 9:
						var _v39 = maybeRoute.a;
						var oldai = model.O;
						var initialData = function () {
							var _v41 = model.O;
							if (_v41.$ === 2) {
								var a0user = _v41.a;
								return $elm$core$Maybe$Just(a0user);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var _v40 = $author$project$Pages$Authentication$init(model.g.d$);
						var am = _v40.a;
						var cmd = _v40.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									O: am,
									p: $author$project$Main$Loaded($author$project$Main$Login)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoginMsg, cmd));
					case 10:
						var _v42 = maybeRoute.a;
						return A2(
							$author$project$Utility$pair,
							_Utils_update(
								model,
								{
									p: $author$project$Main$Loaded(
										$author$project$Main$Test(
											$author$project$Views$Test$init(model.g)))
								}),
							$elm$core$Platform$Cmd$none);
					case 5:
						var _v43 = maybeRoute.a;
						return A2($author$project$Utility$pair, model, $elm$core$Platform$Cmd$none);
					default:
						var _v44 = maybeRoute.a;
						var _v45 = A2($author$project$Pages$Profile$init, model.g.d$, model.g.b4);
						var submdl = _v45.a;
						var subcmd = _v45.b;
						return A2(
							$author$project$Utility$pair,
							_Utils_update(
								model,
								{
									p: $author$project$Main$Loaded(
										$author$project$Main$Profile(submdl))
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Msg$ProfileMsg, subcmd));
				}
			}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var session = model.g;
			var page = $author$project$Main$getPage(model.p);
			var _v0 = _Utils_Tuple2(msg, page);
			switch (_v0.a.$) {
				case 11:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 1:
					var urlRequest = _v0.a.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						var href = $elm$url$Url$toString(url);
						var pushCmd = A2($elm$browser$Browser$Navigation$pushUrl, model.a3, href);
						return _Utils_Tuple2(model, pushCmd);
					} else {
						var href = urlRequest.a;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(href));
					}
				case 0:
					var url = _v0.a.a;
					return A3(
						$author$project$Main$setRoute,
						$author$project$Route$fromUrl(url),
						url.cV,
						model);
				case 2:
					var _v2 = _v0.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[$author$project$Main$scrollToTop, $author$project$Main$focusSearchBox])));
				case 7:
					var m = _v0.a.a;
					var pg = _v0.b;
					var defaultSession = $author$project$Data$Session$defaultSession;
					var _v3 = A2($author$project$Pages$Authentication$update, m, model.O);
					var am = _v3.a;
					var newCmd = _v3.b;
					var userstate = $author$project$Pages$Authentication$getUserState(am);
					var sess = _Utils_update(
						session,
						{d$: userstate});
					var nextAuthCmd = A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoginMsg, newCmd);
					if (m.$ === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{O: am, F: _List_Nil, g: defaultSession}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										nextAuthCmd,
										A2($author$project$Main$redirect, model, $author$project$Route$Home)
									])));
					} else {
						switch (userstate.$) {
							case 2:
								var user = userstate.a;
								var pageShowCmd = function () {
									switch (pg.$) {
										case 6:
											return A2($author$project$Main$redirect, model, $author$project$Route$Home);
										case 3:
											var pm = pg.a;
											return _Utils_eq(pm.d$, userstate) ? $elm$core$Platform$Cmd$none : A2($author$project$Main$redirect, model, $author$project$Route$Profile);
										default:
											var _v8 = model.aB;
											if (_v8.$ === 1) {
												return $elm$core$Platform$Cmd$none;
											} else {
												var route = _v8.a;
												return A2($author$project$Main$redirect, model, route);
											}
									}
								}();
								var getSubsCmd = _Utils_eq(sess.cB, _List_Nil) ? A2(
									$elm$core$List$map,
									function (x) {
										return A2($author$project$Requests$fetchSub, x, $author$project$Msg$OnApiSubResponse);
									},
									user.dV) : _List_fromArray(
									[$elm$core$Platform$Cmd$none]);
								var _v6 = $author$project$Data$UrlQueue$request(model.y);
								var getDocsCmd = _v6.a;
								var newQueue = _v6.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{O: am, y: newQueue, g: sess}),
									$elm$core$Platform$Cmd$batch(
										A2(
											$elm$core$List$cons,
											nextAuthCmd,
											A2(
												$elm$core$List$cons,
												pageShowCmd,
												_Utils_ap(getSubsCmd, getDocsCmd)))));
							case 1:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{O: am, g: sess}),
									nextAuthCmd);
							default:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											O: am,
											p: $author$project$Main$Loaded($author$project$Main$Login),
											g: sess
										}),
									nextAuthCmd);
						}
					}
				case 3:
					var mmsg = _v0.a.a;
					var newSession = A2($author$project$Views$Menu$update, mmsg, model.g);
					var newModel = _Utils_update(
						model,
						{g: newSession});
					var homeCmd = function () {
						switch (mmsg.$) {
							case 3:
								return $author$project$Pages$Home$None;
							case 0:
								return $author$project$Pages$Home$None;
							case 1:
								return $author$project$Pages$Home$Reset;
							default:
								return $author$project$Pages$Home$Reset;
						}
					}();
					var $temp$msg = $author$project$Msg$HomeMsg(homeCmd),
						$temp$model = newModel;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 4:
					if (_v0.b.$ === 2) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var _v10 = A3($author$project$Pages$Home$update, subMsg, session, subModel);
						var homemdl = _v10.a;
						var newsess = _v10.b;
						var newmodl = _Utils_update(
							model,
							{
								F: homemdl.dH,
								p: $author$project$Main$Loaded(
									$author$project$Main$Home(homemdl)),
								g: newsess
							});
						switch (subMsg.$) {
							case 3:
								var $temp$msg = $author$project$Msg$HomeMsg($author$project$Pages$Home$Refresh),
									$temp$model = newmodl;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							case 10:
								var route = subMsg.a;
								return A3(
									$author$project$Main$setRoute,
									$elm$core$Maybe$Just(route),
									$elm$core$Maybe$Nothing,
									newmodl);
							case 11:
								var href = subMsg.a;
								return _Utils_Tuple2(
									newmodl,
									$elm$browser$Browser$Navigation$load(href));
							case 2:
								return _Utils_Tuple2(
									newmodl,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$browser$Browser$Navigation$pushUrl,
												model.a3,
												$author$project$Route$routeToString($author$project$Route$Home)),
												$author$project$Main$scrollToTop
											])));
							case 14:
								return _Utils_Tuple2(
									newmodl,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[$author$project$Main$scrollToTop])));
							default:
								return _Utils_Tuple2(newmodl, $elm$core$Platform$Cmd$none);
						}
					} else {
						return A2($author$project$Utility$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 6:
					if (_v0.b.$ === 7) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var _v12 = A2($author$project$Pages$Settings$update, subMsg, subModel);
						var sessmdl = _v12.a;
						var newmsg = _v12.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									p: $author$project$Main$Loaded(
										$author$project$Main$Settings(sessmdl)),
									g: _Utils_update(
										session,
										{dN: sessmdl.X.dN, d2: sessmdl.X.d2})
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Msg$SettingsMsg, newmsg));
					} else {
						return A2($author$project$Utility$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 5:
					if (_v0.b.$ === 3) {
						var subMsg = _v0.a.a;
						var subModel = _v0.b.a;
						var oldSession = model.g;
						var _v13 = A2($author$project$Pages$Profile$update, subMsg, subModel);
						var mdl = _v13.a;
						var newmsg = _v13.b;
						var loadedDocs = $author$project$Pages$Profile$toDocList(mdl);
						var docListFromProfile = A2($elm$core$List$map, $author$project$Data$Outline$docToUrl, loadedDocs);
						var newSession = _Utils_update(
							oldSession,
							{b4: loadedDocs});
						var newCommand = function () {
							if ((subMsg.$ === 1) && (subMsg.a.$ === 1)) {
								return A2($author$project$Main$redirect, model, $author$project$Route$Login);
							} else {
								return A2($elm$core$Platform$Cmd$map, $author$project$Msg$ProfileMsg, newmsg);
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									y: $author$project$Data$UrlQueue$isEmpty(model.y) ? $author$project$Data$UrlQueue$fromList(docListFromProfile) : model.y,
									p: $author$project$Main$Loaded(
										$author$project$Main$Profile(mdl)),
									g: newSession
								}),
							newCommand);
					} else {
						return A2($author$project$Utility$pair, model, $elm$core$Platform$Cmd$none);
					}
				case 9:
					var responseResult = _v0.a.a;
					var _v15 = function () {
						if (!responseResult.$) {
							var s = responseResult.a;
							if ($author$project$Data$UrlQueue$isEmpty(model.y)) {
								var _v17 = $author$project$Data$UrlQueue$request(
									$author$project$Data$UrlQueue$fromList(s.ep));
								var docRequestCmd = _v17.a;
								var newDocQueue = _v17.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{y: newDocQueue}),
									$elm$core$Platform$Cmd$batch(docRequestCmd));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						} else {
							var errmsg = responseResult.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										g: A2(
											$author$project$Data$Session$setError,
											model.g,
											A2($author$project$Data$Errors$APIError, 'API Profile Error: ', errmsg))
									}),
								$elm$core$Platform$Cmd$none);
						}
					}();
					var newMod = _v15.a;
					var newCmd = _v15.b;
					return A2($author$project$Utility$pair, newMod, newCmd);
				case 10:
					var responseResult = _v0.a.a;
					var _v18 = function () {
						if (!responseResult.$) {
							var s = responseResult.a;
							return _Utils_Tuple3(
								session,
								A2($author$project$Requests$fetchDocument, s, $author$project$Msg$OnLoadDoc),
								model.y);
						} else {
							var errmsg = responseResult.a;
							return _Utils_Tuple3(
								A2(
									$author$project$Data$Session$setError,
									model.g,
									A2($author$project$Data$Errors$APIError, 'API Profile Error: ', errmsg)),
								$elm$core$Platform$Cmd$none,
								$author$project$Data$UrlQueue$received(model.y));
						}
					}();
					var sess = _v18.a;
					var newCmd = _v18.b;
					var newQueue = _v18.c;
					return A2(
						$author$project$Utility$pair,
						_Utils_update(
							model,
							{y: newQueue, g: sess}),
						newCmd);
				default:
					var _v20 = _v0.a;
					var docinfo = _v20.a;
					var xmlResult = _v20.b;
					var pg = _v0.b;
					var newQueue = $author$project$Data$UrlQueue$received(model.y);
					var firstDocLoadedOnHome = function () {
						if (pg.$ === 2) {
							return ($elm$core$List$length(session.b4) === 1) && _Utils_eq(model.aB, $elm$core$Maybe$Nothing);
						} else {
							return false;
						}
					}();
					var newSession = A4($author$project$Main$convertLoadedDocXml, docinfo, xmlResult, firstDocLoadedOnHome, model.g);
					var updatedModel = _Utils_update(
						model,
						{
							y: newQueue,
							p: $author$project$Data$UrlQueue$isComplete(newQueue) ? $author$project$Main$setLoaded(model.p) : $author$project$Main$setTransitioningFrom(model.p),
							g: newSession
						});
					var _v21 = function () {
						if ($author$project$Data$UrlQueue$isComplete(newQueue)) {
							var _v22 = updatedModel.aB;
							if (_v22.$ === 1) {
								return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
							} else {
								var delayedroute = _v22.a;
								return A3(
									$author$project$Main$setRoute,
									$elm$core$Maybe$Just(delayedroute),
									$elm$core$Maybe$Nothing,
									updatedModel);
							}
						} else {
							return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v21.a;
					var newCmd = _v21.b;
					var _v23 = firstDocLoadedOnHome ? A2(
						$author$project$Main$update,
						$author$project$Msg$HomeMsg($author$project$Pages$Home$Reset),
						newModel) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					var newModel2 = _v23.a;
					var newCmd2 = _v23.b;
					return _Utils_Tuple2(
						newModel2,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[newCmd2, newCmd])));
			}
		}
	});
var $author$project$Main$init = F3(
	function (mFlags, url, key) {
		var initialRoute = $author$project$Route$fromUrl(url);
		var initialFragment = url.cV;
		var initialData = $author$project$Main$parseFlags(mFlags);
		var _v0 = function () {
			var _v1 = initialData.bI;
			if (_v1.$ === 1) {
				return _Utils_Tuple3(
					A2($author$project$Pages$Authentication$LoggedOut, $elm$core$Maybe$Nothing, $author$project$Data$APITypes$emptyUserPass),
					$elm$core$Platform$Cmd$none,
					$author$project$Data$User$LoggedOut);
			} else {
				var u = _v1.a;
				return _Utils_Tuple3(
					$author$project$Pages$Authentication$LoggedOutWith(u),
					$author$project$Requests$fetchProfile($author$project$Msg$APIProfileResult),
					$author$project$Data$User$CheckingProfile(u));
			}
		}();
		var authModel = _v0.a;
		var authCmd = _v0.b;
		var userState = _v0.c;
		var initialSession = function () {
			var defaultSession = $author$project$Data$Session$defaultSession;
			return _Utils_update(
				defaultSession,
				{dN: initialData.X.dN, d$: userState, d2: initialData.X.d2});
		}();
		var initialModel = {
			O: authModel,
			F: _List_Nil,
			y: initialData.au,
			a3: key,
			p: $author$project$Main$TransitioningFrom($author$project$Main$Blank),
			aB: $elm$core$Maybe$Nothing,
			g: initialSession
		};
		var _v2 = A3($author$project$Main$setRoute, initialRoute, initialFragment, initialModel);
		var pageModel = _v2.a;
		var pageCmd = _v2.b;
		return _Utils_Tuple2(
			pageModel,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoginMsg, authCmd),
					_List_fromArray(
						[pageCmd]))));
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {bR: body, gD: title};
	});
var $author$project$Views$Page$About = 1;
var $author$project$Views$Page$Home = 2;
var $author$project$Views$Page$Login = 3;
var $author$project$Views$Page$Other = 0;
var $author$project$Views$Page$Profile = 4;
var $author$project$Views$Page$Settings = 5;
var $author$project$Pages$Home$ViewCollection = {$: 14};
var $author$project$Msg$MenuMsg = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $elm$html$Html$Lazy$lazy4 = $elm$virtual_dom$VirtualDom$lazy4;
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Data$Version$version = '2.0.202';
var $author$project$Views$Page$viewFooter = A2(
	$elm$html$Html$footer,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('footer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('footer-left'),
							$elm$html$Html$Attributes$href('/')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('attribution')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('View our '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://readtheregs.com/privacy'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Privacy Policy')
										])),
									$elm$html$Html$text(' and '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://readtheregs.com/termsandconditions'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Terms and Conditions')
										])),
									$elm$html$Html$text('.')
								])),
							$elm$html$Html$text('Site design '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$property,
									'innerHTML',
									$elm$json$Json$Encode$string('&copy;'))
								]),
							_List_Nil),
							$elm$html$Html$text('2019 by '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://haiqu.ca'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('HaiQu Software')
								])),
							$elm$html$Html$text('. Version: ' + $author$project$Data$Version$version)
						]))
				]))
		]));
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Route$href = function (routeIn) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$routeToString(routeIn));
};
var $author$project$Views$Page$viewHeader = A2(
	$elm$html$Html$header,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('header-title')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href($author$project$Route$Home)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Read The Regs!')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('header-edition')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('GLP Edition')
				]))
		]));
var $author$project$Views$Menu$ToggleMenu = {$: 0};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Views$Menu$viewMenuToggle = function (isActive) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('menuLink'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu-link', true),
						_Utils_Tuple2('active', isActive)
					])),
				$elm$html$Html$Events$onClick($author$project$Views$Menu$ToggleMenu),
				$elm$html$Html$Attributes$title('Show/Hide the menu')
			]),
		_List_fromArray(
			[
				A2($elm$html$Html$span, _List_Nil, _List_Nil)
			]));
};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Views$Icons$svgFeatherIcon = function (className) {
	return $elm$svg$Svg$svg(
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('feather feather-' + className),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height('24'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth('2'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$width('24')
			]));
};
var $author$project$Views$Icons$chevronRight = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'chevron-right',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('9 18 15 12 9 6')
				]),
			_List_Nil)
		]));
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Views$Icons$info = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'info',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('10')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('12'),
					$elm$svg$Svg$Attributes$y1('16'),
					$elm$svg$Svg$Attributes$x2('12'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('12'),
					$elm$svg$Svg$Attributes$y1('8'),
					$elm$svg$Svg$Attributes$x2('12'),
					$elm$svg$Svg$Attributes$y2('8')
				]),
			_List_Nil)
		]));
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Views$Menu$menuEntryExt = F3(
	function (pg, title, icon) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pure-menu-item', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(pg),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pure-menu-link', true),
									_Utils_Tuple2('menu-item-with-icon', true)
								]))
						]),
					_List_fromArray(
						[
							icon,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'paddingLeft', '6px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						]))
				]));
	});
var $author$project$Requests$Pricing = {$: 4};
var $author$project$Requests$pricingPage = $author$project$Requests$endPointToString($author$project$Requests$Pricing);
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Views$Menu$RemoveSearchable = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Views$Menu$checkbox = F4(
	function (action, doclabel, hovertext, cBox) {
		var ischecked = function () {
			if (!cBox.$) {
				return $elm$html$Html$Attributes$checked(true);
			} else {
				return $elm$html$Html$Attributes$checked(false);
			}
		}();
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('menu-checkbox', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							ischecked,
							$elm$html$Html$Events$onClick(action)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$title(hovertext)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(' ' + doclabel)
						]))
				]));
	});
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $author$project$Views$Menu$getDocFromCheckbox = function (cb) {
	if (!cb.$) {
		var doc = cb.a;
		return doc;
	} else {
		var doc = cb.a;
		return doc;
	}
};
var $author$project$Views$Menu$makeDocCheckList = function (cBox) {
	var doc = $author$project$Views$Menu$getDocFromCheckbox(cBox);
	var docid = $author$project$Data$DocID$toString(doc.R);
	var doclabel = doc.f8;
	var hovertext = doc.gD;
	var action = function () {
		if (!cBox.$) {
			return $author$project$Views$Menu$RemoveSearchable(doc);
		} else {
			return $author$project$Views$Menu$AddSearchable(doc);
		}
	}();
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('pure-menu-item', true)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$fieldset,
				_List_Nil,
				_List_fromArray(
					[
						A4($author$project$Views$Menu$checkbox, action, doclabel, hovertext, cBox)
					]))
			]));
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Views$Menu$makeMenuTOC = function (outline) {
	var subs = $author$project$Data$Outline$getSubs(outline);
	var olType = $author$project$Data$Outline$getOLType(outline);
	var subList = function () {
		if (olType.$ === 9) {
			return $elm$html$Html$text('');
		} else {
			return A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-sublist')
					]),
				A2($elm$core$List$map, $author$project$Views$Menu$makeMenuTOC, subs));
		}
	}();
	var entry = $author$project$Data$Outline$getEntry(outline);
	var entTitleOrReParent = $elm$core$String$isEmpty(
		$elm$core$String$trim(entry.gD)) ? ('(re: ' + (entry.dn + ')')) : entry.gD;
	var docid = $author$project$Data$Outline$getParentDocumentID(outline);
	var linkTarget = function () {
		if (olType.$ === 9) {
			return $author$project$Route$href(
				A2($author$project$Route$SearchResultsItem, docid, entry.R));
		} else {
			return $author$project$Route$href(
				A2($author$project$Route$Contents, docid, entry.R));
		}
	}();
	var subEntry = F3(
		function (title, styleList, startHidden) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pure-menu-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									linkTarget,
									$elm$html$Html$Events$onClick($author$project$Views$Menu$ToggleMenu),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('pure-menu-link', true),
											_Utils_Tuple2('menu-hidden', startHidden)
										]))
								]),
							styleList),
						_List_fromArray(
							[title])),
						subList
					]));
		});
	var _v0 = entry.a6;
	switch (_v0.$) {
		case 0:
			var title = $elm$html$Html$text(entry.cO + (': ' + entry.gD));
			return A4(
				$elm$html$Html$Lazy$lazy3,
				subEntry,
				title,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-entry-doc')
					]),
				false);
		case 1:
			var title = $elm$html$Html$text(entry.cO + (': ' + entTitleOrReParent));
			return (entry.gD === '') ? $elm$html$Html$text('') : A4(
				$elm$html$Html$Lazy$lazy3,
				subEntry,
				title,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-entry-section')
					]),
				false);
		case 2:
			var title = $elm$html$Html$text(entry.cO + (': ' + entTitleOrReParent));
			return (entry.gD === '') ? $elm$html$Html$text('') : A4(
				$elm$html$Html$Lazy$lazy3,
				subEntry,
				title,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-entry-section')
					]),
				false);
		case 3:
			var title = $elm$html$Html$text(entry.cO + (': ' + entTitleOrReParent));
			return (entry.gD === '') ? $elm$html$Html$text('') : A4(
				$elm$html$Html$Lazy$lazy3,
				subEntry,
				title,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-entry-article')
					]),
				true);
		case 4:
			return $elm$html$Html$text('');
		case 5:
			return $elm$html$Html$text('');
		case 6:
			return $elm$html$Html$text('');
		case 7:
			return $elm$html$Html$text('');
		case 8:
			var title = $elm$html$Html$text(entry.cO + (': ' + entry.gD));
			return A4(
				$elm$html$Html$Lazy$lazy3,
				subEntry,
				title,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-entry-doc')
					]),
				true);
		case 9:
			var title = $elm$html$Html$text(entry.cO + (': ' + entTitleOrReParent));
			return A4(
				$elm$html$Html$Lazy$lazy3,
				subEntry,
				title,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-entry-searchresult')
					]),
				false);
		default:
			var title = $elm$html$Html$text(entry.cO + (': ' + entry.gD));
			return A4(
				$elm$html$Html$Lazy$lazy3,
				subEntry,
				title,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('menu-entry-doc')
					]),
				true);
	}
};
var $author$project$Views$Menu$Checked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$Menu$Unchecked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Menu$makeToggleList = F2(
	function (searchableDocs, loadedDocs) {
		var sortedDocs = A2(
			$elm$core$List$sortBy,
			function (x) {
				return $author$project$Data$DocID$toString(
					function ($) {
						return $.R;
					}(x));
			},
			loadedDocs);
		var isIn = F2(
			function (doc, sdocs) {
				var idList = A2(
					$elm$core$List$map,
					function ($) {
						return $.c2;
					},
					sdocs);
				return A2($elm$core$List$member, doc.R, idList);
			});
		var checkIt = function (doc) {
			return A2(isIn, doc, searchableDocs) ? $author$project$Views$Menu$Checked(doc) : $author$project$Views$Menu$Unchecked(doc);
		};
		return A2($elm$core$List$map, checkIt, sortedDocs);
	});
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $author$project$Views$Icons$book = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'book',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M4 19.5A2.5 2.5 0 0 1 6.5 17H20')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z')
				]),
			_List_Nil)
		]));
var $author$project$Views$Icons$bookOpen = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'book-open',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z')
				]),
			_List_Nil)
		]));
var $author$project$APIServer$devel = false;
var $author$project$Requests$GLPDefinitions = {$: 10};
var $author$project$Requests$glpDefinitionsPage = $author$project$Requests$endPointToString($author$project$Requests$GLPDefinitions);
var $author$project$Views$Icons$helpCircle = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'help-circle',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('10')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('12'),
					$elm$svg$Svg$Attributes$y1('17'),
					$elm$svg$Svg$Attributes$x2('12'),
					$elm$svg$Svg$Attributes$y2('17')
				]),
			_List_Nil)
		]));
var $author$project$Views$Menu$menuEntry = F3(
	function (pg, title, icon) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pure-menu-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(pg),
							$elm$html$Html$Events$onClick($author$project$Views$Menu$ToggleMenu),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pure-menu-link', true),
									_Utils_Tuple2('menu-item-with-icon', true)
								]))
						]),
					_List_fromArray(
						[
							icon,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'paddingLeft', '6px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						]))
				]));
	});
var $author$project$Requests$Register = {$: 1};
var $author$project$Requests$registerWithAPI = $author$project$Requests$endPointToString($author$project$Requests$Register);
var $author$project$Views$Icons$search = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'search',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('11'),
					$elm$svg$Svg$Attributes$cy('11'),
					$elm$svg$Svg$Attributes$r('8')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('21'),
					$elm$svg$Svg$Attributes$y1('21'),
					$elm$svg$Svg$Attributes$x2('16.65'),
					$elm$svg$Svg$Attributes$y2('16.65')
				]),
			_List_Nil)
		]));
var $author$project$Views$Icons$settings = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'settings',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('3')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z')
				]),
			_List_Nil)
		]));
var $author$project$Views$Icons$userPlus = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'user-plus',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('8.5'),
					$elm$svg$Svg$Attributes$cy('7'),
					$elm$svg$Svg$Attributes$r('4')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('20'),
					$elm$svg$Svg$Attributes$y1('8'),
					$elm$svg$Svg$Attributes$x2('20'),
					$elm$svg$Svg$Attributes$y2('14')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('23'),
					$elm$svg$Svg$Attributes$y1('11'),
					$elm$svg$Svg$Attributes$x2('17'),
					$elm$svg$Svg$Attributes$y2('11')
				]),
			_List_Nil)
		]));
var $author$project$Views$Menu$userMenu = function (usr) {
	if (usr.$ === 2) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pure-menu-list', true),
							_Utils_Tuple2('doclist', true)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Views$Menu$menuEntry, $author$project$Route$Home, 'Read the Regs!', $author$project$Views$Icons$bookOpen),
					A3($author$project$Views$Menu$menuEntryExt, $author$project$Requests$glpDefinitionsPage, 'Browse GLP Definitions', $author$project$Views$Icons$search),
					A3($author$project$Views$Menu$menuEntry, $author$project$Route$Settings, 'Settings', $author$project$Views$Icons$settings),
					A3($author$project$Views$Menu$menuEntry, $author$project$Route$Profile, 'Documents & Subscriptions', $author$project$Views$Icons$book),
					A3($author$project$Views$Menu$menuEntry, $author$project$Route$About, 'Help & About', $author$project$Views$Icons$helpCircle),
					$author$project$APIServer$devel ? A3($author$project$Views$Menu$menuEntry, $author$project$Route$Test, 'Test selected documents', $author$project$Views$Icons$helpCircle) : $elm$html$Html$text('')
				]));
	} else {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pure-menu-list', true),
							_Utils_Tuple2('doclist', true)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$Views$Menu$menuEntry, $author$project$Route$Home, 'Read the Regs!', $author$project$Views$Icons$bookOpen),
					A3($author$project$Views$Menu$menuEntryExt, $author$project$Requests$glpDefinitionsPage, 'Browse GLP Definitions', $author$project$Views$Icons$search),
					A3($author$project$Views$Menu$menuEntryExt, $author$project$Requests$registerWithAPI, 'Sign Up', $author$project$Views$Icons$userPlus),
					A3($author$project$Views$Menu$menuEntry, $author$project$Route$About, 'About ReadTheRegs', $author$project$Views$Icons$helpCircle),
					A3($author$project$Views$Menu$menuEntryExt, $author$project$Requests$pricingPage, 'Pricing', $author$project$Views$Icons$info)
				]));
	}
};
var $author$project$Views$Menu$viewHomeMenu = F4(
	function (usr, searchableDocs, loadedDocs, searchResults) {
		var hasDocuments = !_Utils_eq(searchableDocs, _List_Nil);
		var contents = hasDocuments ? _List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pure-menu-heading'),
						$author$project$Route$href($author$project$Route$Home),
						$elm$html$Html$Attributes$title('Click to view the top level results.')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Contents')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('pure-menu-item', true),
								_Utils_Tuple2('toc', true)
							]))
					]),
				A2($elm$core$List$map, $author$project$Views$Menu$makeMenuTOC, searchResults))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pure-menu-heading')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Select a Document')
					]))
			]);
		var avail = A2($author$project$Views$Menu$makeToggleList, searchableDocs, loadedDocs);
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('menu')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pure-menu')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pure-menu-heading')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Menu')
									])),
								$author$project$Views$Menu$userMenu(usr),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pure-menu-heading')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Documents'),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$author$project$Route$href($author$project$Route$Home),
												$elm$html$Html$Attributes$target('_top'),
												$elm$html$Html$Attributes$class('menu-heading-link-small')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('(Reload)')
											]))
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('pure-menu-list', true),
												_Utils_Tuple2('doclist', true)
											]))
									]),
								A2(
									$elm$core$List$map,
									$elm$html$Html$Lazy$lazy($author$project$Views$Menu$makeDocCheckList),
									avail))
							]),
						contents))
				]));
	});
var $author$project$Views$Menu$viewOtherMenu = F4(
	function (user, menuTitle, pageRoute, items) {
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('menu')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pure-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pure-menu-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Menu')
								])),
							$author$project$Views$Menu$userMenu(user)
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pure-menu-heading'),
							$author$project$Route$href(pageRoute),
							$elm$html$Html$Attributes$title('Scroll to Top')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(menuTitle)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pure-menu-list', true),
									_Utils_Tuple2('doclist', true)
								]))
						]),
					items)
				]));
	});
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Views$Page$viewSideMenu = F3(
	function (page, session, searchResults) {
		switch (page) {
			case 2:
				var _v1 = session.d$;
				if (_v1.$ === 2) {
					var user = _v1.a;
					return A4($author$project$Views$Menu$viewHomeMenu, session.d$, session.cg, session.b4, searchResults);
				} else {
					return A4($author$project$Views$Menu$viewOtherMenu, session.d$, 'Welcome', $author$project$Route$Home, _List_Nil);
				}
			case 5:
				return A4(
					$author$project$Views$Menu$viewOtherMenu,
					session.d$,
					'Settings',
					$author$project$Route$Settings,
					_List_fromArray(
						[
							A3($author$project$Views$Menu$menuEntryExt, '#search_settings', 'Search Settings', $author$project$Views$Icons$chevronRight),
							A3($author$project$Views$Menu$menuEntryExt, '#layout_settings', 'Layout Settings', $author$project$Views$Icons$chevronRight)
						]));
			case 4:
				return A4(
					$author$project$Views$Menu$viewOtherMenu,
					session.d$,
					'Documents & Subscriptions',
					$author$project$Route$Profile,
					_List_fromArray(
						[
							A3($author$project$Views$Menu$menuEntryExt, $author$project$Requests$pricingPage, 'Get more documents with Pro subscriptions', $author$project$Views$Icons$info)
						]));
			case 3:
				return A4($author$project$Views$Menu$viewOtherMenu, session.d$, 'Login', $author$project$Route$Login, _List_Nil);
			case 1:
				return A4(
					$author$project$Views$Menu$viewOtherMenu,
					session.d$,
					'Help & About',
					$author$project$Route$About,
					_List_fromArray(
						[
							A3($author$project$Views$Menu$menuEntryExt, '#about-readtheregs', 'About ReadTheRegs', $author$project$Views$Icons$chevronRight),
							A3($author$project$Views$Menu$menuEntryExt, '#quickstart', 'QuickStart', $author$project$Views$Icons$chevronRight),
							A3($author$project$Views$Menu$menuEntryExt, '#current-status', 'Current Status', $author$project$Views$Icons$chevronRight),
							A3($author$project$Views$Menu$menuEntryExt, '#faq', 'FAQ', $author$project$Views$Icons$chevronRight),
							A3($author$project$Views$Menu$menuEntryExt, $author$project$Requests$pricingPage, 'Pro subscriptions', $author$project$Views$Icons$info),
							A3(
							$author$project$Views$Menu$menuEntryExt,
							'https://haiqu.ca',
							'HaiQu Software',
							A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$title('HaiQu Software'),
										$elm$html$Html$Attributes$src('/img/HQ80.svg'),
										$elm$html$Html$Attributes$height(24),
										$elm$html$Html$Attributes$width(24),
										$elm$html$Html$Attributes$alt('HQ')
									]),
								_List_Nil))
						]));
			default:
				return A4($author$project$Views$Menu$viewOtherMenu, session.d$, 'Other', $author$project$Route$Home, _List_Nil);
		}
	});
var $author$project$Views$Page$contextLink = function (contextMenu) {
	var viewMenuItem = function (item) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('top-menu-item', false),
							_Utils_Tuple2('pure-menu-item', true)
						]))
				]),
			_List_fromArray(
				[item]));
	};
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('top-menu-link', false),
						_Utils_Tuple2('pure-menu-link', false),
						_Utils_Tuple2('context-menu', true)
					])),
				$elm$html$Html$Attributes$title(contextMenu.dc)
			]),
		A2($elm$core$List$map, viewMenuItem, contextMenu.db));
};
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $author$project$Views$Page$isActive = F2(
	function (page, route) {
		var _v0 = _Utils_Tuple2(page, route);
		_v0$2:
		while (true) {
			switch (_v0.a) {
				case 2:
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				case 5:
					if (_v0.b.$ === 8) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return false;
	});
var $author$project$Views$Page$navbarLink = F4(
	function (page, route, altText, linkContent) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('top-menu-item', false),
							_Utils_Tuple2('pure-menu-item', true),
							_Utils_Tuple2(
							'active',
							A2($author$project$Views$Page$isActive, page, route))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('top-menu-link', false),
									_Utils_Tuple2('pure-menu-link', true)
								])),
							$elm$html$Html$Attributes$alt(altText),
							$elm$html$Html$Attributes$title(altText),
							$author$project$Route$href(route)
						]),
					linkContent)
				]));
	});
var $author$project$Views$Icons$loader = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'loader',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('12'),
					$elm$svg$Svg$Attributes$y1('2'),
					$elm$svg$Svg$Attributes$x2('12'),
					$elm$svg$Svg$Attributes$y2('6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('12'),
					$elm$svg$Svg$Attributes$y1('18'),
					$elm$svg$Svg$Attributes$x2('12'),
					$elm$svg$Svg$Attributes$y2('22')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('4.93'),
					$elm$svg$Svg$Attributes$y1('4.93'),
					$elm$svg$Svg$Attributes$x2('7.76'),
					$elm$svg$Svg$Attributes$y2('7.76')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('16.24'),
					$elm$svg$Svg$Attributes$y1('16.24'),
					$elm$svg$Svg$Attributes$x2('19.07'),
					$elm$svg$Svg$Attributes$y2('19.07')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('2'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('6'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('18'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('22'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('4.93'),
					$elm$svg$Svg$Attributes$y1('19.07'),
					$elm$svg$Svg$Attributes$x2('7.76'),
					$elm$svg$Svg$Attributes$y2('16.24')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('16.24'),
					$elm$svg$Svg$Attributes$y1('7.76'),
					$elm$svg$Svg$Attributes$x2('19.07'),
					$elm$svg$Svg$Attributes$y2('4.93')
				]),
			_List_Nil)
		]));
var $author$project$Views$Spinner$spinner = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-icon')
		]),
	_List_fromArray(
		[$author$project$Views$Icons$loader]));
var $author$project$Utility$viewIf = F2(
	function (condition, content) {
		return condition ? content : $elm$html$Html$text('');
	});
var $author$project$Msg$LogOut = {$: 1};
var $author$project$Views$Icons$logIn = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'log-in',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('10 17 15 12 10 7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('15'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('3'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil)
		]));
var $author$project$Views$Icons$logOut = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'log-out',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('16 17 21 12 16 7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('21'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('9'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil)
		]));
var $author$project$Data$User$profileImage = function (user) {
	return $author$project$Views$Icons$book;
};
var $author$project$Views$Page$viewSignIn = F2(
	function (page, muser) {
		var logoutLink = F3(
			function (action, txt, icon) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('top-menu-item', false),
									_Utils_Tuple2('pure-menu-item', true),
									_Utils_Tuple2('active', false)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('top-menu-link', false),
											_Utils_Tuple2('pure-menu-link', true)
										])),
									$elm$html$Html$Attributes$alt(txt),
									$elm$html$Html$Attributes$title(txt),
									action,
									$elm$html$Html$Attributes$href('#')
								]),
							_List_fromArray(
								[icon]))
						]));
			});
		var loginLink = F3(
			function (action, txt, icon) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('top-menu-item', false),
									_Utils_Tuple2('pure-menu-item', true),
									_Utils_Tuple2('active', false)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('top-menu-link', false),
											_Utils_Tuple2('pure-menu-link', true)
										])),
									$elm$html$Html$Attributes$alt(txt),
									$elm$html$Html$Attributes$title(txt),
									action
								]),
							_List_fromArray(
								[icon]))
						]));
			});
		var linkTo = $author$project$Views$Page$navbarLink(page);
		if (muser.$ === 2) {
			var user = muser.a;
			return _List_fromArray(
				[
					A3(
					linkTo,
					$author$project$Route$Settings,
					'Settings',
					_List_fromArray(
						[$author$project$Views$Icons$settings])),
					A3(
					linkTo,
					$author$project$Route$Profile,
					'Documents & Subscriptions',
					_List_fromArray(
						[
							$author$project$Data$User$profileImage(user)
						])),
					A3(
					logoutLink,
					$elm$html$Html$Events$onClick(
						$author$project$Msg$LoginMsg($author$project$Msg$LogOut)),
					'Log out',
					$author$project$Views$Icons$logOut)
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					loginLink,
					$author$project$Route$href($author$project$Route$Login),
					'Register / Login',
					$author$project$Views$Icons$logIn)
				]);
		}
	});
var $author$project$Views$Page$viewTopMenu = F4(
	function (page, user, contextMenu, isLoading) {
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('top-menu'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('top-menu-container', false),
							_Utils_Tuple2('pure-menu', true),
							_Utils_Tuple2('pure-menu-horizontal', true),
							_Utils_Tuple2('pull-right', false)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('pure-menu-list', true),
									_Utils_Tuple2('top-menu-list', false),
									_Utils_Tuple2('articleMenu', false)
								]))
						]),
					A2(
						$elm$core$List$cons,
						A3($elm$html$Html$Lazy$lazy2, $author$project$Utility$viewIf, isLoading, $author$project$Views$Spinner$spinner),
						A2(
							$elm$core$List$cons,
							$author$project$Views$Page$contextLink(contextMenu),
							A2(
								$elm$core$List$cons,
								A4(
									$author$project$Views$Page$navbarLink,
									page,
									$author$project$Route$Home,
									'Read Regs',
									_List_fromArray(
										[$author$project$Views$Icons$bookOpen])),
								A2(
									$elm$core$List$cons,
									A4(
										$author$project$Views$Page$navbarLink,
										page,
										$author$project$Route$About,
										'Help & About',
										_List_fromArray(
											[$author$project$Views$Icons$helpCircle])),
									A2($author$project$Views$Page$viewSignIn, page, user))))))
				]));
	});
var $author$project$Views$Page$frame = F6(
	function (isLoading, session, page, contextMenu, searchResults, mainContent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('layout'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', session.cw),
							_Utils_Tuple2('container', true)
						]))
				]),
			_List_fromArray(
				[
					$author$project$Views$Page$viewHeader,
					A5($elm$html$Html$Lazy$lazy4, $author$project$Views$Page$viewTopMenu, page, session.d$, contextMenu, isLoading),
					A2(
					$elm$html$Html$map,
					$author$project$Msg$MenuMsg,
					A2($elm$html$Html$Lazy$lazy, $author$project$Views$Menu$viewMenuToggle, session.cw)),
					A2(
					$elm$html$Html$map,
					$author$project$Msg$MenuMsg,
					A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Page$viewSideMenu, page, session, searchResults)),
					mainContent,
					$author$project$Views$Page$viewFooter
				]));
	});
var $author$project$Views$Spinner$loadingMessageBig = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-big')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Loading your documents...')
		]));
var $author$project$Pages$About$about = ' \n# About ReadTheRegs #\n\nThis is a service (an App) that presents the content of the GLPs and other regulations, guidelines and associated documents in a consistent and modern way that makes sense for how the QA community consumes this content.\n\nWith ReadTheRegs you get the content of important regulations and guidelines from multiple jurisdictions at your fingertips:\n\n- Formatted with readability in mind;\n- Searchable by relevant keywords;\n- Links to definitions and key concepts;\n- A navigable table of contents; and\n- Easy citations of specific clauses and paragraphs.\n\nAll in a \'responsive\' document that is readable and navigable on computers, phones, and tablets.\n\nTry it, and if you don\'t find it to be the best way to Read the Regs, let us know!\n\n[Contact us with your comments!](mailto:support@readtheregs.com)\n';
var $elm$html$Html$article = _VirtualDom_node('article');
var $author$project$Pages$About$faq = '       \n## FAQ ##\n    \n### Why ReadTheRegs? ###\n\nCompliance isn\'t always straight forward, but at the very least reading and finding the applicable regulations and guidances should be easy. I built this tool to scratch an itch for my own consulting practice because I was getting annoyed having to open and search through the text of several pdfs every time I wanted to confirm a finding or cite a paragraph. \n\nSince then ReadTheRegs has grown into a platform that will eventually contain many different kinds of regulatory information, all navigable using the same interface.\n\n\n### Who are you? ###\n\nReadTheRegs is developed by [HaiQu Software](https://haiqu.ca), a software development shop based out of Canada specializing in tools and systems for the QA community.\n\nHaiQu is run by Brendan Hyland, a QA professional (RQAP-GLP) and software developer with a Masters in Engineering. \n   \n \n### Do I need to provide you my email address to use this site? ###\n\nYes, to create an account you must provide a valid email address. This helps us communicate with our users and limits abuse of the site by automated services. Please see our [Privacy Policy](https://readtheregs.com/privacy) for details on how we will use such information.\n\n\n### How should I use the information I find on this site? ###\n\nFirst and formost, your use of this website is goverened by the [Terms and Conditions](https://readtheregs.com/termsandconditions).\n\nReadTheRegs is NOT an official source for any of the regulations or guidelines. The database uses excerpts from the original sources that have been processed and reformatted in various ways. This processed content was not created by the original publishers, and is not in any way official or legal editions of the originals.\n\nWhile we do our best to check the correctness of the information we present, please view the service as a convenience, provided on an as-is basis with no warranty. This means you should *use due diligence* and *QC any decisions or findings against the original sources.* If you do find any problems, please [let us know](mailto:support@readtheregs.com)!\n\n\n### How will you use my information?\n\nSee our [Privacy Policy](https://readtheregs.com/privacy) for details on how we will use any information we might gather through your use of the site.\n';
var $author$project$Pages$About$instructions = '\n# QuickStart #\n\n1. There is a menu to the left that allows you to navigate around the app:\n   * On small screens, the menu may be hidden. \n   * To reveal the hidden menu, tap the \'hamburger\' ![(hamburger icon)](img/hamburger-small.png) icon at the top left of the screen;\n2. Once you are signed in:\n   * If you don\'t see a document open, click \'Read the Regs!\' or ![the open book icon](img/open-book.png);\n   * In the side menu there should be a list of several documents that you can select to read and search through;\n   * Select one of those documents, or navigate to \'Documents and Subscriptions\' ![the closed book icon](img/closed-book.png) to change the available documents;\n3. Use the search bar to search within the selected document(s). At least one document must be selected for search to be enabled;\n4. Hover over or select a paragraph to reveal a mini-menu on the right to:\n  * Create and copy a citation ![(paperclip icon)](img/paperclip.png) for the selected paragraph;\n  * Create and copy the paragraph text ![(copy icon)](img/clipboard.png) along with a citation;\n  * Choose an entry ![(circle icon)](img/circle.png) to add to your \'collection\'. Collections are a convenient way to select multiple, unrelated paragraphs to cite or copy.\n5. View your current collection from the Collections link ![(briefcase icon)](img/briefcase.png) at the top (only visible if you have collected entries);\n6. Change and save search options from the \'Settings\' menu ![(gear icon)](img/gear.png);\n7. Select, add or remove documents to be searched from the \'Documents and Subscriptions\' page ![(closed-book icon)](img/closed-book.png). \n\n';
var $author$project$Pages$About$status = '\n# Current Status #\n\n- The OECD, FDA and EPA GLPs are available for navigation;\n- Pro subscriptions are now available with additional documents (e.g. Part 11, CSV and archiving guidance) and features. More content will be generated and checked over time;\n- Content is automatically generated, and although we do our best to QC documents, any citations from this service should be checked against sources;\n\nThis is a work in progress. As such, format, presentation and tools are being actively changed as development progresses.\n\nWhile we do our best to check the correctness of the information we present, please view the service as a convenience. This means you should *use due diligence* and *QC any decisions or findings against the original sources.* See the Terms and Conditions document linked below for more information.\n\nIf you do find any problems, please [let us know!](mailto:support@readtheregs.com)!\n\n*_WARNING_: ReadTheRegs is NOT an official source for any of the regulations or guidelines. The database uses excerpts from the original sources that have been processed and reformatted in various ways. This processed content was not created by the original publishers, and is not in any way official or legal editions of the originals.*\n\n';
var $elm_explorations$markdown$Markdown$defaultOptions = {
	eV: $elm$core$Maybe$Nothing,
	fc: $elm$core$Maybe$Just(
		{eC: false, gn: false}),
	f0: true,
	gb: false
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $author$project$Pages$About$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('content-container')
		]),
	A2(
		$elm$core$List$map,
		function (x) {
			return A2(
				$elm$html$Html$article,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, x)
					]));
		},
		_List_fromArray(
			[$author$project$Pages$About$about, $author$project$Pages$About$instructions, $author$project$Pages$About$status, $author$project$Pages$About$faq])));
var $author$project$Data$Errors$httpErrToString = function (s) {
	switch (s.$) {
		case 0:
			var hs = s.a;
			return 'Bad url: ' + hs;
		case 1:
			return 'Timeout';
		case 2:
			return 'Network Error';
		case 3:
			var rs = s.a;
			return 'Bad Status: ' + $elm$core$String$fromInt(rs);
		default:
			var rs = s.a;
			return 'Bad Payload: ' + rs;
	}
};
var $author$project$Msg$EmailUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$LoggingIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$PWUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$SubmitLogin = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$Submitted = {$: 3};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Requests$ForgotPassword = {$: 2};
var $author$project$Requests$forgotPassword = $author$project$Requests$endPointToString($author$project$Requests$ForgotPassword);
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pages$Authentication$loginForm = F2(
	function (mmsg, userpass) {
		var msgAlert = function () {
			if (mmsg.$ === 1) {
				return $elm$html$Html$text('');
			} else {
				var msg = mmsg.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('alert')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(msg)
						]));
			}
		}();
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('login'),
					$elm$html$Html$Events$onSubmit(
					$author$project$Msg$LoggingIn($author$project$Msg$Submitted))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('login-container')
						]),
					_List_fromArray(
						[
							msgAlert,
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('uname')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Username')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('email'),
									$elm$html$Html$Attributes$placeholder('Enter Email'),
									$elm$html$Html$Attributes$name('uname'),
									$elm$html$Html$Attributes$required(true),
									$elm$html$Html$Attributes$value(userpass.a1),
									$elm$html$Html$Events$onInput(
									function (x) {
										return $author$project$Msg$LoggingIn(
											$author$project$Msg$EmailUpdated(x));
									}),
									A2($elm$html$Html$Attributes$attribute, 'autocorrect', 'off'),
									A2($elm$html$Html$Attributes$attribute, 'autocapitalize', 'off'),
									A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'on'),
									$elm$html$Html$Attributes$spellcheck(false)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('psw')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Password')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('password'),
									$elm$html$Html$Attributes$placeholder('Enter Password'),
									$elm$html$Html$Attributes$name('psw'),
									$elm$html$Html$Attributes$required(true),
									$elm$html$Html$Attributes$value(userpass.cb),
									A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'on'),
									$elm$html$Html$Events$onInput(
									function (x) {
										return $author$project$Msg$LoggingIn(
											$author$project$Msg$PWUpdated(x));
									})
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('submit'),
									$elm$html$Html$Events$onClick(
									$author$project$Msg$LoggingIn(
										$author$project$Msg$SubmitLogin(userpass)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Login')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('login-container'),
							A2($elm$html$Html$Attributes$style, 'background-color', '#f1f1f1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('psw')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Forgot your '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href($author$project$Requests$forgotPassword)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Password?')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('psw2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sign up for a '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href($author$project$Requests$registerWithAPI)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Account')
										])),
									$elm$html$Html$text('.')
								]))
						]))
				]));
	});
var $author$project$Pages$Authentication$view = function (model) {
	switch (model.$) {
		case 4:
			var err = model.a;
			var msg = function () {
				_v1$2:
				while (true) {
					if (!err.$) {
						switch (err.a.$) {
							case 4:
								var m = err.a.a;
								return $elm$core$Maybe$Just(
									$author$project$Data$Errors$httpErrToString(m) + ' : Please try again later.');
							case 3:
								var m = err.a.a;
								return $elm$core$Maybe$Just('Internal Error - Invalid Request of: ' + m);
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return $elm$core$Maybe$Nothing;
			}();
			return A2($author$project$Pages$Authentication$loginForm, msg, $author$project$Data$APITypes$emptyUserPass);
		case 2:
			var user = model.a;
			return A2(
				$author$project$Pages$Authentication$loginForm,
				$elm$core$Maybe$Just('Attempting to log in with the last session: ' + user.a1),
				$author$project$Data$APITypes$emptyUserPass);
		case 1:
			var user = model.a;
			return A2(
				$author$project$Pages$Authentication$loginForm,
				$elm$core$Maybe$Just('You are logged in as: ' + user.a1),
				$author$project$Data$APITypes$emptyUserPass);
		case 3:
			return $elm$html$Html$text('Contacting Server, please wait...');
		default:
			var msg = model.a;
			var userpass = model.b;
			return A2($author$project$Pages$Authentication$loginForm, msg, userpass);
	}
};
var $author$project$Pages$Home$ToggleMenu = {$: 4};
var $author$project$Views$Icons$chevronsLeft = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'chevrons-left',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('11 17 6 12 11 7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('18 17 13 12 18 7')
				]),
			_List_Nil)
		]));
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Pages$Home$ShowDocInfo = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Home$infoLinkLink = function (outline) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('articleMenu', true)
					])),
				$elm$html$Html$Attributes$title('Document information'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Home$ShowDocInfo(outline)),
				$elm$html$Html$Attributes$href('#')
			]),
		_List_fromArray(
			[$author$project$Views$Icons$info]));
};
var $author$project$Pages$Home$mdOptions = {
	eV: $elm$core$Maybe$Nothing,
	fc: $elm$core$Maybe$Just(
		{eC: true, gn: false}),
	f0: false,
	gb: true
};
var $author$project$Pages$Home$fineprint = F2(
	function (ol, session) {
		var mdoc = function (outline) {
			return A2($author$project$Data$Outline$getDoc, outline, session.b4);
		};
		var doc = mdoc(ol);
		var publisher = function () {
			var _v0 = doc.bk;
			switch (_v0.$) {
				case 1:
					return 'U.S. Federal Government';
				case 2:
					return 'U.S. Federal Government';
				case 3:
					return 'OECD';
				default:
					return 'publisher';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fineprint')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Notice for ' + doc.f8)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This database uses excerpts from the original source that have been processed and reformatted in various ways. This processed content was not created by the ' + (publisher + ' and is not an official nor legal edition of the original:'))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$em,
							_List_Nil,
							_List_fromArray(
								[
									A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Pages$Home$mdOptions, _List_Nil, doc.e9)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('For more information on the source document, click on the info icon')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('articleMenu-visible')
								]),
							_List_fromArray(
								[
									$author$project$Pages$Home$infoLinkLink(ol)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' here or beside any document title.')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' For the terms and conditions of your use of the processed content, see the linked documents at the bottom of this page.')
								]))
						]))
				]));
	});
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Pages$Home$makeAnchorString = function (ol) {
	var ent = $author$project$Data$Outline$getEntry(ol);
	var pID = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Data$ID$empty,
		function ($) {
			return $.dm;
		}(ent));
	var eID = function ($) {
		return $.R;
	}(ent);
	var dID = $author$project$Data$Outline$getParentDocumentID(ol);
	return $author$project$Data$ID$toString(eID);
};
var $author$project$Pages$Home$AddToCollection = function (a) {
	return {$: 12, a: a};
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Utility$buttonAsLink = F2(
	function (attr, elementList) {
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'role', 'link'),
				_Utils_ap(
					attr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('button-link', true)
								])),
							$elm$html$Html$Attributes$tabindex(0)
						]))),
			elementList);
	});
var $author$project$Views$Icons$circle = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'circle',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('10')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Home$addToCollectionLink = function (outline) {
	return A2(
		$author$project$Utility$buttonAsLink,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('articleMenu', true)
					])),
				$elm$html$Html$Attributes$title('Add entry to collection'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Home$AddToCollection(outline))
			]),
		_List_fromArray(
			[$author$project$Views$Icons$circle]));
};
var $author$project$Pages$Home$CiteEntry = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$Icons$paperclip = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'paperclip',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Home$citeEntryLink = function (outline) {
	return A2(
		$author$project$Utility$buttonAsLink,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('articleMenu', true)
					])),
				$elm$html$Html$Attributes$title('Cite this entry'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Home$CiteEntry(outline))
			]),
		_List_fromArray(
			[$author$project$Views$Icons$paperclip]));
};
var $author$project$Pages$Home$CopyEntry = function (a) {
	return {$: 6, a: a};
};
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$Views$Icons$clipboard = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'clipboard',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('8'),
					$elm$svg$Svg$Attributes$y('2'),
					$elm$svg$Svg$Attributes$width('8'),
					$elm$svg$Svg$Attributes$height('4'),
					$elm$svg$Svg$Attributes$rx('1'),
					$elm$svg$Svg$Attributes$ry('1')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Home$copyTextLink = function (outline) {
	return A2(
		$author$project$Utility$buttonAsLink,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('articleMenu', true)
					])),
				$elm$html$Html$Attributes$title('Copy this entry to clipboard'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Home$CopyEntry(outline))
			]),
		_List_fromArray(
			[$author$project$Views$Icons$clipboard]));
};
var $author$project$Pages$Home$RemoveFromCollection = function (a) {
	return {$: 13, a: a};
};
var $author$project$Views$Icons$checkCircle = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'check-circle',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M22 11.08V12a10 10 0 1 1-5.93-9.14')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('22 4 12 14.01 9 11.01')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Home$removeFromCollectionLink = function (outline) {
	return A2(
		$author$project$Utility$buttonAsLink,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('articleMenu', true),
						_Utils_Tuple2('articleMenu-always-on', true)
					])),
				$elm$html$Html$Attributes$title('Remove entry from collection'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Home$RemoveFromCollection(outline))
			]),
		_List_fromArray(
			[$author$project$Views$Icons$checkCircle]));
};
var $author$project$Pages$Home$textMenuBox = F3(
	function (heading, cont, subMenu) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textMenu-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textMenu-heading')
						]),
					_List_fromArray(
						[heading])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textMenu-content')
						]),
					cont),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textMenu-menu')
						]),
					subMenu)
				]));
	});
var $author$project$Pages$Home$articleMenu = F4(
	function (outline, collected, heading, cont) {
		var hasContent = !$elm$core$String$isEmpty(
			$author$project$Data$Outline$getEntry(outline).eO);
		var menu = _List_fromArray(
			[
				collected ? $author$project$Pages$Home$removeFromCollectionLink(outline) : $author$project$Pages$Home$addToCollectionLink(outline),
				$author$project$Pages$Home$citeEntryLink(outline),
				hasContent ? $author$project$Pages$Home$copyTextLink(outline) : $elm$html$Html$text('')
			]);
		return A3($author$project$Pages$Home$textMenuBox, heading, cont, menu);
	});
var $author$project$Pages$Home$headingMenuBox = F2(
	function (heading, subMenu) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('headingMenu-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('headingMenu-heading')
						]),
					_List_fromArray(
						[heading])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('headingMenu-menu')
						]),
					subMenu)
				]));
	});
var $author$project$Pages$Home$collapsedMenu = F3(
	function (outline, collected, heading) {
		var menu = _List_fromArray(
			[
				collected ? $author$project$Pages$Home$removeFromCollectionLink(outline) : $author$project$Pages$Home$addToCollectionLink(outline)
			]);
		return A2($author$project$Pages$Home$headingMenuBox, heading, menu);
	});
var $author$project$Pages$Home$RemoveAllFromCollection = {$: 15};
var $author$project$Views$Icons$trash2 = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'trash-2',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('3 6 5 6 21 6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('10'),
					$elm$svg$Svg$Attributes$y1('11'),
					$elm$svg$Svg$Attributes$x2('10'),
					$elm$svg$Svg$Attributes$y2('17')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('14'),
					$elm$svg$Svg$Attributes$y1('11'),
					$elm$svg$Svg$Attributes$x2('14'),
					$elm$svg$Svg$Attributes$y2('17')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Home$clearCollectionsLink = A2(
	$author$project$Utility$buttonAsLink,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('articleMenu', true),
					_Utils_Tuple2('articleMenu-always-on', true)
				])),
			$elm$html$Html$Attributes$title('Remove all entries from the collection'),
			$elm$html$Html$Events$onClick($author$project$Pages$Home$RemoveAllFromCollection)
		]),
	_List_fromArray(
		[$author$project$Views$Icons$trash2]));
var $author$project$Pages$Home$ExportAllCollectionCitations = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Home$exportCollectionsCitationsLink = function (outline) {
	return A2(
		$author$project$Utility$buttonAsLink,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('articleMenu', true),
						_Utils_Tuple2('articleMenu-always-on', true)
					])),
				$elm$html$Html$Attributes$title('Export all collected entry citations'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Home$ExportAllCollectionCitations(outline))
			]),
		_List_fromArray(
			[$author$project$Views$Icons$paperclip]));
};
var $author$project$Pages$Home$ExportAllCollectionContents = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Home$exportCollectionsContentLink = function (outline) {
	return A2(
		$author$project$Utility$buttonAsLink,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('articleMenu', true),
						_Utils_Tuple2('articleMenu-always-on', true)
					])),
				$elm$html$Html$Attributes$title('Export all collected entry citations'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Home$ExportAllCollectionContents(outline))
			]),
		_List_fromArray(
			[$author$project$Views$Icons$clipboard]));
};
var $author$project$Pages$Home$collectionMenu = F2(
	function (outline, heading) {
		var menu = _List_fromArray(
			[
				$author$project$Pages$Home$clearCollectionsLink,
				$author$project$Pages$Home$exportCollectionsCitationsLink(outline),
				$author$project$Pages$Home$exportCollectionsContentLink(outline)
			]);
		return A2($author$project$Pages$Home$headingMenuBox, heading, menu);
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Pages$Home$createHeading = F3(
	function (docLevel, title, isCollapsed) {
		var sep = A2(
			$elm$core$List$all,
			function (x) {
				return $elm$core$Char$isAlpha(x) || (x === ' ');
			},
			$elm$core$String$toList(docLevel)) ? ': ' : (A2(
			$elm$core$List$all,
			$elm$core$Char$isAlpha,
			$elm$core$String$toList(
				A2($elm$core$String$right, 1, docLevel))) ? ') ' : '. ');
		var els = isCollapsed ? '...' : '';
		return ((title === '') || _Utils_eq(docLevel, title)) ? _Utils_ap(docLevel, els) : _Utils_ap(
			docLevel,
			_Utils_ap(
				sep,
				_Utils_ap(title, els)));
	});
var $author$project$Pages$Home$documentMenu = F2(
	function (outline, heading) {
		var menu = _List_fromArray(
			[
				$author$project$Pages$Home$infoLinkLink(outline)
			]);
		return A2($author$project$Pages$Home$headingMenuBox, heading, menu);
	});
var $author$project$Data$Outline$getOutlineVisibility = function (_v0) {
	var x = _v0;
	return x.cs;
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $author$project$Search$markKeywordsInPhrase = F2(
	function (keywords, txt) {
		var kwds = A2(
			$elm$core$String$join,
			'|',
			A2($elm$core$List$map, $author$project$Search$getSearchTerm, keywords));
		var regexStr = '\\b' + (kwds + '\\b');
		return _Utils_eq(keywords, _List_Nil) ? txt : A3(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				A2(
					$elm$regex$Regex$fromStringWith,
					{eF: true, fD: true},
					regexStr)),
			function (_v0) {
				var match = _v0.fA;
				return '<span class=\"highlight\">' + (match + '</span>');
			},
			txt);
	});
var $author$project$Pages$Home$highlightWords = F2(
	function (searchTerms, txt) {
		return _Utils_eq(searchTerms, _List_Nil) ? _List_fromArray(
			[
				A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Pages$Home$mdOptions, _List_Nil, txt)
			]) : _List_fromArray(
			[
				A3(
				$elm_explorations$markdown$Markdown$toHtmlWith,
				$author$project$Pages$Home$mdOptions,
				_List_Nil,
				A2($author$project$Search$markKeywordsInPhrase, searchTerms, txt))
			]);
	});
var $elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
var $elm$html$Html$Lazy$lazy5 = $elm$virtual_dom$VirtualDom$lazy5;
var $author$project$Pages$Home$makeBreadCrumbs = function (outline) {
	var entry = $author$project$Data$Outline$getEntry(outline);
	var parentLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$Route$href(
				A2(
					$author$project$Route$Contents,
					$author$project$Data$Outline$getParentDocumentID(outline),
					A2($elm$core$Maybe$withDefault, $author$project$Data$ID$empty, entry.dm)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(entry.dn)
			]));
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('breadCrumbs')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Under: '),
				parentLink
			]));
};
var $author$project$Data$SearchInfo$searchRatingToString = function (searchRating) {
	switch (searchRating.$) {
		case 0:
			var s = searchRating.a;
			return $elm$core$Maybe$Nothing;
		case 1:
			var s = searchRating.a;
			return $elm$core$Maybe$Just('Content match for (\'' + (s + '\')'));
		case 2:
			var s = searchRating.a;
			return $elm$core$Maybe$Just('Title match for (\'' + (s + '\')'));
		default:
			var s = searchRating.a;
			return $elm$core$Maybe$Just('Keyword match for (\'' + (s + '\')'));
	}
};
var $author$project$Data$SearchInfo$searchRatingsToString = function (searchRatings) {
	return A2(
		$elm$core$String$join,
		'; ',
		$elm_community$maybe_extra$Maybe$Extra$values(
			A2($elm$core$List$map, $author$project$Data$SearchInfo$searchRatingToString, searchRatings)));
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Pages$Home$viewArticle = F3(
	function (searchTerms, outline, collection) {
		var subs = $author$project$Data$Outline$getSubs(outline);
		var isCollapsed = function () {
			var _v8 = $author$project$Data$Outline$getOutlineVisibility(outline);
			switch (_v8) {
				case 0:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		}();
		var ent = $author$project$Data$Outline$getEntry(outline);
		var titleFixed = A3($author$project$Pages$Home$createHeading, ent.cO, ent.gD, isCollapsed);
		var heading = A2(
			$elm$html$Html$h4,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(titleFixed)
				]));
		var cont = function () {
			var _v7 = $author$project$Data$Outline$getOutlineVisibility(outline);
			if (_v7 === 3) {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$String$left, 300, ent.eO) + '...')
					]);
			} else {
				return (ent.gD === '') ? A2($author$project$Pages$Home$highlightWords, searchTerms, ent.cO + (') ' + ent.eO)) : A2($author$project$Pages$Home$highlightWords, searchTerms, ent.eO);
			}
		}();
		var collected = A2(
			$elm$core$Set$member,
			$author$project$Data$ID$toString(
				$author$project$Data$Outline$getOutlineID(outline)),
			collection);
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('Entry')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Pages$Home$makeAnchorString(outline)),
							$elm$html$Html$Attributes$class('EntryID'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('EntryCollapsed'),
							$elm$html$Html$Attributes$hidden(!isCollapsed)
						]),
					_List_fromArray(
						[
							A3($author$project$Pages$Home$collapsedMenu, outline, collected, heading)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('EntryContent'),
							$elm$html$Html$Attributes$hidden(isCollapsed)
						]),
					_List_fromArray(
						[
							(ent.gD === '') ? A4(
							$author$project$Pages$Home$articleMenu,
							outline,
							collected,
							$elm$html$Html$text(''),
							cont) : A4($author$project$Pages$Home$articleMenu, outline, collected, heading, cont)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ArtLowerEntries'),
							$elm$html$Html$Attributes$hidden(isCollapsed)
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$Pages$Home$viewEntries, searchTerms, false, false, collection),
						subs))
				]));
	});
var $author$project$Pages$Home$viewCollectedDoc = F5(
	function (searchTerms, summarize, columnView, outline, collection) {
		var subs = $author$project$Data$Outline$getSubs(outline);
		var isCollapsed = false;
		var doc = $author$project$Data$Outline$getEntry(outline);
		var cont = A2($author$project$Pages$Home$highlightWords, searchTerms, doc.eO);
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('Document', true),
							_Utils_Tuple2('col', columnView)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Pages$Home$makeAnchorString(outline)),
							$elm$html$Html$Attributes$class('DocID'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Home$collectionMenu,
							outline,
							$elm$html$Html$text('')),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocContent'),
									$elm$html$Html$Attributes$hidden(!isCollapsed)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(doc.cO + (': ' + (doc.gD + '...')))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocTitle'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(doc.cO + (': ' + doc.gD))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocContent'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							cont),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('TopLevelEntries'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							A2(
								$elm$core$List$map,
								A4($author$project$Pages$Home$viewEntries, searchTerms, summarize, columnView, collection),
								subs))
						]))
				]));
	});
var $author$project$Pages$Home$viewDefinition = F3(
	function (searchTerms, outline, collection) {
		var subs = $author$project$Data$Outline$getSubs(outline);
		var isCollapsed = function () {
			var _v6 = $author$project$Data$Outline$getOutlineVisibility(outline);
			switch (_v6) {
				case 0:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		}();
		var ent = $author$project$Data$Outline$getEntry(outline);
		var entryNumbering = (ent.cO === '') ? '' : (ent.cO + ') ');
		var entryText = (ent.gD === '') ? ((entryNumbering === '') ? ent.eO : (entryNumbering + ('   ' + ent.eO))) : (entryNumbering + (' *' + (ent.gD + ('*:   ' + ent.eO))));
		var els = isCollapsed ? '...' : '';
		var heading = (ent.gD === '') ? A2(
			$elm$html$Html$h4,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					_Utils_ap(ent.cO, els))
				])) : A2(
			$elm$html$Html$h4,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(ent.cO + (' ' + (ent.gD + els)))
				]));
		var cont = function () {
			var _v5 = $author$project$Data$Outline$getOutlineVisibility(outline);
			if (_v5 === 3) {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$String$left, 300, ent.eO) + '...')
					]);
			} else {
				return A2($author$project$Pages$Home$highlightWords, searchTerms, entryText);
			}
		}();
		var collected = A2(
			$elm$core$Set$member,
			$author$project$Data$ID$toString(
				$author$project$Data$Outline$getOutlineID(outline)),
			collection);
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('Definition')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Pages$Home$makeAnchorString(outline)),
							$elm$html$Html$Attributes$class('EntryID'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('Definition-collapsed'),
							$elm$html$Html$Attributes$hidden(!isCollapsed)
						]),
					_List_fromArray(
						[
							A3($author$project$Pages$Home$collapsedMenu, outline, collected, heading)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('DefinitionContent'),
							$elm$html$Html$Attributes$hidden(isCollapsed)
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Pages$Home$articleMenu,
							outline,
							collected,
							$elm$html$Html$text(''),
							cont)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('DefLowerEntries'),
							$elm$html$Html$Attributes$hidden(isCollapsed)
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$Pages$Home$viewEntries, searchTerms, false, false, collection),
						subs))
				]));
	});
var $author$project$Pages$Home$viewDoc = F4(
	function (searchTerms, columnView, outline, collection) {
		var subs = $author$project$Data$Outline$getSubs(outline);
		var isCollapsed = function () {
			var _v4 = $author$project$Data$Outline$getOutlineVisibility(outline);
			switch (_v4) {
				case 0:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		}();
		var doc = $author$project$Data$Outline$getEntry(outline);
		var cont = function () {
			var _v3 = $author$project$Data$Outline$getOutlineVisibility(outline);
			if (_v3 === 3) {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$String$left, 300, doc.eO) + '...')
					]);
			} else {
				return A2($author$project$Pages$Home$highlightWords, searchTerms, doc.eO);
			}
		}();
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('Document', true),
							_Utils_Tuple2('col', columnView)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Pages$Home$makeAnchorString(outline)),
							$elm$html$Html$Attributes$class('DocID'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocContent'),
									$elm$html$Html$Attributes$hidden(!isCollapsed)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Home$documentMenu,
									outline,
									A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(doc.cO + (': ' + (doc.gD + '...')))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocTitle'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Home$documentMenu,
									outline,
									A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(doc.cO + (': ' + doc.gD))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocContent'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							cont),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('TopLevelEntries'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							A2(
								$elm$core$List$map,
								A4($author$project$Pages$Home$viewEntries, searchTerms, false, columnView, collection),
								subs))
						]))
				]));
	});
var $author$project$Pages$Home$viewEntries = F5(
	function (searchTerms, summarize, columnView, collection, outline) {
		var _v2 = $author$project$Data$Outline$getEntry(outline).a6;
		switch (_v2.$) {
			case 0:
				return A5($elm$html$Html$Lazy$lazy4, $author$project$Pages$Home$viewDoc, searchTerms, columnView, outline, collection);
			case 1:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewSec, searchTerms, outline, collection);
			case 2:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewSec, searchTerms, outline, collection);
			case 3:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewArticle, searchTerms, outline, collection);
			case 4:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewDefinition, searchTerms, outline, collection);
			case 5:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewArticle, searchTerms, outline, collection);
			case 6:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewDefinition, searchTerms, outline, collection);
			case 7:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewArticle, searchTerms, outline, collection);
			case 8:
				return A6($elm$html$Html$Lazy$lazy5, $author$project$Pages$Home$viewSearchDoc, searchTerms, summarize, columnView, outline, collection);
			case 9:
				var searchInfo = _v2.a;
				return A6($elm$html$Html$Lazy$lazy5, $author$project$Pages$Home$viewSearchResult, searchTerms, searchInfo, summarize, outline, collection);
			default:
				return A6($elm$html$Html$Lazy$lazy5, $author$project$Pages$Home$viewCollectedDoc, searchTerms, summarize, columnView, outline, collection);
		}
	});
var $author$project$Pages$Home$viewSearchDoc = F5(
	function (searchTerms, summarize, columnView, outline, collection) {
		var subs = $author$project$Data$Outline$getSubs(outline);
		var isCollapsed = false;
		var doc = $author$project$Data$Outline$getEntry(outline);
		var cont = A2($author$project$Pages$Home$highlightWords, searchTerms, doc.eO);
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('Document', true),
							_Utils_Tuple2('col', columnView)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Pages$Home$makeAnchorString(outline)),
							$elm$html$Html$Attributes$class('DocID'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocContent'),
									$elm$html$Html$Attributes$hidden(!isCollapsed)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Home$documentMenu,
									outline,
									A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(doc.cO + (': ' + (doc.gD + '...')))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocTitle'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Home$documentMenu,
									outline,
									A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(doc.cO + (': ' + doc.gD))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocContent'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							cont),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('TopLevelEntries'),
									$elm$html$Html$Attributes$hidden(isCollapsed)
								]),
							A2(
								$elm$core$List$map,
								A4($author$project$Pages$Home$viewEntries, searchTerms, summarize, columnView, collection),
								subs))
						]))
				]));
	});
var $author$project$Pages$Home$viewSearchResult = F5(
	function (searchTerms, searchInfo, summarize, outline, collection) {
		var subs = $author$project$Data$Outline$getSubs(outline);
		var sec = $author$project$Data$Outline$getEntry(outline);
		var resultInfo = function () {
			var score = $elm$core$String$fromInt(
				$author$project$Data$SearchInfo$getSearchScore(searchInfo));
			var matchInfo = $author$project$Data$SearchInfo$searchRatingsToString(
				$author$project$Data$SearchInfo$getSearchRating(searchInfo));
			return matchInfo;
		}();
		var heading = (sec.gD === '') ? A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(sec.cO)
				])) : A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(sec.cO + (' ' + sec.gD))
				]));
		var hasContent = sec.eO !== '';
		var els = summarize ? '...' : '';
		var docid = $author$project$Data$Outline$getParentDocumentID(outline);
		var fullContentLink = summarize ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$SearchResultsItem, docid, sec.R))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('[expand]')
				])) : $elm$html$Html$text('');
		var cont = summarize ? _Utils_ap(
			A2($elm$core$String$left, 300, sec.eO),
			els) : sec.eO;
		var highlitCont = _Utils_ap(
			A2($author$project$Pages$Home$highlightWords, searchTerms, cont),
			_List_fromArray(
				[fullContentLink]));
		var collected = A2(
			$elm$core$Set$member,
			$author$project$Data$ID$toString(
				$author$project$Data$Outline$getOutlineID(outline)),
			collection);
		var content = hasContent ? A4($author$project$Pages$Home$articleMenu, outline, collected, heading, highlitCont) : A3($author$project$Pages$Home$collapsedMenu, outline, collected, heading);
		var breadCrumbs = $author$project$Pages$Home$makeBreadCrumbs(outline);
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('SearchResults')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('SearchResultInfo'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(resultInfo)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Pages$Home$makeAnchorString(outline)),
							$elm$html$Html$Attributes$class('SecID'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('SecContent'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_fromArray(
						[breadCrumbs, content])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('SearchResultSubs'),
							$elm$html$Html$Attributes$hidden(summarize)
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$Pages$Home$viewEntries, searchTerms, summarize, false, collection),
						subs))
				]));
	});
var $author$project$Pages$Home$viewSec = F3(
	function (searchTerms, outline, collection) {
		var subs = $author$project$Data$Outline$getSubs(outline);
		var sec = $author$project$Data$Outline$getEntry(outline);
		var isCollapsed = function () {
			var _v1 = $author$project$Data$Outline$getOutlineVisibility(outline);
			switch (_v1) {
				case 0:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		}();
		var heading = A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Pages$Home$createHeading, sec.cO, sec.gD, isCollapsed))
				]));
		var hasContent = sec.eO !== '';
		var cont = function () {
			var _v0 = $author$project$Data$Outline$getOutlineVisibility(outline);
			if (_v0 === 3) {
				return _List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$String$left, 300, sec.eO) + '...')
					]);
			} else {
				return A2($author$project$Pages$Home$highlightWords, searchTerms, sec.eO);
			}
		}();
		var collected = A2(
			$elm$core$Set$member,
			$author$project$Data$ID$toString(
				$author$project$Data$Outline$getOutlineID(outline)),
			collection);
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('Section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(
							$author$project$Pages$Home$makeAnchorString(outline)),
							$elm$html$Html$Attributes$class('SecID'),
							$elm$html$Html$Attributes$hidden(false)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('SecContent'),
							$elm$html$Html$Attributes$hidden(!isCollapsed)
						]),
					_List_fromArray(
						[
							A3($author$project$Pages$Home$collapsedMenu, outline, collected, heading)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('SecContent'),
							$elm$html$Html$Attributes$hidden(isCollapsed)
						]),
					_List_fromArray(
						[
							hasContent ? A4($author$project$Pages$Home$articleMenu, outline, collected, heading, cont) : A3($author$project$Pages$Home$collapsedMenu, outline, collected, heading)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('SecLowerEntries'),
							$elm$html$Html$Attributes$hidden(isCollapsed)
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$Pages$Home$viewEntries, searchTerms, false, false, collection),
						subs))
				]));
	});
var $author$project$Pages$Home$viewContent = F2(
	function (session, model) {
		var searchTerms = A2($author$project$Search$prepareSearchTerms, model.bE, session.dN);
		var viewTopLevel = function (entry) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('panel', true),
								_Utils_Tuple2('col', session.d2.bT)
							]))
					]),
				_List_fromArray(
					[
						A5($author$project$Pages$Home$viewEntries, searchTerms, session.d2.cm, session.d2.bT, model.eM, entry),
						A2($author$project$Pages$Home$fineprint, entry, session)
					]));
		};
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('content', true),
							_Utils_Tuple2('active', session.cw),
							_Utils_Tuple2('col', session.d2.bT)
						])),
					session.cw ? $elm$html$Html$Events$onClick($author$project$Pages$Home$ToggleMenu) : $elm$html$Html$Events$onClick($author$project$Pages$Home$None)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('searchresults', true),
									_Utils_Tuple2('col', session.d2.bT)
								]))
						]),
					A2(
						$elm$core$List$cons,
						function () {
							if (model.a5) {
								var mTopOL = $elm$core$List$head(model._);
								var docRef = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Pages$Home$makeAnchorString, mTopOL));
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('backarrow')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('search-glass'),
													$elm$html$Html$Attributes$href('/#' + docRef),
													$elm$html$Html$Attributes$title('Expand view to see the context')
												]),
											_List_fromArray(
												[$author$project$Views$Icons$chevronsLeft]))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
						A2($elm$core$List$map, viewTopLevel, model._)))
				]));
	});
var $author$project$Pages$Home$ClosePopup = {$: 8};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Utility$onKeyCode = F2(
	function (value, msg) {
		var isEnter = function (code) {
			return _Utils_eq(code, value) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not Keycode');
		};
		return A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2($elm$json$Json$Decode$andThen, isEnter, $elm$html$Html$Events$keyCode));
	});
var $author$project$Utility$onEsc = function (msg) {
	return A2($author$project$Utility$onKeyCode, 27, msg);
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$Pages$Home$textWithBreaks = function (txt) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(txt)
				]))
		]);
};
var $author$project$Views$Icons$x = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'x',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('18'),
					$elm$svg$Svg$Attributes$y1('6'),
					$elm$svg$Svg$Attributes$x2('6'),
					$elm$svg$Svg$Attributes$y2('18')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('6'),
					$elm$svg$Svg$Attributes$y1('6'),
					$elm$svg$Svg$Attributes$x2('18'),
					$elm$svg$Svg$Attributes$y2('18')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Home$viewCPopup = F2(
	function (title, cont) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('popup', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Utility$buttonAsLink,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('close'),
									$elm$html$Html$Events$onClick($author$project$Pages$Home$ClosePopup),
									$author$project$Utility$onEsc($author$project$Pages$Home$ClosePopup)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('closing-x')
										]),
									_List_fromArray(
										[$author$project$Views$Icons$x]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('popup-instructions')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Click on the text area below to select.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('copyText'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('popup-content', true)
										])),
									$elm$html$Html$Attributes$autofocus(true)
								]),
							$author$project$Pages$Home$textWithBreaks(cont))
						]))
				]));
	});
var $author$project$Pages$Home$viewCollectionPopup = F3(
	function (title, cont, instr) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('overlay')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('popup', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Utility$buttonAsLink,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('close'),
									$elm$html$Html$Events$onClick($author$project$Pages$Home$ClosePopup),
									$author$project$Utility$onEsc($author$project$Pages$Home$ClosePopup)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('closing-x')
										]),
									_List_fromArray(
										[$author$project$Views$Icons$x]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('popup-instructions')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Click on the text area below to select everything. ' + instr)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('copyText'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('popup-content', true)
										])),
									$elm$html$Html$Attributes$autofocus(true)
								]),
							$elm$core$List$concat(
								A2($elm$core$List$map, $author$project$Pages$Home$textWithBreaks, cont)))
						]))
				]));
	});
var $author$project$Data$Citation$getLiteralCitation = function (citn) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Data$Citation$internalString(citn));
};
var $author$project$Pages$Home$viewDIPopup = function (mdoc) {
	var dToS = function (mdt) {
		if (mdt.$ === 1) {
			return 'Unknown';
		} else {
			var dt = mdt.a;
			return dt;
		}
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('popup', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(mdoc.gD)
							])),
						A2(
						$author$project$Utility$buttonAsLink,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('close'),
								$elm$html$Html$Events$onClick($author$project$Pages$Home$ClosePopup),
								$author$project$Utility$onEsc($author$project$Pages$Home$ClosePopup)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('closing-x')
									]),
								_List_fromArray(
									[$author$project$Views$Icons$x]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('DocInfo', true)
									])),
								$elm$html$Html$Attributes$autofocus(true)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Pages$Home$mdOptions, _List_Nil, mdoc.b1)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Pages$Home$mdOptions, _List_Nil, mdoc.e9)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Source: '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(mdoc.c9)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Data$Citation$getLiteralCitation(mdoc.bk))
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Date Published: ' + dToS(mdoc.dz))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Source last checked: ' + dToS(mdoc.fx))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('RTR xml version: ' + mdoc.gK)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Pages$Home$mdOptions, _List_Nil, mdoc.fh)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Home$viewDialog = function (model) {
	var _v0 = model.af;
	switch (_v0.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			var title = _v0.a;
			var cont = _v0.b;
			return A2($author$project$Pages$Home$viewCPopup, title, cont);
		case 2:
			var doc = _v0.a;
			return $author$project$Pages$Home$viewDIPopup(doc);
		default:
			var title = _v0.a;
			var cont = _v0.b;
			var note = _v0.c;
			return A3($author$project$Pages$Home$viewCollectionPopup, title, cont, note);
	}
};
var $author$project$Pages$Home$viewErrors = function (session) {
	var _v0 = session.bq;
	if (!_v0.b) {
		return $elm$html$Html$text('');
	} else {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href($author$project$Route$Test)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('There were errors initializing...')
				]));
	}
};
var $author$project$Pages$Home$PreSearch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Home$Search = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Utility$onTab = function (msg) {
	return A2($author$project$Utility$onKeyCode, 9, msg);
};
var $author$project$Pages$Home$searchGlass = function (action) {
	return A2(
		$author$project$Utility$buttonAsLink,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('search-glass', true),
						_Utils_Tuple2('pure-u-2-24', false)
					])),
				action,
				$elm$html$Html$Attributes$title('Search')
			]),
		_List_fromArray(
			[$author$project$Views$Icons$search]));
};
var $author$project$Pages$Home$searchGlassAction = $elm$html$Html$Events$onClick(
	$author$project$Pages$Home$Search(''));
var $author$project$Pages$Home$searchX = A2(
	$author$project$Utility$buttonAsLink,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('search-x', true),
					_Utils_Tuple2('pure-u-2-24', false)
				])),
			$elm$html$Html$Events$onClick(
			$author$project$Pages$Home$Search('')),
			$elm$html$Html$Attributes$title('Reset search')
		]),
	_List_fromArray(
		[$author$project$Views$Icons$x]));
var $author$project$Utility$onEnter = function (msg) {
	return A2($author$project$Utility$onKeyCode, 13, msg);
};
var $author$project$Pages$Home$keywordItem = function (word) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$Pages$Home$Search(word)),
						$author$project$Utility$onEnter(
						$author$project$Pages$Home$Search(word)),
						$elm$html$Html$Attributes$title('Click to search for this keyword'),
						$elm$html$Html$Attributes$href('#')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(word)
					]))
			]));
};
var $author$project$Pages$Home$viewSearchDropdown = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('search-ac', true)
					])),
				$elm$html$Html$Attributes$title('Click to search by keyword')
			]),
		A2($elm$core$List$map, $author$project$Pages$Home$keywordItem, model.aM));
};
var $author$project$Pages$Home$viewSearchBar = function (model) {
	var somethingToSearch = !_Utils_eq(model.dH, _List_Nil);
	var getNextKeyword = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(model.aM));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('search'),
				$elm$html$Html$Attributes$title('Search the selected documents')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('search-form', true)
							])),
						$elm$html$Html$Events$onSubmit(
						$author$project$Pages$Home$Search(model.aT))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('search-container', true),
										_Utils_Tuple2('hoverbackground', !somethingToSearch)
									]))
							]),
						_List_fromArray(
							[
								$author$project$Pages$Home$searchGlass($author$project$Pages$Home$searchGlassAction),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('search'),
										$elm$html$Html$Attributes$id('mainSearchBar'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('search-bar', true),
												_Utils_Tuple2('pure-input-1-2', false)
											])),
										$elm$html$Html$Attributes$value(model.aT),
										somethingToSearch ? $elm$html$Html$Attributes$placeholder('Enter Search Term') : $elm$html$Html$Attributes$placeholder('Select a document to begin'),
										$elm$html$Html$Events$onInput($author$project$Pages$Home$PreSearch),
										$author$project$Utility$onTab(
										$author$project$Pages$Home$PreSearch(getNextKeyword)),
										$elm$html$Html$Attributes$autocomplete(false),
										$elm$html$Html$Attributes$disabled(!somethingToSearch)
									]),
								_List_Nil),
								$author$project$Pages$Home$searchX
							]))
					])),
				$author$project$Pages$Home$viewSearchDropdown(model)
			]));
};
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $author$project$Views$Icons$star = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'star',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2')
				]),
			_List_Nil)
		]));
var $author$project$Views$ProBadge$proBadgeSubscribe = function (additionalText) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href($author$project$Requests$pricingPage)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('pro-badge', true)
							])),
						$elm$html$Html$Attributes$title('Subscribe to Pro')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icons$star,
						$elm$html$Html$text('Pro!' + (' ' + additionalText))
					]))
			]));
};
var $author$project$Pages$Home$viewSearchTip = function (session) {
	var _v0 = $author$project$Data$User$getSubLevel(session.d$);
	if (_v0 === 1) {
		return $elm$html$Html$text('');
	} else {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-pro-message')
				]),
			_List_fromArray(
				[
					$author$project$Views$ProBadge$proBadgeSubscribe('Search across multiple documents!'),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('right-pro-star')
						]),
					_List_fromArray(
						[$author$project$Views$Icons$star]))
				]));
	}
};
var $author$project$Pages$Home$viewWelcomeBack = F3(
	function (session, model, loading) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content-container')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Pages$Home$viewSearchBar(model),
				_Utils_ap(
					loading ? _List_fromArray(
						[$author$project$Views$Spinner$loadingMessageBig]) : A2(
						$elm$core$List$map,
						function (x) {
							return A2(
								$elm$html$Html$article,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('content')
									]),
								_List_fromArray(
									[
										A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Pages$Home$mdOptions, _List_Nil, x)
									]));
						},
						_List_fromArray(
							[$author$project$Pages$About$instructions])),
					_List_fromArray(
						[
							$author$project$Pages$Home$viewErrors(session)
						]))));
	});
var $author$project$Pages$Home$viewLoggedIn = F3(
	function (session, model, loading) {
		return _Utils_eq(model.dH, _List_Nil) ? A3($author$project$Pages$Home$viewWelcomeBack, session, model, loading) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content-container')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$Lazy$lazy, $author$project$Pages$Home$viewDialog, model),
					A2($elm$html$Html$Lazy$lazy, $author$project$Pages$Home$viewSearchBar, model),
					A2($elm$html$Html$Lazy$lazy, $author$project$Pages$Home$viewSearchTip, session),
					A3($elm$html$Html$Lazy$lazy2, $author$project$Pages$Home$viewContent, session, model),
					A2($elm$html$Html$Lazy$lazy, $author$project$Pages$Home$viewErrors, session)
				]));
	});
var $author$project$Pages$Home$NavigateExt = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Home$NavigateIn = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Home$viewPleaseLogIn = function (session) {
	var viewSignUp = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('*Please log in or sign up to continue.*')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pure_frontpage'),
						$elm$html$Html$Events$onClick(
						$author$project$Pages$Home$NavigateIn($author$project$Route$Login))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Log In')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pure_frontpage'),
						$elm$html$Html$Events$onClick(
						$author$project$Pages$Home$NavigateExt($author$project$Requests$registerWithAPI))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Sign Up for a Free Account')
					]))
			]));
	return A2(
		$elm$html$Html$article,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content-container')
			]),
		A2(
			$elm$core$List$cons,
			viewSignUp,
			_List_fromArray(
				[
					$author$project$Pages$Home$viewErrors(session)
				])));
};
var $author$project$Pages$Home$view = F3(
	function (session, model, loading) {
		var _v0 = session.d$;
		switch (_v0.$) {
			case 0:
				return A2($elm$html$Html$Lazy$lazy, $author$project$Pages$Home$viewPleaseLogIn, session);
			case 1:
				var user = _v0.a;
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewWelcomeBack, session, model, loading);
			default:
				return A4($elm$html$Html$Lazy$lazy3, $author$project$Pages$Home$viewLoggedIn, session, model, loading);
		}
	});
var $author$project$Pages$NotFound$backArrow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('backarrow')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-glass'),
					$author$project$Route$href($author$project$Route$Home),
					$elm$html$Html$Attributes$title('Back to Home')
				]),
			_List_fromArray(
				[$author$project$Views$Icons$chevronsLeft]))
		]));
var $author$project$Pages$NotFound$view = function (session) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				$author$project$Pages$NotFound$backArrow,
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('notfound')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Not Found')
					])),
				A2(
				$elm$html$Html$article,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Either could not find that page, or you don\'t have access to that document. Please try again.')
					]))
			]));
};
var $author$project$Pages$Profile$SaveDocs = {$: 4};
var $author$project$Pages$Profile$SelectAllOfType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Profile$regTypeButton = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('pill-button')
	]);
var $author$project$Pages$Profile$chooseByJurisdiction = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('selection-buttons')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$title('Select all available documents'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Pages$Profile$SelectAllOfType('All')),
					$author$project$Pages$Profile$regTypeButton)),
			_List_fromArray(
				[
					$elm$html$Html$text('All')
				])),
			A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$title('Select all available OECD documents'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Pages$Profile$SelectAllOfType('OECD')),
					$author$project$Pages$Profile$regTypeButton)),
			_List_fromArray(
				[
					$elm$html$Html$text('OECD')
				])),
			A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$title('Select all available FDA documents'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Pages$Profile$SelectAllOfType('FDA')),
					$author$project$Pages$Profile$regTypeButton)),
			_List_fromArray(
				[
					$elm$html$Html$text('FDA')
				])),
			A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$title('Select all available EPA documents'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Pages$Profile$SelectAllOfType('EPA')),
					$author$project$Pages$Profile$regTypeButton)),
			_List_fromArray(
				[
					$elm$html$Html$text('EPA')
				])),
			A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$title('Clear all selections'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Pages$Profile$SelectAllOfType('None')),
					$author$project$Pages$Profile$regTypeButton)),
			_List_fromArray(
				[
					$elm$html$Html$text('None')
				]))
		]));
var $author$project$Views$ProBadge$alreadyProBadge = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('pro-badge', true)
				])),
			$elm$html$Html$Attributes$title('Included with your Pro Subscription')
		]),
	_List_fromArray(
		[
			$author$project$Views$Icons$star,
			$elm$html$Html$text('Pro')
		]));
var $author$project$Pages$Profile$DocCheckChanged = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Pages$Profile$checkbox = F4(
	function (isChecked, isDisabled, action, lbl) {
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('menu-checkbox', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(isChecked),
									$elm$html$Html$Attributes$disabled(isDisabled),
									$elm$html$Html$Events$onCheck(action)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' ' + lbl)
								]))
						]))
				]));
	});
var $author$project$Pages$Profile$listDocuments = function (doc) {
	switch (doc.$) {
		case 2:
			var status = doc.a;
			switch (status.$) {
				case 0:
					var id = status.a;
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' Error: Failed to load information ' + id)
							]));
				case 1:
					var id = status.a;
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' Loading information for ' + (id + '...'))
							]));
				default:
					var id = status.a;
					var di = status.b;
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' ' + di.gD)
							]));
			}
		case 1:
			var status = doc.a;
			switch (status.$) {
				case 0:
					var id = status.a;
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' Error: Failed to load information ' + id)
							]));
				case 1:
					var id = status.a;
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' Loading information for ' + (id + '...'))
							]));
				default:
					var name = status.a;
					var di = status.b;
					return A4(
						$author$project$Pages$Profile$checkbox,
						false,
						false,
						$author$project$Pages$Profile$DocCheckChanged(di),
						di.gD);
			}
		default:
			var docinfo = doc.a;
			var status = doc.b;
			switch (status.$) {
				case 0:
					var id = status.a;
					return A4(
						$author$project$Pages$Profile$checkbox,
						false,
						false,
						$author$project$Pages$Profile$DocCheckChanged(docinfo),
						' Error: Failed to load document ' + docinfo.gD);
				case 1:
					var id = status.a;
					return A4(
						$author$project$Pages$Profile$checkbox,
						true,
						false,
						$author$project$Pages$Profile$DocCheckChanged(docinfo),
						docinfo.gD + ' (Loading...)');
				default:
					var id = status.a;
					var dc = status.b;
					return A4(
						$author$project$Pages$Profile$checkbox,
						true,
						false,
						$author$project$Pages$Profile$DocCheckChanged(docinfo),
						docinfo.gD + ' (Loaded)');
			}
	}
};
var $author$project$Data$APITypes$subLevelToString = function (sublevel) {
	if (!sublevel) {
		return 'Basic';
	} else {
		return 'Pro';
	}
};
var $author$project$Pages$Profile$showSubscription = F2(
	function (userlevel, sub) {
		var toPara = function (x) {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[x]));
		};
		var docs = A2($elm$core$List$map, $author$project$Pages$Profile$listDocuments, sub.T);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('DocContent')
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					toPara,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('DocTitle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sub.aX.fE),
									function () {
									if (sub.aX.fy === 1) {
										if (!userlevel) {
											return $author$project$Views$ProBadge$proBadgeSubscribe('');
										} else {
											return $author$project$Views$ProBadge$alreadyProBadge;
										}
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Description: ')
										])),
									$elm$html$Html$text(sub.aX.cM)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Available for: ')
										])),
									$elm$html$Html$text(
									$author$project$Data$APITypes$subLevelToString(sub.aX.fy) + ' subscriptions.')
								])),
							_Utils_eq(docs, _List_Nil) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$em,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Includes: ')
								]))
						])),
				_List_fromArray(
					[
						A2($elm$html$Html$ul, _List_Nil, docs)
					])));
	});
var $author$project$Pages$Profile$view = function (model) {
	var userView = function (user) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (x) {
					return A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[x]));
				},
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('User ID: ')
									])),
								$elm$html$Html$text(user.a1)
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Current Subscription Level: ')
									])),
								$elm$html$Html$text(
								$author$project$Data$APITypes$subLevelToString(user.dS)),
								function () {
								var _v3 = user.dS;
								if (!_v3) {
									return $author$project$Views$ProBadge$proBadgeSubscribe('access more documents and features');
								} else {
									return $elm$html$Html$text('');
								}
							}()
							]))
					])));
	};
	var upgradeButton = function () {
		var _v2 = model.d$;
		switch (_v2.$) {
			case 2:
				var user = _v2.a;
				return (!user.dS) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href($author$project$Requests$pricingPage)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('go-pro')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Learn More About Pro Subscriptions')
								]))
						])) : $elm$html$Html$text('');
			case 1:
				var user = _v2.a;
				return (!user.dS) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href($author$project$Requests$pricingPage)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('go-pro')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Learn More About Pro Subscriptions')
								]))
						])) : $elm$html$Html$text('');
			default:
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href($author$project$Route$Login)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Login or Register')
								]))
						]));
		}
	}();
	var subs = function (usr) {
		return A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(x)
						]));
			},
			usr.dV);
	};
	var saveButton = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$Route$href($author$project$Route$Home),
				$elm$html$Html$Attributes$class('button-half-screen')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Pages$Profile$SaveDocs)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save this selection for next time')
					]))
			]));
	var backArrow = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('backarrow')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-glass'),
						$author$project$Route$href($author$project$Route$Home),
						$elm$html$Html$Attributes$title('Back to Search')
					]),
				_List_fromArray(
					[$author$project$Views$Icons$chevronsLeft]))
			]));
	var avail = function (user) {
		var _v1 = model.w;
		switch (_v1.$) {
			case 2:
				var id = _v1.a;
				var s = _v1.b;
				return A2(
					$elm$core$List$map,
					A2($elm$html$Html$Lazy$lazy2, $author$project$Pages$Profile$showSubscription, user.dS),
					s);
			case 0:
				var id = _v1.a;
				return _List_fromArray(
					[
						$elm$html$Html$text('Could not load subscription ' + id)
					]);
			default:
				var id = _v1.a;
				return _List_fromArray(
					[
						$elm$html$Html$text('Loading...')
					]);
		}
	};
	var _v0 = model.d$;
	if (_v0.$ === 2) {
		var user = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('content', true)
						]))
				]),
			_List_fromArray(
				[
					backArrow,
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('DocTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Available Documents and Subscriptions')
						])),
					userView(user),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('DocTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Document Categories')
						])),
					$elm$html$Html$text('Select available documents: '),
					$author$project$Pages$Profile$chooseByJurisdiction,
					saveButton,
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Or pick and choose below: ')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('DocContent')
						]),
					avail(user)),
					saveButton
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('main'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('content', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('DocTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Available Documents and Subscriptions')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Not Logged In')
						])),
					upgradeButton
				]));
	}
};
var $author$project$Pages$Settings$ColumnViewChecked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Settings$IgnoreCWChecked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Settings$IgnoreCaseChecked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Settings$SaveSettings = {$: 7};
var $author$project$Pages$Settings$SummarizeChecked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Settings$UseSynonymsChecked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Settings$alertBox = function (msg) {
	return (msg === '') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('alert')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(msg)
			]));
};
var $author$project$Pages$Settings$checkbox = F3(
	function (attr, children, lbl) {
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('menu-checkbox', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox')
									]),
								attr),
							children),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' ' + lbl)
								]))
						]))
				]));
	});
var $author$project$Pages$Settings$SearchTermChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utility$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $author$project$Utility$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'change',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Utility$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $author$project$Pages$Settings$searchTermSettingsFromLabel = function (s) {
	switch (s) {
		case 'Search for the Exact, Whole Phrase':
			return 0;
		case 'Search for All Words (in any order)':
			return 1;
		case 'Search for Any of the Words':
			return 2;
		case 'Only Search Keywords':
			return 3;
		default:
			return 2;
	}
};
var $author$project$Pages$Settings$searchTermSettingsToLabel = function (s) {
	switch (s) {
		case 0:
			return $elm$html$Html$text(' Search for the Exact, Whole Phrase');
		case 1:
			return $elm$html$Html$text(' Search for All Words (in any order)');
		case 2:
			return $elm$html$Html$text(' Search for Any of the Words');
		default:
			return $elm$html$Html$text(' Only Search Keywords');
	}
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Pages$Settings$selectSearchTermS = function (current) {
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				$author$project$Utility$onChange(
				function (x) {
					return $author$project$Pages$Settings$SearchTermChanged(
						$author$project$Pages$Settings$searchTermSettingsFromLabel(x));
				})
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(!current)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Settings$searchTermSettingsToLabel(0)
					])),
				A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(current === 1)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Settings$searchTermSettingsToLabel(1)
					])),
				A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(current === 2)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Settings$searchTermSettingsToLabel(2)
					])),
				A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(current === 3)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Settings$searchTermSettingsToLabel(3)
					]))
			]));
};
var $author$project$Pages$Settings$SortByChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Settings$sortByFromLabel = function (t) {
	switch (t) {
		case 'Sort by Total Score (Relevance)':
			return 0;
		case 'Sort by the Order they Occur in the Document':
			return 1;
		default:
			return 1;
	}
};
var $author$project$Pages$Settings$sortByToLabel = function (t) {
	if (!t) {
		return $elm$html$Html$text(' Sort by Total Score (Relevance)');
	} else {
		return $elm$html$Html$text(' Sort by the Order they Occur in the Document');
	}
};
var $author$project$Pages$Settings$selectSortBy = function (current) {
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				$author$project$Utility$onChange(
				function (x) {
					return $author$project$Pages$Settings$SortByChanged(
						$author$project$Pages$Settings$sortByFromLabel(x));
				})
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(!current)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Settings$sortByToLabel(0)
					])),
				A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(current === 1)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Settings$sortByToLabel(1)
					]))
			]));
};
var $author$project$Pages$Settings$viewSettings = F2(
	function (model, user) {
		var isPro = user.dS === 1;
		var backArrow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('backarrow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-glass'),
							$author$project$Route$href($author$project$Route$Home),
							$elm$html$Html$Attributes$title('Back to Search')
						]),
					_List_fromArray(
						[$author$project$Views$Icons$chevronsLeft]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			_List_fromArray(
				[
					backArrow,
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('search_settings')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Search Settings ')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('How should the search term be treated?: '),
									$author$project$Pages$Settings$selectSearchTermS(model.X.dN.cf)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('How should the results be sorted?: '),
									$author$project$Pages$Settings$selectSortBy(model.X.dN.ck)
								])),
							A3(
							$author$project$Pages$Settings$checkbox,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$checked(model.X.dN.b$),
									$elm$html$Html$Events$onCheck($author$project$Pages$Settings$IgnoreCaseChecked)
								]),
							_List_Nil,
							' Ignore case. \'Figment\' will also return \'figment\' and \'FiGmEnT\'.'),
							A3(
							$author$project$Pages$Settings$checkbox,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$checked(model.X.dN.b0),
									$elm$html$Html$Attributes$disabled(!((model.X.dN.cf === 1) || (model.X.dN.cf === 2))),
									$elm$html$Html$Events$onCheck($author$project$Pages$Settings$IgnoreCWChecked)
								]),
							_List_Nil,
							' Ignore common words like \'is\', \'the\', \'and\', \'it\'. Only valid for Any Words and All Words searches.'),
							A3(
							$author$project$Pages$Settings$checkbox,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$checked(model.X.dN.cr),
									$elm$html$Html$Attributes$disabled(!((!model.X.dN.cf) || (model.X.dN.cf === 3))),
									$elm$html$Html$Events$onCheck($author$project$Pages$Settings$UseSynonymsChecked)
								]),
							_List_Nil,
							' Use synonyms. Searching for \'Study Plan\' will also return results for \'Study Protocol\' (Note: Valid when for Whole Phrase and Keyword search. Recommend use with case insensitive.)')
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('layout_settings')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Layout Settings '),
							isPro ? $elm$html$Html$text('') : $author$project$Views$ProBadge$proBadgeSubscribe('level feature')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('settings-form'),
							$elm$html$Html$Attributes$disabled(!isPro)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Pages$Settings$checkbox,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$checked(model.X.d2.cm),
									$elm$html$Html$Events$onCheck($author$project$Pages$Settings$SummarizeChecked),
									$elm$html$Html$Attributes$disabled(!isPro)
								]),
							_List_Nil,
							' Summarize search results.'),
							A3(
							$author$project$Pages$Settings$checkbox,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$checked(model.X.d2.bT),
									$elm$html$Html$Events$onCheck($author$project$Pages$Settings$ColumnViewChecked),
									$elm$html$Html$Attributes$disabled(!isPro)
								]),
							_List_Nil,
							' Column view for two or more documents. Recommended for larger screens only.')
						])),
					$author$project$Pages$Settings$alertBox(model.Q),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Pages$Settings$SaveSettings)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save Settings')
								]))
						]))
				]));
	});
var $author$project$Pages$Settings$view = F2(
	function (model, userState) {
		switch (userState.$) {
			case 2:
				var user = userState.a;
				return A3($elm$html$Html$Lazy$lazy2, $author$project$Pages$Settings$viewSettings, model, user);
			case 1:
				var user = userState.a;
				return A3($elm$html$Html$Lazy$lazy2, $author$project$Pages$Settings$viewSettings, model, user);
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Search Settings ')
								])),
							$elm$html$Html$text('Log in to change search settings')
						]));
		}
	});
var $author$project$Data$User$showSummary = function (state) {
	var print = function (user) {
		return '<' + (user.a1 + '>');
	};
	switch (state.$) {
		case 0:
			return 'No user logged in';
		case 1:
			var user = state.a;
			return 'Loading... ' + print(user);
		default:
			var user = state.a;
			return print(user);
	}
};
var $author$project$Views$Test$displayCurrentUser = function (session) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Current User: ')
					])),
				$elm$html$Html$text(
				$author$project$Data$User$showSummary(session.d$))
			]));
};
var $author$project$Data$Errors$errToString = function (err) {
	switch (err.$) {
		case 0:
			var s = err.a;
			return 'Internal Error: ' + s;
		case 1:
			var m = err.a;
			var s = err.b;
			return 'Parse Error: ' + (m + (' -- ' + s));
		default:
			var m = err.a;
			var s = err.b;
			return 'API Error: ' + (m + (' -- ' + function () {
				switch (s.$) {
					case 0:
						var d = s.a;
						return 'Please Try Again: ' + d;
					case 2:
						var d = s.a;
						return 'Session Expired: ' + d;
					case 1:
						var d = s.a;
						return 'Please Log In: ' + d;
					case 3:
						var d = s.a;
						return 'Invalid Request' + d;
					default:
						var h = s.a;
						return 'Other Http Error: ' + $author$project$Data$Errors$httpErrToString(h);
				}
			}()));
	}
};
var $author$project$Views$Test$displayErrorMessages = function (session) {
	var displayErr = function (err) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Data$Errors$errToString(err))
				]));
	};
	var errMsgs = _Utils_eq(session.bq, _List_Nil) ? _List_fromArray(
		[
			$elm$html$Html$text('No API errors detected')
		]) : A2($elm$core$List$map, displayErr, session.bq);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Error Messages: ')
					])),
			errMsgs));
};
var $author$project$Views$Test$displayLoadedDocs = function (session) {
	var docs = _Utils_eq(session.b4, _List_Nil) ? _List_fromArray(
		[
			$elm$html$Html$text('No docs loaded')
		]) : A2(
		$elm$core$List$map,
		function (x) {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						function ($) {
							return $.gD;
						}(x))
					]));
		},
		session.b4);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Loaded Documents: ' + $elm$core$String$fromInt(
								$elm$core$List$length(session.b4)))
						]))
				]),
			docs));
};
var $author$project$Views$Test$sessionView = function (session) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				$author$project$Views$Test$displayCurrentUser(session),
				$author$project$Views$Test$displayErrorMessages(session),
				$author$project$Views$Test$displayLoadedDocs(session)
			]));
};
var $author$project$Views$Test$Fail = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Views$Test$Pass = function (a) {
	return {$: 0, a: a};
};
var $elm_community$result_extra$Result$Extra$isErr = function (x) {
	if (!x.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Views$Test$testNoCitationErrors = function (doc) {
	var title = 'Testing Citation Errors in ' + $author$project$Data$DocID$toString(doc.R);
	var getC = function (outline) {
		var x = outline;
		var year = $author$project$Data$Outline$getYear(doc.dz);
		var citn = function ($) {
			return $.bk;
		}(x);
		return A5($author$project$Data$Citation$readCitation, citn, doc.gD, year, doc.c9, 2);
	};
	var resultList = A2($author$project$Data$Outline$mapOutlineList, getC, doc.a9);
	var getErrs = A2($elm$core$List$filter, $elm_community$result_extra$Result$Extra$isErr, resultList);
	var printErrs = A2(
		$elm$core$List$map,
		function (r) {
			if (r.$ === 1) {
				var s = r.a;
				return s;
			} else {
				return '';
			}
		},
		getErrs);
	return (!$elm$core$List$length(getErrs)) ? $author$project$Views$Test$Pass(title) : A2(
		$author$project$Views$Test$Fail,
		title,
		'There were failures creating citations: \n\n- ' + A2($elm$core$String$join, '\n\n- ', printErrs));
};
var $author$project$Utility$dups = function (ys) {
	dups:
	while (true) {
		if (!ys.b) {
			return _List_Nil;
		} else {
			var x = ys.a;
			var xs = ys.b;
			if (A2($elm$core$List$member, x, xs)) {
				return A2(
					$elm$core$List$cons,
					x,
					$author$project$Utility$dups(xs));
			} else {
				var $temp$ys = xs;
				ys = $temp$ys;
				continue dups;
			}
		}
	}
};
var $author$project$Views$Test$testNoConflictingIDs = function (doc) {
	var title = 'Testing ID duplication in ' + $author$project$Data$DocID$toString(doc.R);
	var ol = doc.a9;
	var idList = A2(
		$author$project$Data$Outline$mapOutlineList,
		function (x) {
			return $author$project$Data$Outline$getEntry(x).R;
		},
		ol);
	var strList = A2($elm$core$List$map, $author$project$Data$ID$toString, idList);
	var duplicates = $author$project$Utility$dups(strList);
	return _Utils_eq(duplicates, _List_Nil) ? $author$project$Views$Test$Pass(title) : A2(
		$author$project$Views$Test$Fail,
		title,
		'The following IDs were duplicates: ' + A2($elm$core$String$join, ', ', duplicates));
};
var $author$project$Views$Test$mdOptions = {
	eV: $elm$core$Maybe$Nothing,
	fc: $elm$core$Maybe$Just(
		{eC: true, gn: false}),
	f0: true,
	gb: false
};
var $author$project$Views$Test$viewTest = function (result) {
	switch (result.$) {
		case 0:
			var title = result.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('passtest')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Pass: '),
								$elm$html$Html$text(title)
							]))
					]));
		case 1:
			var title = result.a;
			var msg = result.b;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('failtest')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Fail: '),
								$elm$html$Html$text(title)
							])),
						A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Views$Test$mdOptions, _List_Nil, msg)
					]));
		default:
			var title = result.a;
			var msg = result.b;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notruntest')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Not Run: '),
								$elm$html$Html$text(title)
							])),
						A3($elm_explorations$markdown$Markdown$toHtmlWith, $author$project$Views$Test$mdOptions, _List_Nil, msg)
					]));
	}
};
var $author$project$Views$Test$testsView = function (session) {
	var tests = _Utils_eq(session.b4, _List_Nil) ? _List_fromArray(
		[
			$elm$html$Html$text('No tests conducted')
		]) : A2(
		$elm$core$List$map,
		$author$project$Views$Test$viewTest,
		_Utils_ap(
			A2($elm$core$List$map, $author$project$Views$Test$testNoConflictingIDs, session.b4),
			A2($elm$core$List$map, $author$project$Views$Test$testNoCitationErrors, session.b4)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Tests:')
						]))
				]),
			tests));
};
var $author$project$Views$Test$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tests')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Testing all loaded documents:')
							]))
					])),
				$author$project$Views$Test$sessionView(model),
				$author$project$Views$Test$testsView(model)
			]));
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Views$Icons$briefcase = A2(
	$author$project$Views$Icons$svgFeatherIcon,
	'briefcase',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('2'),
					$elm$svg$Svg$Attributes$y('7'),
					$elm$svg$Svg$Attributes$width('20'),
					$elm$svg$Svg$Attributes$height('14'),
					$elm$svg$Svg$Attributes$rx('2'),
					$elm$svg$Svg$Attributes$ry('2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Home$iconOverlay = F2(
	function (overlayText, icon) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon-overlay-container')
				]),
			_List_fromArray(
				[
					icon,
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-overlay-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(overlayText)
						]))
				]));
	});
var $author$project$Pages$Home$topMenuHomeItem = F4(
	function (icon, titlemsg, classname, action) {
		return A2(
			$author$project$Utility$buttonAsLink,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('top-menu-link', false),
							_Utils_Tuple2('pure-menu-link', true),
							_Utils_Tuple2(classname, true)
						])),
					action,
					$elm$html$Html$Attributes$title(titlemsg)
				]),
			_List_fromArray(
				[icon]));
	});
var $author$project$Pages$Home$topMenuCollectEntries = F2(
	function (count, action) {
		return A4(
			$author$project$Pages$Home$topMenuHomeItem,
			A2(
				$author$project$Pages$Home$iconOverlay,
				$elm$core$String$fromInt(count),
				$author$project$Views$Icons$briefcase),
			'View collected entries',
			'briefcase',
			action);
	});
var $author$project$Pages$Home$viewCollectedEntries = F2(
	function (collection, msg) {
		return $elm$core$Set$isEmpty(collection) ? $elm$html$Html$text('') : A2(
			$author$project$Pages$Home$topMenuCollectEntries,
			$elm$core$Set$size(collection),
			$elm$html$Html$Events$onClick(msg));
	});
var $author$project$Main$viewPage = F3(
	function (model, isLoading, page) {
		var session = model.g;
		var noMenu = {db: _List_Nil, dc: ''};
		var homeContextMenu = function (collection) {
			return {
				db: _List_fromArray(
					[
						A2(
						$author$project$Pages$Home$viewCollectedEntries,
						collection,
						$author$project$Msg$HomeMsg($author$project$Pages$Home$ViewCollection))
					]),
				dc: 'Document specific menu items'
			};
		};
		var frame = F3(
			function (pg, searchResults, cont) {
				return A5($author$project$Views$Page$frame, isLoading, session, pg, cont, searchResults);
			});
		switch (page.$) {
			case 1:
				return A4(
					frame,
					0,
					_List_Nil,
					noMenu,
					$author$project$Pages$NotFound$view(session));
			case 0:
				return A4(frame, 0, _List_Nil, noMenu, $author$project$Views$Spinner$loadingMessageBig);
			case 2:
				var subModel = page.a;
				return A4(
					frame,
					2,
					subModel.dH,
					homeContextMenu(subModel.eM),
					A2(
						$elm$html$Html$map,
						$author$project$Msg$HomeMsg,
						A3($author$project$Pages$Home$view, session, subModel, isLoading)));
			case 5:
				return A4(frame, 1, _List_Nil, noMenu, $author$project$Pages$About$view);
			case 3:
				var subModel = page.a;
				return A4(
					frame,
					4,
					_List_Nil,
					noMenu,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProfileMsg,
						$author$project$Pages$Profile$view(subModel)));
			case 4:
				var subModel = page.a;
				return A4(
					frame,
					0,
					_List_Nil,
					noMenu,
					$author$project$Views$Test$view(subModel));
			case 7:
				var subModel = page.a;
				return A4(
					frame,
					5,
					_List_Nil,
					noMenu,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$SettingsMsg,
						A2($author$project$Pages$Settings$view, subModel, session.d$)));
			default:
				return A4(
					frame,
					3,
					_List_Nil,
					noMenu,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$LoginMsg,
						$author$project$Pages$Authentication$view(model.O)));
		}
	});
var $author$project$Main$view = function (model) {
	return A2(
		$elm$browser$Browser$Document,
		'Read the Regs - GLP Edition - HaiQu Software',
		_List_fromArray(
			[
				function () {
				var _v0 = model.p;
				if (!_v0.$) {
					var page = _v0.a;
					return A3($author$project$Main$viewPage, model, false, page);
				} else {
					var page = _v0.a;
					return A3($author$project$Main$viewPage, model, true, page);
				}
			}()
			]));
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{fm: $author$project$Main$init, fR: $author$project$Msg$UrlChanged, fS: $author$project$Msg$LinkClicked, dV: $author$project$Main$subscriptions, gI: $author$project$Main$update, gL: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$json$Json$Decode$andThen,
					function (settings) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (docList) {
								return A2(
									$elm$json$Json$Decode$andThen,
									function (authData) {
										return $elm$json$Json$Decode$succeed(
											{bP: authData, au: docList, X: settings});
									},
									A2(
										$elm$json$Json$Decode$field,
										'authData',
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
												]))));
							},
							A2(
								$elm$json$Json$Decode$field,
								'docList',
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
										]))));
					},
					A2(
						$elm$json$Json$Decode$field,
						'settings',
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
								])))))
			])))(0)}});}(this));